
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("8f72W", function(module, exports) {
$parcel$export(module.exports, "createDefaultPreset", () => $941572fc46cd3ad3$export$4efc99f259929bff);
// #region Imports

var $hU8M0 = parcelRequire("hU8M0");

var $9PC0M = parcelRequire("9PC0M");

var $ePLdG = parcelRequire("ePLdG");

var $2CoFm = parcelRequire("2CoFm");

var $3ndaT = parcelRequire("3ndaT");

var $pYSSV = parcelRequire("pYSSV");

var $9QiVY = parcelRequire("9QiVY");

var $3dfNp = parcelRequire("3dfNp");

var $fRUcc = parcelRequire("fRUcc");

var $kliKN = parcelRequire("kliKN");

var $io4ZI = parcelRequire("io4ZI");

var $gUNXe = parcelRequire("gUNXe");

var $1XFnB = parcelRequire("1XFnB");

var $bXida = parcelRequire("bXida");

var $c7D2T = parcelRequire("c7D2T");

var $a1ESh = parcelRequire("a1ESh");

var $jTQuH = parcelRequire("jTQuH");

var $lMapo = parcelRequire("lMapo");

var $3OwOt = parcelRequire("3OwOt");

var $21bLu = parcelRequire("21bLu");

var $ayDEm = parcelRequire("ayDEm");

var $zjMkD = parcelRequire("zjMkD");

var $aCXWX = parcelRequire("aCXWX");

var $58QGE = parcelRequire("58QGE");

var $glxMc = parcelRequire("glxMc");

var $4dpcQ = parcelRequire("4dpcQ");

var $iMKXn = parcelRequire("iMKXn");

var $2KvOl = parcelRequire("2KvOl");

var $j3xyv = parcelRequire("j3xyv");

var $4yyNU = parcelRequire("4yyNU");

var $143O4 = parcelRequire("143O4");

var $hiMOs = parcelRequire("hiMOs");

var $gayoi = parcelRequire("gayoi");

var $ae5yU = parcelRequire("ae5yU");

var $2pS9T = parcelRequire("2pS9T");

var $kNoxo = parcelRequire("kNoxo");

var $5oN7k = parcelRequire("5oN7k");
function $941572fc46cd3ad3$export$4efc99f259929bff(options) {
    var _options$toolbar, _options$featureFlags, _options$blockMenu, _options$blockMenu2, _options$blockMenu3, _options$blockMenu4, _options$blockMenu5;
    const isFullPage = (0, $5oN7k.isFullPage)(options.appearance);
    const preset = new (0, $hU8M0.EditorPresetBuilder)().add([
        (0, $a1ESh.featureFlagsPlugin),
        options.featureFlags || {}
    ]).maybeAdd([
        (0, $ePLdG.analyticsPlugin),
        {
            createAnalyticsEvent: options.createAnalyticsEvent,
            performanceTracking: options.performanceTracking
        }
    ], Boolean(options.allowAnalyticsGASV3)).add((0, $3ndaT.betterTypeHistoryPlugin)).add([
        (0, $zjMkD.pastePlugin),
        {
            ...options === null || options === void 0 ? void 0 : options.paste,
            isFullPage: isFullPage
        }
    ]).add((0, $fRUcc.default)).add((0, $lMapo.focusPlugin)).add([
        (0, $9PC0M.userPreferencesPlugin),
        {
            initialUserPreferences: {
                toolbarDockingPosition: isFullPage ? 'none' : 'top'
            }
        }
    ]).maybeAdd((0, $ayDEm.interactionPlugin), Boolean(options === null || options === void 0 ? void 0 : options.__livePage)).add((0, $io4ZI.compositionPlugin)).add([
        (0, $gUNXe.contextIdentifierPlugin),
        {
            contextIdentifierProvider: options.contextIdentifierProvider
        }
    ]).add([
        (0, $2CoFm.default),
        options.base
    ]).add((0, $bXida.decorationsPlugin)).add([
        (0, $143O4.typeAheadPlugin),
        options.typeAhead
    ]).maybeAdd((0, $3OwOt.default), Boolean(options.allowUndoRedoButtons)).add((0, $2pS9T.userIntentPlugin)).maybeAdd([
        (0, $4yyNU.toolbarPlugin),
        options.toolbar || {}
    ], Boolean((_options$toolbar = options.toolbar) === null || _options$toolbar === void 0 ? void 0 : _options$toolbar.enableNewToolbarExperience)).add([
        (0, $58QGE.primaryToolbarPlugin),
        {
            contextualFormattingEnabled: isFullPage
        }
    ]).add((0, $hiMOs.uiControlRegistryPlugin)).maybeAdd((0, $gayoi.undoRedoPlugin), Boolean(((_options$featureFlags = options.featureFlags) === null || _options$featureFlags === void 0 ? void 0 : _options$featureFlags.undoRedoButtons) ?? options.allowUndoRedoButtons)).maybeAdd([
        (0, $pYSSV.blockMenuPlugin),
        {
            useStandardNodeWidth: ((_options$blockMenu = options.blockMenu) === null || _options$blockMenu === void 0 ? void 0 : _options$blockMenu.useStandardNodeWidth) ?? false,
            blockLinkHashPrefix: (_options$blockMenu2 = options.blockMenu) === null || _options$blockMenu2 === void 0 ? void 0 : _options$blockMenu2.blockLinkHashPrefix,
            getLinkPath: (_options$blockMenu3 = options.blockMenu) === null || _options$blockMenu3 === void 0 ? void 0 : _options$blockMenu3.getLinkPath,
            enableCopyLinkToSelection: (_options$blockMenu4 = options.blockMenu) === null || _options$blockMenu4 === void 0 ? void 0 : _options$blockMenu4.enableCopyLinkToSelection
        }
    ], Boolean(((_options$blockMenu5 = options.blockMenu) === null || _options$blockMenu5 === void 0 ? void 0 : _options$blockMenu5.enabled) ?? false)).add([
        (0, $9QiVY.blockTypePlugin),
        {
            ...options.blockType,
            includeBlockQuoteAsTextstyleOption: isFullPage
        }
    ]).add((0, $3dfNp.clearMarksOnEmptyDocPlugin)).add([
        (0, $iMKXn.selectionToolbarPlugin),
        {
            preferenceToolbarAboveSelection: !!options.preferenceToolbarAboveSelection,
            contextualFormattingEnabled: isFullPage
        }
    ]).add([
        (0, $21bLu.hyperlinkPlugin),
        {
            ...options.hyperlinkOptions,
            // @ts-ignore Temporary solution to check for Live Page editor.
            __livePage: options.__livePage
        }
    ]).add([
        (0, $j3xyv.textFormattingPlugin),
        options.textFormatting
    ]).add((0, $kNoxo.widthPlugin)).add([
        (0, $glxMc.quickInsertPlugin),
        options.quickInsert
    ]).add([
        (0, $aCXWX.placeholderPlugin),
        options.placeholder
    ]).add((0, $ae5yU.unsupportedContentPlugin)).add([
        (0, $c7D2T.editorDisabledPlugin),
        {
            initialDisabledState: options.disabled
        }
    ]).add([
        (0, $2KvOl.submitEditorPlugin),
        options.submitEditor
    ]).add((0, $1XFnB.copyButtonPlugin)).add((0, $jTQuH.floatingToolbarPlugin)).add([
        (0, $4dpcQ.selectionPlugin),
        {
            ...options.selection,
            __livePage: options.__livePage
        }
    ]).add([
        (0, $kliKN.default),
        options.codeBlock
    ]);
    return preset;
}
function $941572fc46cd3ad3$export$a3add99b7c13b8f7(props) {
    const preset = $941572fc46cd3ad3$export$4efc99f259929bff(props);
    return [
        preset
    ];
}

});
parcelRegister("pYSSV", function(module, exports) {
$parcel$export(module.exports, "blockMenuPlugin", () => $ab0297448ba0862e$export$dfc601443ba8de15);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $3y2s4 = parcelRequire("3y2s4");

var $3zzvD = parcelRequire("3zzvD");

var $CdVEd = parcelRequire("CdVEd");

var $avMdA = parcelRequire("avMdA");

var $vvZ9M = parcelRequire("vvZ9M");

var $hj6cH = parcelRequire("hj6cH");

var $5hluS = parcelRequire("5hluS");

var $cFqsZ = parcelRequire("cFqsZ");

var $86Ecr = parcelRequire("86Ecr");

var $aCsiM = parcelRequire("aCsiM");

var $ahtLN = parcelRequire("ahtLN");

var $l4hdc = parcelRequire("l4hdc");

var $cm3rY = parcelRequire("cm3rY");

var $44b4M = parcelRequire("44b4M");
const $ab0297448ba0862e$export$dfc601443ba8de15 = ({ api: api, config: config })=>{
    const registry = (0, $CdVEd.createBlockMenuRegistry)();
    const transformSourceRegistry = (0, $vvZ9M.createBlockMenuTransformSourceRegistry)();
    registry.register((0, $l4hdc.getBlockMenuComponents)({
        api: api,
        config: config
    }));
    const refs = {};
    return {
        name: 'blockMenu',
        pmPlugins () {
            return [
                {
                    name: 'blockMenuPlugin',
                    plugin: ()=>(0, $aCsiM.createPlugin)(api)
                },
                {
                    name: 'blockMenuKeymap',
                    plugin: ()=>(0, $86Ecr.keymapPlugin)(api, config)
                },
                ...(0, $3zzvD.UNSAFE_expValNoExposure)('platform_editor_experience_tracking_observer', 'isEnabled', false) ? [
                    {
                        name: 'blockMenuExperiences',
                        plugin: ()=>(0, $cFqsZ.getBlockMenuExperiencesPlugin)({
                                refs: refs,
                                dispatchAnalyticsEvent: (payload)=>{
                                    var _api$analytics;
                                    return api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || (_api$analytics = _api$analytics.actions) === null || _api$analytics === void 0 ? void 0 : _api$analytics.fireAnalyticsEvent(payload);
                                }
                            })
                    }
                ] : []
            ];
        },
        actions: {
            registerBlockMenuComponents: (blockMenuComponents)=>{
                registry.register(blockMenuComponents);
            },
            getBlockMenuComponents: ()=>{
                return registry.components;
            },
            isTransformOptionDisabled: (optionNodeTypeName, optionNodeTypeAttrs, targetNodeMarkChanges)=>{
                var _api$blockControls, _api$selection;
                const preservedSelection = api === null || api === void 0 || (_api$blockControls = api.blockControls) === null || _api$blockControls === void 0 || (_api$blockControls = _api$blockControls.sharedState.currentState()) === null || _api$blockControls === void 0 ? void 0 : _api$blockControls.preservedSelection;
                const selection = api === null || api === void 0 || (_api$selection = api.selection) === null || _api$selection === void 0 || (_api$selection = _api$selection.sharedState) === null || _api$selection === void 0 || (_api$selection = _api$selection.currentState()) === null || _api$selection === void 0 ? void 0 : _api$selection.selection;
                const currentSelection = preservedSelection || selection;
                if (!currentSelection) return true;
                return (0, $avMdA.isTransformToTargetDisabled)({
                    selection: currentSelection,
                    targetNodeTypeName: optionNodeTypeName,
                    targetNodeTypeAttrs: optionNodeTypeAttrs,
                    targetNodeMarkChanges: (0, $3y2s4.isExperimentEnabled)('platform_editor_block_menu_small_text') ? targetNodeMarkChanges : undefined,
                    transformRegistry: transformSourceRegistry
                });
            },
            registerBlockMenuTransforms: (transforms)=>transformSourceRegistry.register(transforms)
        },
        commands: {
            transformInlineNode: (metadata)=>(0, $hj6cH.transformInlineNode)(api)(metadata),
            transformNode: (targetType, metadata)=>(0, $5hluS.transformNode)(api, transformSourceRegistry)(targetType, metadata)
        },
        getSharedState (editorState) {
            var _api$blockControls2;
            const useStandardNodeWidth = (config === null || config === void 0 ? void 0 : config.useStandardNodeWidth) ?? false;
            if (!editorState) return {
                currentSelectedNodeName: undefined,
                showFlag: false,
                useStandardNodeWidth: useStandardNodeWidth
            };
            // Get the menuTriggerBy from blockControls plugin if available
            const currentSelectedNodeName = api === null || api === void 0 || (_api$blockControls2 = api.blockControls) === null || _api$blockControls2 === void 0 || (_api$blockControls2 = _api$blockControls2.sharedState.currentState()) === null || _api$blockControls2 === void 0 ? void 0 : _api$blockControls2.menuTriggerBy;
            // Get the showFlag from plugin state
            const pluginState = (0, $aCsiM.blockMenuPluginKey).getState(editorState);
            const showFlag = (pluginState === null || pluginState === void 0 ? void 0 : pluginState.showFlag) ?? false;
            return {
                currentSelectedNodeName: currentSelectedNodeName,
                showFlag: showFlag,
                useStandardNodeWidth: useStandardNodeWidth
            };
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement }) {
            refs.popupsMountPoint = popupsMountPoint || undefined;
            return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $cm3rY.BlockMenuProvider), {
                api: api,
                editorView: editorView,
                children: [
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $ahtLN.default), {
                        editorView: editorView,
                        api: api,
                        mountTo: popupsMountPoint,
                        boundariesElement: popupsBoundariesElement,
                        scrollableElement: popupsScrollableElement
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $44b4M.Flag), {
                        api: api
                    })
                ]
            });
        }
    };
};

});
parcelRegister("CdVEd", function(module, exports) {
$parcel$export(module.exports, "createBlockMenuRegistry", () => $e1803242345d8765$export$b5eca477c47c935a);
const $e1803242345d8765$export$b5eca477c47c935a = ()=>{
    const components = [];
    const register = (blockMenuComponents)=>{
        components.push(...blockMenuComponents);
    };
    return {
        register: register,
        components: components
    };
};

});

parcelRegister("avMdA", function(module, exports) {
$parcel$export(module.exports, "isTransformToTargetDisabled", () => $9ddfd43036abd1f8$export$ed52055465d881d8);

var $6Cbfp = parcelRequire("6Cbfp");

var $kW8qW = parcelRequire("kW8qW");

var $3y2s4 = parcelRequire("3y2s4");

var $dOaWM = parcelRequire("dOaWM");

var $aBMtz = parcelRequire("aBMtz");

var $i78ce = parcelRequire("i78ce");

var $l57rz = parcelRequire("l57rz");
const $9ddfd43036abd1f8$var$getTargetMarks = (schema, currentMarks, marksToAdd, marksToRemove)=>{
    if (!marksToAdd && !marksToRemove) return undefined;
    let targetMarks = currentMarks;
    for (const name of marksToRemove ?? []){
        const markType = schema.marks[name];
        if (markType) targetMarks = markType.removeFromSet(targetMarks);
    }
    for (const [name, attrs] of Object.entries(marksToAdd ?? {})){
        const markType = schema.marks[name];
        if (markType) targetMarks = markType.create(attrs).addToSet(markType.removeFromSet(targetMarks));
    }
    return targetMarks;
};
const $9ddfd43036abd1f8$export$abccbeb211b45a84 = (schema, selectedNodeTypeName, parentNode, nodeTypeName, nodeTypeAttrs, selectedNode, marksToAdd, marksToRemove)=>{
    const adjustedNodeTypeName = (0, $i78ce.getTargetNodeTypeNameInContext)(nodeTypeName, true, parentNode, schema);
    if (!adjustedNodeTypeName) return false;
    const nodeType = schema.nodes[adjustedNodeTypeName];
    let content = null;
    const nodesThatCantBeNestedInNestedExpand = [
        'blockCard',
        'embedCard',
        'table'
    ];
    if (nodesThatCantBeNestedInNestedExpand.includes(selectedNodeTypeName) && (adjustedNodeTypeName === 'expand' || adjustedNodeTypeName === 'nestedExpand')) {
        const node = schema.nodes[selectedNodeTypeName];
        content = node.createAndFill();
    }
    if ((0, $3y2s4.isExperimentEnabled)('platform_editor_block_menu_small_text') && selectedNode && (marksToAdd || marksToRemove)) {
        const targetMarks = $9ddfd43036abd1f8$var$getTargetMarks(schema, selectedNode.marks, marksToAdd, marksToRemove);
        const targetNode = nodeType.createAndFill(nodeTypeAttrs, content, targetMarks);
        return Boolean(targetNode && parentNode.type.validContent((0, $kW8qW.Fragment).from(targetNode)));
    }
    return parentNode.type.validContent((0, $kW8qW.Fragment).from(nodeType.createAndFill(nodeTypeAttrs, content)));
};
const $9ddfd43036abd1f8$var$isHeadingToHeadingTransformEnabled = (selectedNode, targetNodeTypeAttrs)=>{
    var _selectedNode$attrs;
    const selectedLevel = (_selectedNode$attrs = selectedNode.attrs) === null || _selectedNode$attrs === void 0 ? void 0 : _selectedNode$attrs.level;
    const targetLevel = targetNodeTypeAttrs === null || targetNodeTypeAttrs === void 0 ? void 0 : targetNodeTypeAttrs.level;
    if (selectedLevel === undefined || targetLevel === undefined) return false;
    return selectedLevel !== targetLevel;
};
const $9ddfd43036abd1f8$var$isTransformEnabledForNode = (node, targetNodeTypeName, targetNodeTypeAttrs, marksToAdd, marksToRemove, isNested, parent, schema)=>{
    const selectedNodeTypeName = (0, $aBMtz.toNodeTypeValue)(node.type.name);
    if (!selectedNodeTypeName) return false;
    if (selectedNodeTypeName === targetNodeTypeName) {
        const removesTargetMarks = marksToRemove === null || marksToRemove === void 0 ? void 0 : marksToRemove.some((name)=>{
            const markType = schema.marks[name];
            return markType ? Boolean(markType.isInSet(node.marks)) : false;
        });
        const addsOrReplacesTargetMarks = Object.entries(marksToAdd ?? {}).some(([name, attrs])=>{
            var _markType$isInSet;
            const markType = schema.marks[name];
            return markType ? !((_markType$isInSet = markType.isInSet(node.marks)) !== null && _markType$isInSet !== void 0 && _markType$isInSet.eq(markType.create(attrs))) : false;
        });
        if (removesTargetMarks || addsOrReplacesTargetMarks) {
            if (isNested && !$9ddfd43036abd1f8$export$abccbeb211b45a84(schema, selectedNodeTypeName, parent, targetNodeTypeName, targetNodeTypeAttrs, node, marksToAdd, marksToRemove)) return false;
            return true;
        }
    }
    const isDisabledByStepsConfig = (0, $dOaWM.isTransformDisabledBasedOnStepsConfig)(selectedNodeTypeName, targetNodeTypeName);
    if (isDisabledByStepsConfig) return false;
    if (selectedNodeTypeName === 'heading' && targetNodeTypeName === 'heading') return $9ddfd43036abd1f8$var$isHeadingToHeadingTransformEnabled(node, targetNodeTypeAttrs);
    if (isNested && !$9ddfd43036abd1f8$export$abccbeb211b45a84(schema, selectedNodeTypeName, parent, targetNodeTypeName, targetNodeTypeAttrs, node, marksToAdd, marksToRemove)) return false;
    return true;
};
const $9ddfd43036abd1f8$export$ed52055465d881d8 = ({ selection: selection, targetNodeTypeName: targetNodeTypeName, targetNodeTypeAttrs: targetNodeTypeAttrs, targetNodeMarkChanges: targetNodeMarkChanges, transformRegistry: transformRegistry })=>{
    const { range: range } = (0, $6Cbfp.expandSelectionToBlockRange)(selection);
    if (!range) return false;
    const sourceNode = (0, $l57rz.getSingleTransformSourceNode)(selection, range);
    if ((0, $l57rz.isExtensionTransformSource)(sourceNode)) {
        var _transformRegistry$re;
        return (transformRegistry === null || transformRegistry === void 0 || (_transformRegistry$re = transformRegistry.resolve({
            source: sourceNode.toJSON(),
            targetTypeName: targetNodeTypeName
        })) === null || _transformRegistry$re === void 0 ? void 0 : _transformRegistry$re.status) !== 'supported';
    }
    const selectedNodes = (0, $i78ce.getBlockNodesInRange)(range);
    const parent = range.parent;
    const isNested = range.depth >= 1;
    const { schema: schema } = selection.$from.doc.type;
    const { marksToAdd: marksToAdd, marksToRemove: marksToRemove } = targetNodeMarkChanges ?? {};
    const supportedTargetNodeTypeName = (0, $aBMtz.toNodeTypeValue)(targetNodeTypeName);
    if (!supportedTargetNodeTypeName) return true;
    const isEnabledForAnyNode = selectedNodes.some((node)=>$9ddfd43036abd1f8$var$isTransformEnabledForNode(node, supportedTargetNodeTypeName, targetNodeTypeAttrs, marksToAdd, marksToRemove, isNested, parent, schema));
    return !isEnabledForAnyNode;
};

});
parcelRegister("dOaWM", function(module, exports) {
$parcel$export(module.exports, "convertNodesToTargetType", () => $e5109418603be31b$export$643addcbe529babf);
$parcel$export(module.exports, "isTransformDisabledBasedOnStepsConfig", () => $e5109418603be31b$export$9370deb718b26b1b);

var $01Z6w = parcelRequire("01Z6w");

var $kW8qW = parcelRequire("kW8qW");

var $3y2s4 = parcelRequire("3y2s4");

var $5N1Y4 = parcelRequire("5N1Y4");

var $i78ce = parcelRequire("i78ce");

var $dszy8 = parcelRequire("dszy8");

var $aBMtz = parcelRequire("aBMtz");
const $e5109418603be31b$var$LIST_NODE_TYPE_NAMES = new Set([
    'bulletList',
    'orderedList',
    'taskList',
    'decisionList',
    'listItem',
    'taskItem',
    'blockTaskItem',
    'decisionItem'
]);
const $e5109418603be31b$var$shouldRecurseThroughListNode = (node)=>$e5109418603be31b$var$LIST_NODE_TYPE_NAMES.has(node.type.name);
const $e5109418603be31b$var$applyTargetNodeMarks = (node, targetNodeType, marksToAdd, marksToRemove, schema, shouldRecurseIntoChildren = ()=>true)=>{
    let nextNode = node;
    if (node.type === targetNodeType) {
        const marksAfterRemovals = (marksToRemove ?? []).reduce((currentMarks, name)=>{
            const markType = schema.marks[name];
            return markType ? markType.removeFromSet(currentMarks) : currentMarks;
        }, node.marks);
        const marks = Object.entries(marksToAdd ?? {}).reduce((currentMarks, [name, attrs])=>{
            const markType = schema.marks[name];
            return markType ? markType.create(attrs).addToSet(markType.removeFromSet(currentMarks)) : currentMarks;
        }, marksAfterRemovals);
        nextNode = node.mark(marks);
    }
    if (!shouldRecurseIntoChildren(nextNode) || nextNode.childCount === 0) return nextNode;
    const children = [];
    nextNode.forEach((child)=>children.push($e5109418603be31b$var$applyTargetNodeMarks(child, targetNodeType, marksToAdd, marksToRemove, schema, shouldRecurseIntoChildren)));
    return nextNode.copy((0, $kW8qW.Fragment).fromArray(children));
};
const $e5109418603be31b$export$d51f879aeee57aee = (nodes, parentNode, schema)=>{
    if (!schema.nodes['panel_c1'] || !(0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) return nodes;
    return nodes.map((node)=>{
        if (node.type.name === 'panel') {
            const shouldUsePanelC1 = !parentNode || (0, $01Z6w.isNodeTypeValidChildOf)('panel_c1', parentNode, schema);
            if (shouldUsePanelC1) return schema.nodes['panel_c1'].createAndFill(node.attrs, node.content, node.marks) ?? node;
        }
        return node;
    });
};
const $e5109418603be31b$export$643addcbe529babf = ({ sourceNodes: sourceNodes, targetNodeType: targetNodeType, schema: schema, isNested: isNested, targetAttrs: targetAttrs, marksToAdd: marksToAdd, marksToRemove: marksToRemove, parentNode: parentNode })=>{
    const sourceNode = sourceNodes.at(0);
    if (!sourceNode) return sourceNodes;
    const selectedNodeTypeName = (0, $aBMtz.toNodeTypeValue)((0, $aBMtz.getNodeName)(sourceNodes));
    const initialTargetNodeTypeName = (0, $aBMtz.toNodeTypeValue)(targetNodeType.name);
    const targetNodeTypeName = (0, $i78ce.getTargetNodeTypeNameInContext)(initialTargetNodeTypeName, isNested, parentNode, schema);
    if (!selectedNodeTypeName || !targetNodeTypeName) return sourceNodes;
    const steps = (0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $dszy8.TRANSFORMATION_MATRIX_PANEL_C1)[selectedNodeTypeName][targetNodeTypeName] : (0, $dszy8.TRANSFORMATION_MATRIX)[selectedNodeTypeName][targetNodeTypeName];
    const shouldApplyTargetNodeMarkChanges = (0, $3y2s4.isExperimentEnabled)('platform_editor_block_menu_small_text') && Boolean(marksToAdd || marksToRemove);
    const context = {
        // sourceNode is incorrect now - what to do here?
        fromNode: sourceNode,
        includeBlockTaskItems: shouldApplyTargetNodeMarkChanges,
        targetNodeTypeName: targetNodeTypeName,
        schema: schema,
        targetAttrs: targetAttrs
    };
    if (!shouldApplyTargetNodeMarkChanges) {
        if (!steps || steps.length === 0) return sourceNodes;
        const resultNodes = steps.reduce((nodes, step)=>step(nodes, context), sourceNodes);
        return $e5109418603be31b$export$d51f879aeee57aee(resultNodes, parentNode, schema);
    }
    const shouldLimitTargetNodeMarkRecursion = targetNodeTypeName === 'paragraph' && [
        'multi',
        'panel',
        'panel_c1',
        'expand',
        'nestedExpand',
        'blockquote',
        'layoutSection'
    ].includes(selectedNodeTypeName);
    const resultNodes = (steps === null || steps === void 0 ? void 0 : steps.reduce((nodes, step)=>step(nodes, context), sourceNodes)) ?? sourceNodes;
    const upgradedNodes = steps !== null && steps !== void 0 && steps.length ? $e5109418603be31b$export$d51f879aeee57aee(resultNodes, parentNode, schema) : resultNodes;
    return upgradedNodes.map((node)=>$e5109418603be31b$var$applyTargetNodeMarks(node, targetNodeType, marksToAdd, marksToRemove, schema, shouldLimitTargetNodeMarkRecursion ? $e5109418603be31b$var$shouldRecurseThroughListNode : undefined));
};
const $e5109418603be31b$export$9370deb718b26b1b = (selectedNodeType, targetNodeType)=>{
    const steps = (0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $dszy8.TRANSFORMATION_MATRIX_PANEL_C1)[selectedNodeType][targetNodeType] : (0, $dszy8.TRANSFORMATION_MATRIX)[selectedNodeType][targetNodeType];
    return !steps || steps.length === 0;
};

});
parcelRegister("i78ce", function(module, exports) {
$parcel$export(module.exports, "isTextNode", () => $e39d2623ebe4191d$export$ccbedd67ef6e9417);
$parcel$export(module.exports, "isListNode", () => $e39d2623ebe4191d$export$a7d7d2b9ba4d4dbb);
$parcel$export(module.exports, "getSelectedNode", () => $e39d2623ebe4191d$export$da5a91481a5e4aa3);
$parcel$export(module.exports, "getTargetNodeTypeNameInContext", () => $e39d2623ebe4191d$export$4126f65c98e68a18);
$parcel$export(module.exports, "convertNestedExpandToExpand", () => $e39d2623ebe4191d$export$3f28f32259ef3cd);
$parcel$export(module.exports, "convertExpandToNestedExpand", () => $e39d2623ebe4191d$export$46a467eba720c02e);
$parcel$export(module.exports, "convertTextNodeToParagraph", () => $e39d2623ebe4191d$export$da315ff7968a4b6e);
$parcel$export(module.exports, "getBlockNodesInRange", () => $e39d2623ebe4191d$export$4a1a21434bd3128);
$parcel$export(module.exports, "createTextContent", () => $e39d2623ebe4191d$export$acfd0d6af597f7c);

var $01Z6w = parcelRequire("01Z6w");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $2E7OD = parcelRequire("2E7OD");

var $5N1Y4 = parcelRequire("5N1Y4");

var $aBMtz = parcelRequire("aBMtz");
const $e39d2623ebe4191d$export$ccbedd67ef6e9417 = (node)=>{
    const category = (0, $aBMtz.NODE_CATEGORY_BY_TYPE)[node.type.name];
    return category === 'text';
};
const $e39d2623ebe4191d$export$a7d7d2b9ba4d4dbb = (node)=>{
    return [
        'bulletList',
        'orderedList',
        'taskList'
    ].includes(node.type.name);
};
const $e39d2623ebe4191d$export$da5a91481a5e4aa3 = (selection)=>{
    if (selection instanceof (0, $cw0wu.NodeSelection)) return {
        node: selection.node,
        pos: selection.$from.pos,
        start: 0,
        // ?
        depth: selection.$from.depth
    };
    if (selection instanceof (0, $2E7OD.CellSelection)) {
        const tableSelected = (0, $gab48.findParentNodeOfType)(selection.$from.doc.type.schema.nodes.table)(selection);
        return tableSelected;
    }
    if (selection instanceof (0, $cw0wu.TextSelection)) {
        const { blockquote: blockquote, bulletList: bulletList, orderedList: orderedList, taskList: taskList, codeBlock: codeBlock, paragraph: paragraph, heading: heading } = selection.$from.doc.type.schema.nodes;
        const quoteSelected = (0, $gab48.findParentNodeOfType)([
            blockquote
        ])(selection);
        if (quoteSelected) return quoteSelected;
        const codeBlockSelected = (0, $gab48.findParentNodeOfType)([
            codeBlock
        ])(selection);
        if (codeBlockSelected) return codeBlockSelected;
        const listSelected = (0, $gab48.findParentNodeOfType)([
            bulletList,
            taskList,
            orderedList
        ])(selection);
        if (listSelected) return listSelected;
        const paragraphOrHeading = (0, $gab48.findParentNodeOfType)([
            paragraph,
            heading
        ])(selection);
        if (paragraphOrHeading) return paragraphOrHeading;
    }
    return undefined;
};
const $e39d2623ebe4191d$export$4126f65c98e68a18 = (nodeTypeName, isNested, parentNode, schema)=>{
    if (parentNode && isNested && (parentNode.type.name === 'layoutColumn' || parentNode.type.name === 'bodiedSyncBlock')) return nodeTypeName;
    if (nodeTypeName === 'expand' && isNested) return 'nestedExpand';
    if (nodeTypeName === 'panel' && schema !== null && schema !== void 0 && schema.nodes['panel_c1'] && (0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) {
        if (!parentNode || (0, $01Z6w.isNodeTypeValidChildOf)('panel_c1', parentNode, schema)) return 'panel_c1';
    }
    return nodeTypeName;
};
const $e39d2623ebe4191d$export$3f28f32259ef3cd = (node, schema)=>{
    var _node$attrs;
    const expandType = schema.nodes.expand;
    if (!expandType) return null;
    return expandType.createAndFill({
        title: ((_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.title) || '',
        localId: crypto.randomUUID()
    }, node.content);
};
const $e39d2623ebe4191d$export$46a467eba720c02e = (node, schema)=>{
    var _node$attrs2;
    const nestedExpandType = schema.nodes.nestedExpand;
    if (!nestedExpandType) return null;
    return nestedExpandType.createAndFill({
        title: ((_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.title) || '',
        localId: crypto.randomUUID()
    }, node.content);
};
const $e39d2623ebe4191d$export$da315ff7968a4b6e = (node, schema)=>{
    // If it's already a paragraph, return as-is
    if (node.type.name === 'paragraph') return node;
    // Convert heading (or other text node) to paragraph with same inline content
    return schema.nodes.paragraph.createAndFill({}, node.content) ?? null;
};
const $e39d2623ebe4191d$export$4a1a21434bd3128 = (range)=>{
    if (range.startIndex === range.endIndex) return [];
    if (range.endIndex - range.startIndex <= 1) return [
        range.parent.child(range.startIndex)
    ];
    const blockNodes = [];
    for(let i = range.startIndex; i < range.endIndex; i++)if (range.parent.child(i).isBlock) blockNodes.push(range.parent.child(i));
    return blockNodes;
};
const $e39d2623ebe4191d$export$acfd0d6af597f7c = (node)=>{
    const textContent = node.children.map((child)=>{
        if (child.isText) return child.text;
        else if (child.type.name === 'hardBreak') return '\n';
        return '';
    });
    return textContent.join('');
};

});
parcelRegister("aBMtz", function(module, exports) {
$parcel$export(module.exports, "NODE_CATEGORY_BY_TYPE", () => $7801aa798774cb8b$export$46b8389d01fc568c);
$parcel$export(module.exports, "toNodeTypeValue", () => $7801aa798774cb8b$export$708f29fc6944bd7f);
$parcel$export(module.exports, "getNodeName", () => $7801aa798774cb8b$export$651544f548703224);
const $7801aa798774cb8b$export$46b8389d01fc568c = {
    blockquote: 'container',
    blockCard: 'atomic',
    bodiedExtension: 'atomic',
    bulletList: 'list',
    codeBlock: 'container',
    decisionList: 'list',
    embedCard: 'atomic',
    expand: 'container',
    extension: 'atomic',
    heading: 'text',
    layoutSection: 'container',
    media: 'atomic',
    mediaGroup: 'atomic',
    mediaSingle: 'atomic',
    multiBodiedExtension: 'atomic',
    orderedList: 'list',
    panel: 'container',
    panel_c1: 'container',
    paragraph: 'text',
    nestedExpand: 'container',
    taskList: 'list',
    table: 'atomic',
    multi: 'multi'
};
const $7801aa798774cb8b$export$8b255fd4814375b4 = (value)=>value in $7801aa798774cb8b$export$46b8389d01fc568c;
const $7801aa798774cb8b$export$708f29fc6944bd7f = (value)=>value && $7801aa798774cb8b$export$8b255fd4814375b4(value) ? value : null;
const $7801aa798774cb8b$export$651544f548703224 = (nodes)=>{
    var _nodes$at;
    return nodes.length > 1 ? 'multi' : (_nodes$at = nodes.at(0)) === null || _nodes$at === void 0 ? void 0 : _nodes$at.type.name;
};

});


parcelRegister("dszy8", function(module, exports) {
$parcel$export(module.exports, "TRANSFORMATION_MATRIX", () => $776a532d36c9c7e3$export$1afd37dec4d41179);
$parcel$export(module.exports, "TRANSFORMATION_MATRIX_PANEL_C1", () => $776a532d36c9c7e3$export$de222f5888011a02);

var $3y2s4 = parcelRequire("3y2s4");

var $k0ktg = parcelRequire("k0ktg");

var $eDIoD = parcelRequire("eDIoD");

var $eVUkf = parcelRequire("eVUkf");

var $3CF1U = parcelRequire("3CF1U");

var $hi0NR = parcelRequire("hi0NR");

var $bxbn6 = parcelRequire("bxbn6");

var $eGbd2 = parcelRequire("eGbd2");

var $6j8P7 = parcelRequire("6j8P7");

var $kiPNO = parcelRequire("kiPNO");

var $1LZnC = parcelRequire("1LZnC");

var $jY7Ey = parcelRequire("jY7Ey");

var $fn1ry = parcelRequire("fn1ry");

var $70IWl = parcelRequire("70IWl");

var $bBQWi = parcelRequire("bBQWi");

var $9kjFX = parcelRequire("9kjFX");

var $e2ewP = parcelRequire("e2ewP");
const $776a532d36c9c7e3$var$applyTargetHeadingToParagraphStep = (nodes, context)=>{
    if (!(0, $3y2s4.isExperimentEnabled)('platform_editor_block_menu_small_text')) return nodes;
    return nodes.map((node)=>{
        if (node.type.name !== 'heading') return node;
        return (0, $k0ktg.applyTargetTextTypeStep)([
            node
        ], context).at(0) ?? node;
    });
};
/**
 * Creates the transformation matrix for all node type pairs.
 * When includePanelC1 is true (platform_editor_nest_table_in_panel experiment on),
 * panel_c1 entries are included as both source and target types.
 * If a transformation is not defined (undefined), it is not available.
 */ const $776a532d36c9c7e3$var$createTransformationMatrix = (includePanelC1)=>({
        paragraph: {
            heading: [
                (0, $hi0NR.flattenStep),
                (0, $k0ktg.applyTargetTextTypeStep)
            ],
            blockquote: [
                (0, $9kjFX.wrapMixedContentStep)
            ],
            codeBlock: [
                (0, $9kjFX.wrapMixedContentStep)
            ],
            expand: [
                (0, $9kjFX.wrapMixedContentStep)
            ],
            nestedExpand: [
                (0, $9kjFX.wrapMixedContentStep)
            ],
            layoutSection: [
                (0, $9kjFX.wrapMixedContentStep)
            ],
            panel: [
                (0, $9kjFX.wrapMixedContentStep)
            ],
            ...includePanelC1 ? {
                panel_c1: [
                    (0, $9kjFX.wrapMixedContentStep)
                ]
            } : {},
            bulletList: [
                (0, $bBQWi.wrapIntoListStep)
            ],
            orderedList: [
                (0, $bBQWi.wrapIntoListStep)
            ],
            taskList: [
                (0, $bBQWi.wrapIntoListStep)
            ],
            decisionList: [
                (0, $bBQWi.wrapIntoListStep)
            ]
        },
        heading: {
            heading: [
                (0, $hi0NR.flattenStep),
                (0, $k0ktg.applyTargetTextTypeStep)
            ],
            paragraph: [
                (0, $hi0NR.flattenStep),
                (0, $k0ktg.applyTargetTextTypeStep)
            ],
            blockquote: [
                (0, $9kjFX.wrapMixedContentStep)
            ],
            codeBlock: [
                (0, $9kjFX.wrapMixedContentStep)
            ],
            expand: [
                (0, $9kjFX.wrapMixedContentStep)
            ],
            nestedExpand: [
                (0, $9kjFX.wrapMixedContentStep)
            ],
            layoutSection: [
                (0, $9kjFX.wrapMixedContentStep)
            ],
            panel: [
                (0, $9kjFX.wrapMixedContentStep)
            ],
            ...includePanelC1 ? {
                panel_c1: [
                    (0, $9kjFX.wrapMixedContentStep)
                ]
            } : {},
            bulletList: [
                (0, $bBQWi.wrapIntoListStep)
            ],
            orderedList: [
                (0, $bBQWi.wrapIntoListStep)
            ],
            taskList: [
                (0, $bBQWi.wrapIntoListStep)
            ],
            decisionList: [
                (0, $bBQWi.wrapIntoListStep)
            ]
        },
        panel: {
            blockquote: [
                (0, $fn1ry.unwrapStep),
                (0, $9kjFX.wrapMixedContentStep)
            ],
            codeBlock: [
                (0, $fn1ry.unwrapStep),
                (0, $9kjFX.wrapMixedContentStep)
            ],
            expand: [
                (0, $fn1ry.unwrapStep),
                (0, $e2ewP.wrapStep)
            ],
            nestedExpand: [
                (0, $fn1ry.unwrapStep),
                (0, $e2ewP.wrapStep)
            ],
            layoutSection: [
                (0, $fn1ry.unwrapStep),
                (0, $9kjFX.wrapMixedContentStep)
            ],
            paragraph: [
                (0, $fn1ry.unwrapStep),
                $776a532d36c9c7e3$var$applyTargetHeadingToParagraphStep
            ]
        },
        panel_c1: includePanelC1 ? {
            blockquote: [
                (0, $fn1ry.unwrapStep),
                (0, $9kjFX.wrapMixedContentStep)
            ],
            codeBlock: [
                (0, $fn1ry.unwrapStep),
                (0, $9kjFX.wrapMixedContentStep)
            ],
            expand: [
                (0, $fn1ry.unwrapStep),
                (0, $e2ewP.wrapStep)
            ],
            nestedExpand: [
                (0, $fn1ry.unwrapStep),
                (0, $e2ewP.wrapStep)
            ],
            layoutSection: [
                (0, $fn1ry.unwrapStep),
                (0, $9kjFX.wrapMixedContentStep)
            ],
            paragraph: [
                (0, $fn1ry.unwrapStep),
                $776a532d36c9c7e3$var$applyTargetHeadingToParagraphStep
            ]
        } : {},
        expand: {
            panel: [
                (0, $kiPNO.unwrapExpandStep),
                (0, $9kjFX.wrapMixedContentStep)
            ],
            ...includePanelC1 ? {
                panel_c1: [
                    (0, $kiPNO.unwrapExpandStep),
                    (0, $9kjFX.wrapMixedContentStep)
                ]
            } : {},
            blockquote: [
                (0, $kiPNO.unwrapExpandStep),
                (0, $9kjFX.wrapMixedContentStep)
            ],
            layoutSection: [
                (0, $kiPNO.unwrapExpandStep),
                (0, $9kjFX.wrapMixedContentStep)
            ],
            nestedExpand: [
                (0, $kiPNO.unwrapExpandStep),
                (0, $e2ewP.wrapStep)
            ],
            paragraph: [
                (0, $kiPNO.unwrapExpandStep),
                $776a532d36c9c7e3$var$applyTargetHeadingToParagraphStep
            ]
        },
        nestedExpand: {
            panel: [
                (0, $kiPNO.unwrapExpandStep),
                (0, $9kjFX.wrapMixedContentStep)
            ],
            ...includePanelC1 ? {
                panel_c1: [
                    (0, $kiPNO.unwrapExpandStep),
                    (0, $9kjFX.wrapMixedContentStep)
                ]
            } : {},
            blockquote: [
                (0, $kiPNO.unwrapExpandStep),
                (0, $9kjFX.wrapMixedContentStep)
            ],
            layoutSection: [
                (0, $kiPNO.unwrapExpandStep),
                (0, $9kjFX.wrapMixedContentStep)
            ],
            paragraph: [
                (0, $kiPNO.unwrapExpandStep),
                $776a532d36c9c7e3$var$applyTargetHeadingToParagraphStep
            ]
        },
        blockquote: {
            expand: [
                (0, $e2ewP.wrapStep)
            ],
            nestedExpand: [
                (0, $e2ewP.wrapStep)
            ],
            layoutSection: [
                (0, $9kjFX.wrapMixedContentStep)
            ],
            panel: [
                (0, $fn1ry.unwrapStep),
                (0, $e2ewP.wrapStep)
            ],
            ...includePanelC1 ? {
                panel_c1: [
                    (0, $fn1ry.unwrapStep),
                    (0, $e2ewP.wrapStep)
                ]
            } : {},
            paragraph: [
                (0, $fn1ry.unwrapStep),
                $776a532d36c9c7e3$var$applyTargetHeadingToParagraphStep
            ],
            decisionList: [
                (0, $fn1ry.unwrapStep),
                (0, $70IWl.wrapBlockquoteToDecisionListStep)
            ]
        },
        layoutSection: {
            blockquote: [
                (0, $1LZnC.unwrapLayoutStep),
                (0, $9kjFX.wrapMixedContentStep)
            ],
            expand: [
                (0, $1LZnC.unwrapLayoutStep),
                (0, $e2ewP.wrapStep)
            ],
            nestedExpand: [
                (0, $1LZnC.unwrapLayoutStep),
                (0, $e2ewP.wrapStep)
            ],
            panel: [
                (0, $1LZnC.unwrapLayoutStep),
                (0, $9kjFX.wrapMixedContentStep)
            ],
            ...includePanelC1 ? {
                panel_c1: [
                    (0, $1LZnC.unwrapLayoutStep),
                    (0, $9kjFX.wrapMixedContentStep)
                ]
            } : {},
            paragraph: [
                (0, $1LZnC.unwrapLayoutStep),
                $776a532d36c9c7e3$var$applyTargetHeadingToParagraphStep
            ]
        },
        codeBlock: {
            blockquote: [
                (0, $e2ewP.wrapStep)
            ],
            expand: [
                (0, $e2ewP.wrapStep)
            ],
            nestedExpand: [
                (0, $e2ewP.wrapStep)
            ],
            layoutSection: [
                (0, $9kjFX.wrapMixedContentStep)
            ],
            panel: [
                (0, $e2ewP.wrapStep)
            ],
            ...includePanelC1 ? {
                panel_c1: [
                    (0, $e2ewP.wrapStep)
                ]
            } : {},
            paragraph: [
                (0, $k0ktg.applyTargetTextTypeStep)
            ]
        },
        bulletList: {
            orderedList: [
                (0, $eGbd2.listToListStep)
            ],
            taskList: [
                (0, $eGbd2.listToListStep)
            ],
            decisionList: [
                (0, $3CF1U.flattenListStep),
                (0, $bxbn6.listToDecisionListStep)
            ],
            blockquote: [
                (0, $e2ewP.wrapStep)
            ],
            expand: [
                (0, $e2ewP.wrapStep)
            ],
            nestedExpand: [
                (0, $e2ewP.wrapStep)
            ],
            layoutSection: [
                (0, $9kjFX.wrapMixedContentStep)
            ],
            panel: [
                (0, $e2ewP.wrapStep)
            ],
            ...includePanelC1 ? {
                panel_c1: [
                    (0, $e2ewP.wrapStep)
                ]
            } : {},
            paragraph: [
                (0, $3CF1U.flattenListStep),
                (0, $jY7Ey.unwrapListStep),
                (0, $k0ktg.applyTargetTextTypeStep)
            ]
        },
        orderedList: {
            bulletList: [
                (0, $eGbd2.listToListStep)
            ],
            taskList: [
                (0, $eGbd2.listToListStep)
            ],
            decisionList: [
                (0, $3CF1U.flattenListStep),
                (0, $bxbn6.listToDecisionListStep)
            ],
            blockquote: [
                (0, $e2ewP.wrapStep)
            ],
            expand: [
                (0, $e2ewP.wrapStep)
            ],
            nestedExpand: [
                (0, $e2ewP.wrapStep)
            ],
            layoutSection: [
                (0, $9kjFX.wrapMixedContentStep)
            ],
            panel: [
                (0, $e2ewP.wrapStep)
            ],
            ...includePanelC1 ? {
                panel_c1: [
                    (0, $e2ewP.wrapStep)
                ]
            } : {},
            paragraph: [
                (0, $3CF1U.flattenListStep),
                (0, $jY7Ey.unwrapListStep),
                (0, $k0ktg.applyTargetTextTypeStep)
            ]
        },
        taskList: {
            bulletList: [
                (0, $eGbd2.listToListStep)
            ],
            orderedList: [
                (0, $eGbd2.listToListStep)
            ],
            decisionList: [
                (0, $3CF1U.flattenListStep),
                (0, $bxbn6.listToDecisionListStep)
            ],
            expand: [
                (0, $e2ewP.wrapStep)
            ],
            nestedExpand: [
                (0, $e2ewP.wrapStep)
            ],
            layoutSection: [
                (0, $9kjFX.wrapMixedContentStep)
            ],
            panel: [
                (0, $e2ewP.wrapStep)
            ],
            ...includePanelC1 ? {
                panel_c1: [
                    (0, $e2ewP.wrapStep)
                ]
            } : {},
            paragraph: [
                (0, $3CF1U.flattenListStep),
                (0, $jY7Ey.unwrapListStep),
                (0, $k0ktg.applyTargetTextTypeStep)
            ]
        },
        table: {
            expand: [
                (0, $e2ewP.wrapStep)
            ],
            nestedExpand: [
                (0, $e2ewP.wrapStep)
            ],
            layoutSection: [
                (0, $9kjFX.wrapMixedContentStep)
            ]
        },
        mediaSingle: {
            blockquote: [
                (0, $e2ewP.wrapStep)
            ],
            expand: [
                (0, $e2ewP.wrapStep)
            ],
            nestedExpand: [
                (0, $e2ewP.wrapStep)
            ],
            layoutSection: [
                (0, $9kjFX.wrapMixedContentStep)
            ],
            panel: [
                (0, $e2ewP.wrapStep)
            ],
            ...includePanelC1 ? {
                panel_c1: [
                    (0, $e2ewP.wrapStep)
                ]
            } : {},
            bulletList: [
                (0, $bBQWi.wrapIntoListStep)
            ],
            orderedList: [
                (0, $bBQWi.wrapIntoListStep)
            ]
        },
        mediaGroup: {
            blockquote: [
                (0, $e2ewP.wrapStep)
            ],
            expand: [
                (0, $e2ewP.wrapStep)
            ],
            nestedExpand: [
                (0, $e2ewP.wrapStep)
            ],
            layoutSection: [
                (0, $9kjFX.wrapMixedContentStep)
            ],
            panel: [
                (0, $e2ewP.wrapStep)
            ],
            ...includePanelC1 ? {
                panel_c1: [
                    (0, $e2ewP.wrapStep)
                ]
            } : {}
        },
        media: {
            blockquote: [
                (0, $e2ewP.wrapStep)
            ],
            codeBlock: [
                (0, $e2ewP.wrapStep)
            ],
            expand: [
                (0, $e2ewP.wrapStep)
            ],
            nestedExpand: [
                (0, $e2ewP.wrapStep)
            ],
            layoutSection: [
                (0, $e2ewP.wrapStep)
            ],
            panel: [
                (0, $e2ewP.wrapStep)
            ],
            ...includePanelC1 ? {
                panel_c1: [
                    (0, $e2ewP.wrapStep)
                ]
            } : {},
            bulletList: [
                (0, $bBQWi.wrapIntoListStep)
            ],
            orderedList: [
                (0, $bBQWi.wrapIntoListStep)
            ],
            taskList: [
                (0, $bBQWi.wrapIntoListStep)
            ],
            decisionList: [
                (0, $bBQWi.wrapIntoListStep)
            ]
        },
        decisionList: {
            bulletList: [
                (0, $eVUkf.decisionListToListStep)
            ],
            orderedList: [
                (0, $eVUkf.decisionListToListStep)
            ],
            taskList: [
                (0, $eVUkf.decisionListToListStep)
            ],
            blockquote: [
                (0, $jY7Ey.unwrapListStep),
                (0, $e2ewP.wrapStep)
            ],
            expand: [
                (0, $e2ewP.wrapStep)
            ],
            nestedExpand: [
                (0, $e2ewP.wrapStep)
            ],
            layoutSection: [
                (0, $9kjFX.wrapMixedContentStep)
            ],
            panel: [
                (0, $e2ewP.wrapStep)
            ],
            ...includePanelC1 ? {
                panel_c1: [
                    (0, $e2ewP.wrapStep)
                ]
            } : {},
            paragraph: [
                (0, $3CF1U.flattenListStep),
                (0, $jY7Ey.unwrapListStep),
                (0, $k0ktg.applyTargetTextTypeStep)
            ],
            heading: [
                (0, $3CF1U.flattenListStep),
                (0, $jY7Ey.unwrapListStep),
                (0, $k0ktg.applyTargetTextTypeStep)
            ]
        },
        blockCard: {
            expand: [
                (0, $e2ewP.wrapStep)
            ],
            nestedExpand: [
                (0, $e2ewP.wrapStep)
            ],
            layoutSection: [
                (0, $9kjFX.wrapMixedContentStep)
            ],
            panel: [
                (0, $e2ewP.wrapStep)
            ],
            ...includePanelC1 ? {
                panel_c1: [
                    (0, $e2ewP.wrapStep)
                ]
            } : {}
        },
        embedCard: {
            expand: [
                (0, $e2ewP.wrapStep)
            ],
            nestedExpand: [
                (0, $e2ewP.wrapStep)
            ],
            layoutSection: [
                (0, $9kjFX.wrapMixedContentStep)
            ]
        },
        extension: {
            blockquote: [
                (0, $e2ewP.wrapStep)
            ],
            expand: [
                (0, $e2ewP.wrapStep)
            ],
            nestedExpand: [
                (0, $e2ewP.wrapStep)
            ],
            layoutSection: [
                (0, $9kjFX.wrapMixedContentStep)
            ],
            panel: [
                (0, $e2ewP.wrapStep)
            ],
            ...includePanelC1 ? {
                panel_c1: [
                    (0, $e2ewP.wrapStep)
                ]
            } : {}
        },
        bodiedExtension: {
            nestedExpand: [
                (0, $e2ewP.wrapStep)
            ],
            layoutSection: [
                (0, $9kjFX.wrapMixedContentStep)
            ]
        },
        multiBodiedExtension: {
            blockquote: [
                (0, $e2ewP.wrapStep)
            ],
            codeBlock: [
                (0, $e2ewP.wrapStep)
            ],
            expand: [
                (0, $e2ewP.wrapStep)
            ],
            nestedExpand: [
                (0, $e2ewP.wrapStep)
            ],
            layoutSection: [
                (0, $e2ewP.wrapStep)
            ],
            panel: [
                (0, $e2ewP.wrapStep)
            ],
            ...includePanelC1 ? {
                panel_c1: [
                    (0, $e2ewP.wrapStep)
                ]
            } : {},
            bulletList: [
                (0, $bBQWi.wrapIntoListStep)
            ],
            orderedList: [
                (0, $bBQWi.wrapIntoListStep)
            ],
            taskList: [
                (0, $bBQWi.wrapIntoListStep)
            ],
            decisionList: [
                (0, $bBQWi.wrapIntoListStep)
            ]
        },
        multi: {
            blockquote: [
                (0, $9kjFX.wrapMixedContentStep)
            ],
            codeBlock: [
                (0, $9kjFX.wrapMixedContentStep)
            ],
            expand: [
                (0, $9kjFX.wrapMixedContentStep)
            ],
            nestedExpand: [
                (0, $9kjFX.wrapMixedContentStep)
            ],
            layoutSection: [
                (0, $9kjFX.wrapMixedContentStep)
            ],
            panel: [
                (0, $9kjFX.wrapMixedContentStep)
            ],
            ...includePanelC1 ? {
                panel_c1: [
                    (0, $9kjFX.wrapMixedContentStep)
                ]
            } : {},
            bulletList: [
                (0, $eDIoD.convertEachNodeStep),
                (0, $6j8P7.mergeNeighbourListsStep)
            ],
            orderedList: [
                (0, $eDIoD.convertEachNodeStep),
                (0, $6j8P7.mergeNeighbourListsStep)
            ],
            taskList: [
                (0, $eDIoD.convertEachNodeStep),
                (0, $6j8P7.mergeNeighbourListsStep)
            ],
            decisionList: [
                (0, $eDIoD.convertEachNodeStep),
                (0, $6j8P7.mergeNeighbourListsStep)
            ],
            paragraph: [
                (0, $eDIoD.convertEachNodeStep)
            ],
            heading: [
                (0, $k0ktg.applyTargetTextTypeStep)
            ]
        }
    });
const $776a532d36c9c7e3$export$1afd37dec4d41179 = $776a532d36c9c7e3$var$createTransformationMatrix(false);
const $776a532d36c9c7e3$export$de222f5888011a02 = $776a532d36c9c7e3$var$createTransformationMatrix(true);

});
parcelRegister("k0ktg", function(module, exports) {
$parcel$export(module.exports, "applyTargetTextTypeStep", () => $438950f7e1101990$export$2765a2ea32feab70);
const $438950f7e1101990$export$2765a2ea32feab70 = (nodes, context)=>{
    const { schema: schema, targetNodeTypeName: targetNodeTypeName, targetAttrs: targetAttrs } = context;
    if (targetNodeTypeName !== 'heading' && targetNodeTypeName !== 'paragraph') return nodes;
    const targetType = schema.nodes[targetNodeTypeName];
    if (!targetType) return nodes;
    return nodes.map((node)=>{
        // If codeblock, return nodes as is
        if (targetNodeTypeName === 'heading' && node.type.name === 'codeBlock') return node;
        if (node.isTextblock) {
            // Convert textblock nodes to the target type with content preserved
            let attrs = {};
            if (targetNodeTypeName === 'heading') {
                const level = typeof (targetAttrs === null || targetAttrs === void 0 ? void 0 : targetAttrs.level) === 'number' ? targetAttrs.level : 1;
                attrs = {
                    level: level
                };
            }
            // Filter out marks that aren't allowed on paragraph/heading nodes
            // Remove 'breakout' mark when converting to paragraph/heading as these nodes don't support breakout
            const filteredMarks = node.marks.filter((mark)=>{
                // breakout marks should be removed when converting to paragraph or heading
                if (mark.type.name === 'breakout') return false;
                // Keep all other marks (alignment, indentation, etc.)
                return true;
            });
            return targetType.create(attrs, node.content, filteredMarks);
        }
        // Non-textblock nodes are left unchanged
        return node;
    });
};

});

parcelRegister("eDIoD", function(module, exports) {
$parcel$export(module.exports, "convertEachNodeStep", () => $d8e008ce2c729af3$export$ec839c7f5e301db8);

var $dOaWM = parcelRequire("dOaWM");
/**
 * Handles the edge case where transforming multi-selection to decisionList results in
 * all content breaking out (no valid children for the target). In this case, creates an empty
 * decisionList to ensure the target type exists.
 *
 * Similar to handleEmptyContainerEdgeCase in wrapMixedContentStep, but specifically for
 * multi-to-decisionList transformations where blockquotes break out.
 *
 * @param result - The current result nodes after processing
 * @param hasCreatedDecisionList - Whether a decisionList was already created during processing
 * @param targetNodeTypeName - The target node type name
 * @param schema - The schema
 * @returns The result nodes with an empty decisionList prepended if needed, or the original result
 */ const $d8e008ce2c729af3$var$handleEmptyDecisionListEdgeCase = (result, hasCreatedDecisionList, targetNodeTypeName, schema)=>{
    // Only apply this edge case for decisionList target
    if (targetNodeTypeName !== 'decisionList') return result;
    // If no decisionList was created but we have nodes in result, all content broke out
    const allContentBrokeOut = !hasCreatedDecisionList && result.length > 0;
    if (!allContentBrokeOut) return result;
    // Create an empty decisionList
    const decisionListType = schema.nodes.decisionList;
    const decisionItemType = schema.nodes.decisionItem;
    if (decisionListType && decisionItemType) {
        const emptyDecisionItem = decisionItemType.createAndFill();
        if (emptyDecisionItem) {
            const emptyDecisionList = decisionListType.createAndFill({}, [
                emptyDecisionItem
            ]);
            if (emptyDecisionList) return [
                emptyDecisionList,
                ...result
            ];
        }
    }
    return result;
};
const $d8e008ce2c729af3$export$ec839c7f5e301db8 = (nodes, context)=>{
    const { schema: schema, targetNodeTypeName: targetNodeTypeName, targetAttrs: targetAttrs } = context;
    const targetNodeType = schema.nodes[targetNodeTypeName];
    if (!targetNodeType) return nodes;
    const blockquoteType = schema.nodes.blockquote;
    const resultNodes = [];
    let hasCreatedDecisionList = false;
    for (const node of nodes){
        // Edge case: blockquotes should break out when transforming to decisionList
        if (targetNodeTypeName === 'decisionList' && blockquoteType && node.type === blockquoteType) {
            resultNodes.push(node);
            continue;
        }
        const transformedNodes = (0, $dOaWM.convertNodesToTargetType)({
            sourceNodes: [
                node
            ],
            targetNodeType: targetNodeType,
            schema: schema,
            isNested: false,
            targetAttrs: targetAttrs
        });
        if (transformedNodes.length > 0) {
            resultNodes.push(...transformedNodes);
            // Track if we created a decisionList
            if (targetNodeTypeName === 'decisionList' && transformedNodes.some((n)=>n.type === targetNodeType)) hasCreatedDecisionList = true;
        } else resultNodes.push(node);
    }
    // Handle edge case: if no decisionList was created, create an empty one
    const finalResult = $d8e008ce2c729af3$var$handleEmptyDecisionListEdgeCase(resultNodes, hasCreatedDecisionList, targetNodeTypeName, schema);
    return finalResult;
};

});

parcelRegister("eVUkf", function(module, exports) {
$parcel$export(module.exports, "decisionListToListStep", () => $4d7d2366eb143fe2$export$6d5588752dacfe72);

var $kW8qW = parcelRequire("kW8qW");
const $4d7d2366eb143fe2$var$targets = (targetNodeTypeName, schema)=>{
    let targetListType;
    let targetItemType;
    switch(targetNodeTypeName){
        case 'bulletList':
            targetListType = schema.nodes.bulletList;
            targetItemType = schema.nodes.listItem;
            break;
        case 'orderedList':
            targetListType = schema.nodes.orderedList;
            targetItemType = schema.nodes.listItem;
            break;
        case 'taskList':
            targetListType = schema.nodes.taskList;
            targetItemType = schema.nodes.taskItem;
            break;
        default:
    }
    return {
        targetListType: targetListType,
        targetItemType: targetItemType
    };
};
const $4d7d2366eb143fe2$export$6d5588752dacfe72 = (nodes, context)=>{
    const { schema: schema, targetNodeTypeName: targetNodeTypeName } = context;
    const paragraphType = schema.nodes.paragraph;
    return nodes.map((node)=>{
        if (node.type !== schema.nodes.decisionList) return node;
        const { targetListType: targetListType, targetItemType: targetItemType } = $4d7d2366eb143fe2$var$targets(targetNodeTypeName, schema);
        if (!targetListType || !targetItemType) return node;
        const newItems = [];
        node.forEach((decisionItem)=>{
            const newItem = targetItemType.inlineContent ? targetItemType.create({}, decisionItem.children) : targetItemType.create({}, paragraphType.create({}, decisionItem.children));
            if (newItem) newItems.push(newItem);
        });
        const newList = targetListType.create({}, (0, $kW8qW.Fragment).from(newItems));
        return newList || node;
    });
};

});

parcelRegister("3CF1U", function(module, exports) {
$parcel$export(module.exports, "flattenListStep", () => $3fe7da5063642647$export$74774d2fcc242aef);

var $kW8qW = parcelRequire("kW8qW");

var $7onAs = parcelRequire("7onAs");
const $3fe7da5063642647$var$extractNestedLists = (node, schema, includeBlockTaskItems)=>{
    const items = [];
    const paragraph = schema.nodes.paragraph;
    const itemTypes = [
        schema.nodes.listItem,
        schema.nodes.taskItem,
        schema.nodes.decisionItem
    ];
    if (includeBlockTaskItems && schema.nodes.blockTaskItem) itemTypes.push(schema.nodes.blockTaskItem);
    const extract = (currentNode)=>{
        currentNode.forEach((child)=>{
            if (itemTypes.some((type)=>child.type === type)) {
                const contentWithoutNestedLists = [];
                const nestedLists = [];
                // Check if this item type expects inline content (taskItem, decisionItem)
                // vs block content (listItem) based on the schema definition
                const isInlineItem = child.type.inlineContent;
                child.forEach((grandChild)=>{
                    if ((0, $7onAs.isListWithIndentation)(grandChild.type.name, schema)) nestedLists.push(grandChild);
                    else if (grandChild.isInline) {
                        // For taskItem/decisionItem, keep text as-is (they support inline content)
                        // For listItem, wrap text in paragraph (they require block content)
                        if (isInlineItem) contentWithoutNestedLists.push(grandChild);
                        else contentWithoutNestedLists.push(paragraph.createAndFill({}, grandChild));
                    } else contentWithoutNestedLists.push(grandChild);
                });
                items.push(child.copy((0, $kW8qW.Fragment).from(contentWithoutNestedLists)));
                nestedLists.forEach((nestedList)=>{
                    extract(nestedList);
                });
            } else if ((0, $7onAs.isListWithIndentation)(child.type.name, schema)) extract(child);
        });
    };
    extract(node);
    return items;
};
const $3fe7da5063642647$export$74774d2fcc242aef = (nodes, context)=>{
    return nodes.map((node)=>{
        if ((0, $7onAs.isListWithIndentation)(node.type.name, context.schema)) return node.copy((0, $kW8qW.Fragment).from($3fe7da5063642647$var$extractNestedLists(node, context.schema, Boolean(context.includeBlockTaskItems))));
        return node;
    });
};

});
parcelRegister("7onAs", function(module, exports) {
$parcel$export(module.exports, "isListWithIndentation", () => $ea7f7c493261a767$export$a821b73688083c0);
$parcel$export(module.exports, "isListWithTextContentOnly", () => $ea7f7c493261a767$export$21440f5b448ca9f3);
const $ea7f7c493261a767$export$a821b73688083c0 = (nodeTypeName, schema)=>{
    const lists = [
        schema.nodes.taskList,
        schema.nodes.bulletList,
        schema.nodes.orderedList
    ];
    return lists.some((list)=>list.name === nodeTypeName);
};
const $ea7f7c493261a767$export$21440f5b448ca9f3 = (nodeTypeName, schema)=>{
    const lists = [
        schema.nodes.taskList,
        schema.nodes.decisionList
    ];
    return lists.some((list)=>list.name === nodeTypeName);
};

});


parcelRegister("hi0NR", function(module, exports) {
$parcel$export(module.exports, "flattenStep", () => $e1c2ef71a3a461f8$export$2d058988e0d92b68);
const $e1c2ef71a3a461f8$export$2d058988e0d92b68 = (nodes, context)=>{
    const { schema: schema, targetNodeTypeName: targetNodeTypeName } = context;
    const { paragraph: paragraph } = schema.nodes;
    const targetNodeType = schema.nodes[targetNodeTypeName];
    if (!targetNodeType || !paragraph) return nodes;
    return nodes.map((node)=>{
        const isValidWithin = targetNodeType.validContent(node.content);
        if (!isValidWithin) return node;
        return paragraph.create({}, node.content, node.marks);
    });
};

});

parcelRegister("bxbn6", function(module, exports) {
$parcel$export(module.exports, "listToDecisionListStep", () => $7b91bf359d11b0d0$export$e95e25b492330619);

var $7onAs = parcelRequire("7onAs");
const $7b91bf359d11b0d0$export$e95e25b492330619 = (nodes, context)=>{
    const { schema: schema } = context;
    const paragraphType = schema.nodes.paragraph;
    const unsupportedContent = [];
    const transformedNodes = nodes.map((node)=>{
        if (!(0, $7onAs.isListWithIndentation)(node.type.name, schema)) return node;
        const decisionItems = [];
        node.forEach((item)=>{
            const itemContent = [];
            item.forEach((child)=>{
                if (child.type === paragraphType) // paragraph may contain hard breaks etc.
                itemContent.push(...child.children);
                else if (child.isInline) itemContent.push(child);
                else if (!(0, $7onAs.isListWithIndentation)(child.type.name, schema)) unsupportedContent.push(child);
            });
            const decisionItem = schema.nodes.decisionItem.create({}, itemContent);
            decisionItems.push(decisionItem);
        });
        const decisionList = schema.nodes.decisionList.create({}, decisionItems);
        return decisionList || node;
    });
    return [
        ...transformedNodes,
        ...unsupportedContent
    ];
};

});

parcelRegister("eGbd2", function(module, exports) {
$parcel$export(module.exports, "listToListStep", () => $6065d797aa372b60$export$46abc3e1699028ef);

var $kYtKJ = parcelRequire("kYtKJ");

var $kW8qW = parcelRequire("kW8qW");

var $7onAs = parcelRequire("7onAs");
/**
 * Recursively converts nested lists to the target list type.
 * This function handles the conversion of both the list container and its items,
 * including any nested lists within those items.
 *
 * Important: taskList has a different nesting structure than bulletList/orderedList:
 * - taskList: nested taskLists are SIBLINGS of taskItems in the parent taskList
 * - bulletList/orderedList: nested lists are CHILDREN of listItems
 */ const $6065d797aa372b60$var$transformList = (node, targetListType, targetItemType, unsupportedContent)=>{
    const schema = node.type.schema;
    const taskListType = schema.nodes.taskList;
    const isSourceTaskList = node.type === taskListType;
    const isTargetTaskList = targetListType === taskListType.name;
    const convertFromTaskListStructure = (node, targetListType, targetItemType)=>{
        const schema = node.type.schema;
        const targetListNodeType = schema.nodes[targetListType];
        const transformedContent = [];
        node.forEach((child)=>{
            if ((0, $7onAs.isListWithIndentation)(child.type.name, schema)) // This is a nested list - it should become a child of the previous item
            {
                if (transformedContent.length > 0) {
                    const previousItem = transformedContent[transformedContent.length - 1];
                    // Convert the nested list and add it to the previous item's content
                    const transformedNestedList = $6065d797aa372b60$var$transformList(child, targetListType, targetItemType, unsupportedContent);
                    const newContent = previousItem.content.append((0, $kW8qW.Fragment).from([
                        transformedNestedList
                    ]));
                    const updatedItem = previousItem.type.create(previousItem.attrs, newContent);
                    transformedContent[transformedContent.length - 1] = updatedItem;
                }
            } else {
                const transformedItem = transformListItem(child, targetListType, targetItemType);
                if (transformedItem) transformedContent.push(transformedItem);
            }
        });
        return targetListNodeType.create(node.attrs, transformedContent);
    };
    const convertToTaskListStructure = (node, targetListType, targetItemType)=>{
        const schema = node.type.schema;
        const targetListNodeType = schema.nodes[targetListType];
        const transformedContent = [];
        node.forEach((itemNode)=>{
            const transformedItem = transformListItem(itemNode, targetListType, targetItemType, true);
            if (transformedItem) transformedContent.push(transformedItem);
            itemNode.forEach((child)=>{
                if ((0, $7onAs.isListWithIndentation)(child.type.name, schema)) transformedContent.push($6065d797aa372b60$var$transformList(child, targetListType, targetItemType, unsupportedContent));
            });
        });
        return targetListNodeType.create(node.attrs, transformedContent);
    };
    const transformListItem = (itemNode, targetListType, targetItemType, excludeNestedLists = false)=>{
        const schema = itemNode.type.schema;
        const targetItemNodeType = schema.nodes[targetItemType];
        const isTargetTaskItem = targetItemType === 'taskItem';
        const isSourceTaskItem = itemNode.type.name === 'taskItem';
        const paragraphType = schema.nodes.paragraph;
        if (isTargetTaskItem) {
            const inlineContent = [];
            let blockMarks = itemNode.marks;
            itemNode.forEach((child)=>{
                if (child.type === paragraphType) {
                    inlineContent.push(...child.children);
                    if (child.marks.length > 0) blockMarks = child.marks;
                } else if (child.isInline) inlineContent.push(child);
                else if (!(0, $7onAs.isListWithIndentation)(child.type.name, schema)) unsupportedContent.push(child);
            });
            const { blockTaskItem: blockTaskItem } = schema.nodes;
            if (blockTaskItem && blockMarks.length > 0) return (0, $kYtKJ.createBlockTaskItem)({
                content: inlineContent,
                marks: blockMarks,
                schema: schema
            });
            return targetItemNodeType.create({}, inlineContent);
        }
        const transformedContent = [];
        if (isSourceTaskItem) transformedContent.push(paragraphType.create(null, itemNode.content));
        else itemNode.forEach((child)=>{
            if ((0, $7onAs.isListWithIndentation)(child.type.name, schema)) {
                if (excludeNestedLists) // Skip nested lists - they will be handled separately as siblings
                return;
                transformedContent.push($6065d797aa372b60$var$transformList(child, targetListType, targetItemType, unsupportedContent));
            } else transformedContent.push(child);
        });
        if (transformedContent.length === 0) transformedContent.push(paragraphType.create());
        return targetItemNodeType.create({}, transformedContent);
    };
    const convertList = (node, schema, targetListType, targetItemType)=>{
        const targetListNodeType = schema.nodes[targetListType];
        const transformedContent = [];
        node.forEach((childNode)=>{
            const transformedItem = (0, $7onAs.isListWithIndentation)(childNode.type.name, schema) ? $6065d797aa372b60$var$transformList(childNode, targetListType, targetItemType, unsupportedContent) : transformListItem(childNode, targetListType, targetItemType);
            if (transformedItem) transformedContent.push(transformedItem);
        });
        return targetListNodeType.create(node.attrs, transformedContent);
    };
    if (isSourceTaskList && !isTargetTaskList) return convertFromTaskListStructure(node, targetListType, targetItemType);
    else if (!isSourceTaskList && isTargetTaskList) return convertToTaskListStructure(node, targetListType, targetItemType);
    return convertList(node, schema, targetListType, targetItemType);
};
const $6065d797aa372b60$export$46abc3e1699028ef = (nodes, context)=>{
    const { schema: schema, targetNodeTypeName: targetNodeTypeName } = context;
    const unsupportedContent = [];
    const transformedNodes = nodes.map((node)=>{
        if ((0, $7onAs.isListWithIndentation)(node.type.name, schema)) {
            const targetItemType = targetNodeTypeName === 'taskList' ? 'taskItem' : 'listItem';
            return $6065d797aa372b60$var$transformList(node, targetNodeTypeName, targetItemType, unsupportedContent);
        }
        return node;
    });
    return [
        ...transformedNodes,
        ...unsupportedContent
    ];
};

});

parcelRegister("6j8P7", function(module, exports) {
$parcel$export(module.exports, "mergeNeighbourListsStep", () => $425690cc2b62723c$export$6dc131b629e53cb8);

var $7onAs = parcelRequire("7onAs");
const $425690cc2b62723c$export$6dc131b629e53cb8 = (nodes, context)=>{
    if (nodes.length === 0) return nodes;
    const { schema: schema } = context;
    const resultNodes = [];
    let currentList = null;
    // Check if a node is any type of list (including decisionList)
    const isList = (node)=>{
        return (0, $7onAs.isListWithIndentation)(node.type.name, schema) || node.type.name === 'decisionList';
    };
    for (const node of nodes)// Check if this node is any type of list
    if (isList(node)) {
        if (currentList && currentList.type === node.type) {
            // Merge with the current list by combining their children
            const mergedContent = currentList.content.append(node.content);
            currentList = currentList.type.create(currentList.attrs, mergedContent);
        } else {
            // Start a new list or switch to a different list type
            if (currentList) resultNodes.push(currentList);
            currentList = node;
        }
    } else {
        // Non-list node - push any accumulated list and then this node
        if (currentList) {
            resultNodes.push(currentList);
            currentList = null;
        }
        resultNodes.push(node);
    }
    // Don't forget the last list if we ended with one
    if (currentList) resultNodes.push(currentList);
    return resultNodes;
};

});

parcelRegister("kiPNO", function(module, exports) {
$parcel$export(module.exports, "unwrapExpandStep", () => $8aab68c09fabcbdd$export$c0de2fe9771a255e);

var $i78ce = parcelRequire("i78ce");

var $fn1ry = parcelRequire("fn1ry");
const $8aab68c09fabcbdd$export$c0de2fe9771a255e = (nodes, context)=>{
    const { schema: schema } = context;
    const outputNodes = [];
    const { expand: expand, nestedExpand: nestedExpand } = schema.nodes;
    nodes.forEach((node)=>{
        const isExpand = node.type.name === expand.name || node.type.name === nestedExpand.name;
        if (isExpand) {
            var _node$attrs;
            const title = (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.title;
            // Create a paragraph from the title if it exists
            if (title) {
                const titleParagraph = schema.nodes.paragraph.createAndFill({}, schema.text(title));
                if (titleParagraph) outputNodes.push(titleParagraph);
            }
            // Add the children, converting any nestedExpands to regular expands
            // since nestedExpand can only exist inside an expand
            node.children.forEach((child)=>{
                if (child.type.name === nestedExpand.name) {
                    const expandNode = (0, $i78ce.convertNestedExpandToExpand)(child, schema);
                    if (expandNode) outputNodes.push(expandNode);
                    else outputNodes.push(child);
                } else outputNodes.push(child);
            });
        } else (0, $fn1ry.unwrapStep)([
            node
        ], context);
    });
    return outputNodes;
};

});
parcelRegister("fn1ry", function(module, exports) {
$parcel$export(module.exports, "unwrapStep", () => $688e49639920936f$export$7583c29c75ec1903);
const $688e49639920936f$export$7583c29c75ec1903 = (nodes)=>{
    const outputNodes = [];
    nodes.forEach((node)=>{
        // we may want to just skip the original instead of using it
        if (node.children.length === 0) outputNodes.push(node);
        else outputNodes.push(...node.children);
    });
    return outputNodes;
};

});


parcelRegister("1LZnC", function(module, exports) {
$parcel$export(module.exports, "unwrapLayoutStep", () => $6b535db6f273df82$export$54edaa1aeed2418a);
const $6b535db6f273df82$export$54edaa1aeed2418a = (nodes)=>{
    const outputNodes = [];
    nodes.forEach((node)=>{
        const isLayoutSection = node.type.name === 'layoutSection';
        if (isLayoutSection) node.children.forEach((column)=>{
            const isLayoutColumn = column.type.name === 'layoutColumn';
            if (isLayoutColumn) outputNodes.push(...column.children);
        });
    });
    if (outputNodes.length === 0) return nodes;
    return outputNodes;
};

});

parcelRegister("jY7Ey", function(module, exports) {
$parcel$export(module.exports, "unwrapListStep", () => $368f065b4ee42fa8$export$503819a1224039d8);
const $368f065b4ee42fa8$export$503819a1224039d8 = (nodes, context)=>{
    const listTypes = [
        context.schema.nodes.bulletList,
        context.schema.nodes.orderedList,
        context.schema.nodes.taskList,
        context.schema.nodes.decisionList
    ];
    return nodes.flatMap((node)=>{
        if (listTypes.some((type)=>node.type === type)) {
            const listItems = [];
            node.forEach((listItem)=>{
                // if isTaskItem or isDecisionItem, convert to paragraph
                if (listItem.type.name === 'taskItem' || listItem.type.name === 'decisionItem') listItems.push(context.schema.nodes.paragraph.create({}, listItem.content));
                else listItems.push(...listItem.children);
            });
            return listItems;
        }
        return node;
    });
};

});

parcelRegister("70IWl", function(module, exports) {
$parcel$export(module.exports, "wrapBlockquoteToDecisionListStep", () => $5455a345e4785dd6$export$90c0437e8a9cfef9);

var $i78ce = parcelRequire("i78ce");
/**
 * Creates a decisionItem with the given inline content.
 */ const $5455a345e4785dd6$var$createDecisionItem = (inlineContent, schema)=>{
    const decisionItemType = schema.nodes.decisionItem;
    if (!decisionItemType) return null;
    const canContentBeWrappedInDecisionItem = decisionItemType.validContent(inlineContent);
    // Check if the content is valid for decisionItem
    if (!canContentBeWrappedInDecisionItem) return null;
    return decisionItemType.createAndFill({}, inlineContent);
};
/**
 * Creates a decisionList containing the given decisionItems.
 */ const $5455a345e4785dd6$var$createDecisionListWithItems = (decisionItems, schema)=>{
    const decisionListType = schema.nodes.decisionList;
    if (!decisionListType || decisionItems.length === 0) return null;
    return decisionListType.createAndFill({}, decisionItems);
};
const $5455a345e4785dd6$export$90c0437e8a9cfef9 = (nodes, context)=>{
    const { schema: schema } = context;
    const decisionItemType = schema.nodes.decisionItem;
    if (!decisionItemType) return nodes;
    const result = [];
    let currentDecisionItems = [];
    const flushCurrentDecisionList = ()=>{
        if (currentDecisionItems.length > 0) {
            const decisionList = $5455a345e4785dd6$var$createDecisionListWithItems(currentDecisionItems, schema);
            if (decisionList) result.push(decisionList);
            currentDecisionItems = [];
        }
    };
    nodes.forEach((node)=>{
        const decisionItem = (0, $i78ce.isTextNode)(node) ? $5455a345e4785dd6$var$createDecisionItem(node.content, schema) : null;
        if (decisionItem) // Accumulate consecutive decisionItems
        currentDecisionItems.push(decisionItem);
        else {
            // Content can't be wrapped in decisionItem - break out the node
            flushCurrentDecisionList();
            result.push(node);
        }
    });
    // Flush any remaining decisionItems
    flushCurrentDecisionList();
    return result.length > 0 ? result : nodes;
};

});

parcelRegister("bBQWi", function(module, exports) {
$parcel$export(module.exports, "wrapIntoListStep", () => $7b0b5f27cfe94bc7$export$d3906b3c22029af7);

var $7onAs = parcelRequire("7onAs");

var $i78ce = parcelRequire("i78ce");
const $7b0b5f27cfe94bc7$var$wrapIntoTaskOrDecisionList = (nodes, targetNodeTypeName, schema)=>{
    const itemNodeType = targetNodeTypeName === 'taskList' ? schema.nodes.taskItem : schema.nodes.decisionItem;
    const inlineContent = nodes.flatMap((node)=>{
        if (node.isTextblock) return node.children;
        else if (node.isText) return [
            node
        ];
        return [];
    });
    const itemNode = itemNodeType.create({}, inlineContent);
    const outputNode = schema.nodes[targetNodeTypeName].createAndFill({}, itemNode);
    return outputNode ? [
        outputNode
    ] : nodes;
};
const $7b0b5f27cfe94bc7$var$wrapIntoBulletOrOrderedList = (nodes, targetNodeTypeName, schema)=>{
    const listItemNodes = nodes.map((node)=>schema.nodes.listItem.createAndFill({}, node.isTextblock ? (0, $i78ce.convertTextNodeToParagraph)(node, schema) : node)).filter((node)=>node !== null);
    if (listItemNodes.length === 0) return nodes;
    const outputNode = schema.nodes[targetNodeTypeName].createAndFill({}, listItemNodes);
    return outputNode ? [
        outputNode
    ] : nodes;
};
const $7b0b5f27cfe94bc7$export$d3906b3c22029af7 = (nodes, context)=>{
    const { schema: schema, targetNodeTypeName: targetNodeTypeName } = context;
    return (0, $7onAs.isListWithTextContentOnly)(targetNodeTypeName, schema) ? $7b0b5f27cfe94bc7$var$wrapIntoTaskOrDecisionList(nodes, targetNodeTypeName, schema) : $7b0b5f27cfe94bc7$var$wrapIntoBulletOrOrderedList(nodes, targetNodeTypeName, schema);
};

});

parcelRegister("9kjFX", function(module, exports) {
$parcel$export(module.exports, "wrapMixedContentStep", () => $0dd1df92117a923d$export$46a3aa15af7139ee);

var $3J3tU = parcelRequire("3J3tU");

var $7zYtf = parcelRequire("7zYtf");
var $30RfR = parcelRequire("30RfR");

var $kW8qW = parcelRequire("kW8qW");

var $3y2s4 = parcelRequire("3y2s4");

var $5N1Y4 = parcelRequire("5N1Y4");

var $zxPJU = parcelRequire("zxPJU");

var $aBMtz = parcelRequire("aBMtz");

var $i78ce = parcelRequire("i78ce");
/**
 * Creates a layout section with two columns, where the first column contains the provided content.
 * Preserves breakout marks if provided.
 */ const $0dd1df92117a923d$var$createLayoutSection = (content, layoutSection, layoutColumn, marks)=>{
    const columnOne = layoutColumn.createAndFill({}, (0, $zxPJU.removeDisallowedMarks)(content, layoutColumn));
    const columnTwo = layoutColumn.createAndFill();
    if (!columnOne || !columnTwo) return null;
    return layoutSection.createAndFill({}, [
        columnOne,
        columnTwo
    ], marks);
};
/**
 * Creates a container with text content (for codeblocks).
 */ const $0dd1df92117a923d$var$createTextContentContainer = (textContentArray, targetNodeType, schema)=>{
    const textContent = textContentArray.join('\n');
    const textNode = textContent ? schema.text(textContent) : null;
    const attrs = targetNodeType.name === 'codeBlock' ? (0, $3J3tU.getDefaultCodeBlockAttrs)() : {};
    return targetNodeType.createAndFill(attrs, textNode);
};
/**
 * Creates a regular container with node content.
 */ const $0dd1df92117a923d$var$createNodeContentContainer = (nodeContent, targetNodeType)=>{
    const isExpandType = targetNodeType.name === 'expand' || targetNodeType.name === 'nestedExpand';
    const nodeAttrs = isExpandType ? {
        localId: crypto.randomUUID()
    } : {};
    return targetNodeType.createAndFill(nodeAttrs, nodeContent);
};
/**
 * Handles the edge case where transforming from a container to another container results in
 * all content breaking out (no valid children for the target). In this case, creates an empty
 * container to ensure the target container type is created.
 *
 * We can determine if there were no valid children by checking if no container was created
 * (`!hasCreatedContainer`) and there are nodes in the result (`result.length > 0`), which
 * means all content broke out rather than being wrapped.
 *
 * @param result - The current result nodes after processing
 * @param hasCreatedContainer - Whether a container was already created during processing
 * @param fromNode - The original source node (before unwrapping)
 * @param targetNodeType - The target container type
 * @param targetNodeTypeName - The target container type name
 * @param schema - The schema
 * @returns The result nodes with an empty container prepended if needed, or the original result
 */ const $0dd1df92117a923d$var$handleEmptyContainerEdgeCase = (result, hasCreatedContainer, fromNode, targetNodeType, targetNodeTypeName, schema)=>{
    const isFromContainer = (0, $aBMtz.NODE_CATEGORY_BY_TYPE)[fromNode.type.name] === 'container';
    const isTargetContainer = (0, $aBMtz.NODE_CATEGORY_BY_TYPE)[targetNodeTypeName] === 'container';
    // If no container was created but we have nodes in result, all content broke out
    // (meaning there were no valid children that could be wrapped)
    const allContentBrokeOut = !hasCreatedContainer && result.length > 0;
    const shouldCreateEmptyTarget = isFromContainer && isTargetContainer && allContentBrokeOut;
    if (!shouldCreateEmptyTarget) return result;
    if (targetNodeTypeName === schema.nodes.codeBlock.name) {
        const emptyCodeBlock = $0dd1df92117a923d$var$createTextContentContainer([], schema.nodes.codeBlock, schema);
        return emptyCodeBlock ? [
            emptyCodeBlock,
            ...result
        ] : result;
    }
    const emptyParagraph = schema.nodes.paragraph.create();
    const isExpandType = targetNodeTypeName === 'expand' || targetNodeTypeName === 'nestedExpand';
    const emptyContainerAttrs = isExpandType ? {
        localId: crypto.randomUUID()
    } : {};
    const emptyContainer = targetNodeType.create(emptyContainerAttrs, emptyParagraph);
    return [
        emptyContainer,
        ...result
    ];
};
const $0dd1df92117a923d$export$46a3aa15af7139ee = (nodes, context)=>{
    const { schema: schema, targetNodeTypeName: targetNodeTypeName, fromNode: fromNode } = context;
    const targetNodeType = schema.nodes[targetNodeTypeName];
    if (!targetNodeType) return nodes;
    const isLayout = targetNodeTypeName === 'layoutSection';
    const isCodeblock = targetNodeTypeName === 'codeBlock';
    const { layoutSection: layoutSection, layoutColumn: layoutColumn } = schema.nodes;
    let breakoutResizableNodesList = [];
    if ((0, $3y2s4.isExperimentEnabled)('platform_editor_lovability_resize_extensions')) {
        breakoutResizableNodesList = (0, $30RfR.getBreakoutResizableNodes)();
        // rule is NOT a supported transform source/target
        breakoutResizableNodesList = breakoutResizableNodesList.filter((node)=>node !== 'rule');
    } else breakoutResizableNodesList = (0, $5N1Y4.expValEquals)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true) ? [
        ...(0, $7zYtf.breakoutResizableNodes),
        'panel'
    ] : (0, $7zYtf.breakoutResizableNodes);
    const sourceSupportsBreakout = breakoutResizableNodesList.includes(fromNode.type.name);
    const targetSupportsBreakout = breakoutResizableNodesList.includes(targetNodeTypeName);
    const shouldPreserveBreakout = sourceSupportsBreakout && targetSupportsBreakout;
    let breakoutMark;
    if (shouldPreserveBreakout) breakoutMark = fromNode.marks.find((mark)=>mark.type.name === 'breakout');
    const result = [];
    let currentContainerContent = [];
    let hasCreatedContainer = false;
    const flushCurrentContainer = ()=>{
        if (currentContainerContent.length === 0) return;
        let container = null;
        if (isLayout) container = $0dd1df92117a923d$var$createLayoutSection(currentContainerContent, layoutSection, layoutColumn, breakoutMark ? [
            breakoutMark
        ] : undefined);
        else if (isCodeblock) container = $0dd1df92117a923d$var$createTextContentContainer(currentContainerContent, targetNodeType, schema);
        else container = $0dd1df92117a923d$var$createNodeContentContainer(currentContainerContent, targetNodeType);
        if (container) {
            result.push(container);
            hasCreatedContainer = true;
        }
        currentContainerContent = [];
    };
    const canNodeBeWrapped = (node)=>{
        const validationType = isLayout ? layoutColumn : targetNodeType;
        return validationType.validContent((0, $kW8qW.Fragment).from((0, $zxPJU.removeDisallowedMarks)([
            node
        ], validationType)));
    };
    const handleWrappableNode = (node)=>{
        const validationType = isLayout ? layoutColumn : targetNodeType;
        currentContainerContent.push(...(0, $zxPJU.removeDisallowedMarks)([
            node
        ], validationType));
    };
    const handleCodeblockTextNode = (node)=>{
        currentContainerContent.push((0, $i78ce.createTextContent)(node));
    };
    const handleConvertibleTextNode = (node)=>{
        const paragraph = (0, $i78ce.convertTextNodeToParagraph)(node, schema);
        if (paragraph) currentContainerContent.push(paragraph);
    };
    const handleUnsupportedNode = (node)=>{
        flushCurrentContainer();
        result.push(node);
    };
    const processNode = (node)=>{
        if (canNodeBeWrapped(node)) {
            handleWrappableNode(node);
            return;
        }
        if ((0, $i78ce.isTextNode)(node) && isCodeblock) {
            handleCodeblockTextNode(node);
            return;
        }
        if ((0, $i78ce.isTextNode)(node)) {
            handleConvertibleTextNode(node);
            return;
        }
        // All other nodes that cannot be wrapped in the target node - break out
        // Examples: same-type containers, layoutSections in layouts
        handleUnsupportedNode(node);
    };
    nodes.forEach(processNode);
    flushCurrentContainer();
    if (isLayout) return result.length > 0 ? result : nodes;
    const finalResult = $0dd1df92117a923d$var$handleEmptyContainerEdgeCase(result, hasCreatedContainer, fromNode, targetNodeType, targetNodeTypeName, schema);
    return finalResult.length > 0 ? finalResult : nodes;
};

});
parcelRegister("zxPJU", function(module, exports) {
$parcel$export(module.exports, "removeDisallowedMarks", () => $75040ad8bc262faa$export$1b4937b79128e5f7);
const $75040ad8bc262faa$export$1b4937b79128e5f7 = (nodes, targetNode)=>{
    return nodes.map((node)=>node.mark(targetNode.allowedMarks(node.marks)));
};

});


parcelRegister("e2ewP", function(module, exports) {
$parcel$export(module.exports, "wrapStep", () => $c487901a07211d06$export$4465c5391021ef03);

var $3J3tU = parcelRequire("3J3tU");

var $7zYtf = parcelRequire("7zYtf");
var $30RfR = parcelRequire("30RfR");

var $3y2s4 = parcelRequire("3y2s4");

var $5N1Y4 = parcelRequire("5N1Y4");

var $zxPJU = parcelRequire("zxPJU");

var $i78ce = parcelRequire("i78ce");
const $c487901a07211d06$export$4465c5391021ef03 = (nodes, context)=>{
    const { schema: schema, targetNodeTypeName: targetNodeTypeName, fromNode: fromNode } = context;
    // When wrapping into expand, convert any expand children to nestedExpand
    // since expand cannot be a direct child of expand
    let processedNodes = nodes;
    if (targetNodeTypeName === 'expand') processedNodes = nodes.map((node)=>{
        if (node.type.name === 'expand') {
            const nestedExpandNode = (0, $i78ce.convertExpandToNestedExpand)(node, schema);
            return nestedExpandNode ?? node;
        }
        return node;
    });
    const targetNodeType = schema.nodes[targetNodeTypeName];
    const isExpandType = targetNodeTypeName === 'expand' || targetNodeTypeName === 'nestedExpand';
    const isCodeBlock = targetNodeTypeName === 'codeBlock';
    const nodeAttrs = isExpandType ? {
        localId: crypto.randomUUID()
    } : isCodeBlock ? (0, $3J3tU.getDefaultCodeBlockAttrs)() : {};
    let breakoutResizableNodesList = [];
    if ((0, $3y2s4.isExperimentEnabled)('platform_editor_lovability_resize_extensions')) {
        breakoutResizableNodesList = (0, $30RfR.getBreakoutResizableNodes)();
        // rule is NOT a supported transform source/target
        breakoutResizableNodesList = breakoutResizableNodesList.filter((node)=>node !== 'rule');
    } else breakoutResizableNodesList = (0, $5N1Y4.expValEquals)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true) ? [
        ...(0, $7zYtf.breakoutResizableNodes),
        'panel'
    ] : (0, $7zYtf.breakoutResizableNodes);
    const sourceSupportsBreakout = breakoutResizableNodesList.includes(fromNode.type.name);
    const targetSupportsBreakout = breakoutResizableNodesList.includes(targetNodeType.name);
    const shouldPreserveBreakout = sourceSupportsBreakout && targetSupportsBreakout;
    let marks;
    if (shouldPreserveBreakout) {
        const breakoutMark = fromNode.marks.find((mark)=>mark.type.name === 'breakout');
        if (breakoutMark) marks = [
            breakoutMark
        ];
    }
    const outputNode = targetNodeType.createAndFill(nodeAttrs, (0, $zxPJU.removeDisallowedMarks)(processedNodes, schema.nodes[targetNodeTypeName]), marks);
    return outputNode ? [
        outputNode
    ] : nodes;
};

});



parcelRegister("l57rz", function(module, exports) {
$parcel$export(module.exports, "getSingleTransformSourceNode", () => $cf0e1b759d9bb9b4$export$22e98634212ded94);
$parcel$export(module.exports, "isExtensionTransformSource", () => $cf0e1b759d9bb9b4$export$f6da6c72d387f4be);

var $i78ce = parcelRequire("i78ce");
const $cf0e1b759d9bb9b4$var$EXTENSION_NODE_TYPES = new Set([
    'extension',
    'bodiedExtension',
    'multiBodiedExtension'
]);
const $cf0e1b759d9bb9b4$export$22e98634212ded94 = (selection, range)=>{
    var _getSelectedNode;
    const selectedNode = (_getSelectedNode = (0, $i78ce.getSelectedNode)(selection)) === null || _getSelectedNode === void 0 ? void 0 : _getSelectedNode.node;
    if (selectedNode) return selectedNode;
    if (!range) return undefined;
    const blockNodes = (0, $i78ce.getBlockNodesInRange)(range);
    return blockNodes.length === 1 ? blockNodes[0] : undefined;
};
const $cf0e1b759d9bb9b4$export$f6da6c72d387f4be = (node)=>Boolean(node && $cf0e1b759d9bb9b4$var$EXTENSION_NODE_TYPES.has(node.type.name));

});


parcelRegister("vvZ9M", function(module, exports) {
$parcel$export(module.exports, "createBlockMenuTransformSourceRegistry", () => $ba0bbc1b3a24f053$export$a09812e9de333dc1);

var $j2Y9J = parcelRequire("j2Y9J");
const $ba0bbc1b3a24f053$export$a09812e9de333dc1 = ()=>{
    const transforms = new Map();
    return {
        register: (registeredTransforms)=>{
            const registered = [];
            registeredTransforms.forEach((transform)=>{
                if (transforms.has(transform.key)) {
                    (0, $j2Y9J.logException)(new Error(`Duplicate Block Menu transform key: ${transform.key}`), {
                        location: 'editor-plugin-block-menu'
                    });
                    return;
                }
                transforms.set(transform.key, transform);
                registered.push(transform);
            });
            if (registered.length === 0) return ()=>{};
            return ()=>{
                registered.forEach((transform)=>{
                    if (transforms.get(transform.key) === transform) transforms.delete(transform.key);
                });
            };
        },
        resolve: (context)=>{
            const transform = Array.from(transforms.values()).find(({ isSupported: isSupported })=>{
                try {
                    return isSupported(context);
                } catch (error) {
                    (0, $j2Y9J.logException)(error instanceof Error ? error : new Error('Block Menu transform support check failed'), {
                        location: 'editor-plugin-block-menu'
                    });
                    return false;
                }
            });
            return transform ? {
                status: 'supported',
                transform: transform
            } : {
                status: 'unsupported'
            };
        }
    };
};

});

parcelRegister("hj6cH", function(module, exports) {
$parcel$export(module.exports, "transformInlineNode", () => $3ce3b6c7d5f67a7d$export$a685a7d7dd697fc3);

var $951G5 = parcelRequire("951G5");

var $cw0wu = parcelRequire("cw0wu");

var $iLPdz = parcelRequire("iLPdz");

var $9R8u3 = parcelRequire("9R8u3");

var $dpwI7 = parcelRequire("dpwI7");
const $3ce3b6c7d5f67a7d$export$a685a7d7dd697fc3 = (api)=>(metadata)=>({ tr: tr })=>{
            var _api$blockControls;
            const preservedSelection = api === null || api === void 0 || (_api$blockControls = api.blockControls) === null || _api$blockControls === void 0 || (_api$blockControls = _api$blockControls.sharedState.currentState()) === null || _api$blockControls === void 0 ? void 0 : _api$blockControls.preservedSelection;
            if (!preservedSelection || !(preservedSelection instanceof (0, $cw0wu.NodeSelection))) return tr;
            const source = {
                node: preservedSelection.node,
                pos: preservedSelection.from
            };
            const analytics = (0, $dpwI7.createTransformAnalytics)(api, tr, preservedSelection);
            const measureId = `transformInlineNode_${metadata.targetTypeName}_${Date.now()}`;
            (0, $951G5.startMeasure)(measureId);
            const isParentLayout = tr.doc.resolve(source.pos).parent.type === tr.doc.type.schema.nodes.layoutColumn;
            const isNested = (0, $iLPdz.isNestedNode)(preservedSelection, '') && !isParentLayout;
            try {
                var _api$blockControls2, _api$blockControls3;
                const inlineNode = metadata.buildInlineNode(source.node);
                const paragraphNode = tr.doc.type.schema.nodes.paragraph.createChecked({}, [
                    inlineNode
                ]);
                tr.replaceWith(source.pos, source.pos + source.node.nodeSize, paragraphNode);
                if ((0, $cw0wu.NodeSelection).isSelectable(inlineNode)) tr.setSelection((0, $cw0wu.NodeSelection).create(tr.doc, source.pos + 1));
                api === null || api === void 0 || (_api$blockControls2 = api.blockControls) === null || _api$blockControls2 === void 0 || _api$blockControls2.commands.stopPreservingSelection()({
                    tr: tr
                });
                api === null || api === void 0 || (_api$blockControls3 = api.blockControls) === null || _api$blockControls3 === void 0 || _api$blockControls3.commands.toggleBlockMenu({
                    closeMenu: true
                })({
                    tr: tr
                });
                (0, $951G5.stopMeasure)(measureId, (duration, startTime)=>{
                    analytics.transformed(duration, startTime, {
                        isEmptyLine: (0, $9R8u3.isEmptyLine)([
                            source.node
                        ]),
                        isNested: isNested,
                        isSuggested: Boolean(metadata.isSuggested),
                        outputNodesCount: 1,
                        sourceNodes: [
                            source.node
                        ],
                        targetNodeType: metadata.targetTypeName
                    });
                });
            } catch (error) {
                (0, $951G5.stopMeasure)(measureId);
                analytics.errored(error, [
                    source.node
                ], metadata.targetTypeName);
            }
            return tr;
        };

});
parcelRegister("iLPdz", function(module, exports) {
$parcel$export(module.exports, "isNestedNode", () => $9e8d558895c96cda$export$721178bb4de8b79);

var $cw0wu = parcelRequire("cw0wu");

var $2E7OD = parcelRequire("2E7OD");
const $9e8d558895c96cda$export$721178bb4de8b79 = (selection, menuTriggerBy)=>{
    if (!selection) return false;
    const { $from: $from } = selection;
    const depth = $from.depth;
    // When a file is in card view, selection.$from has a depth of 1, but it is not a nested node, should return false
    if ($from.depth === 1 && selection instanceof (0, $cw0wu.NodeSelection) && selection.node.type.name === 'media' && selection.node.attrs.type === 'file') return false;
    if ($from.depth > 0 && selection instanceof (0, $cw0wu.NodeSelection)) return true;
    // Depth 0-1: Always top-level
    if (depth <= 1) return false;
    // Depth 4+: Always nested
    if (depth > 4) return true;
    // Special case for table selection
    if (selection instanceof (0, $2E7OD.CellSelection)) return depth > 3;
    // Check parent node type for depth 2-3
    const parentNode = $from.node(depth - 1);
    if (!parentNode) return true;
    const parentType = parentNode.type.name;
    const isTriggeredByBlockquote = menuTriggerBy.includes('blockquote');
    // Special cases where content is still top-level
    if (parentType === 'listItem' && depth === 3 || parentType === 'blockquote' && depth === 2 && isTriggeredByBlockquote || parentType === 'taskList' && depth === 2 || parentType === 'listItem' && depth === 4 && isTriggeredByBlockquote) return false;
    // Everything else at depth 2-3 is nested
    return true;
};

});

parcelRegister("9R8u3", function(module, exports) {
$parcel$export(module.exports, "isEmptyLine", () => $76740a77b002a338$export$6d64057b0e102f00);
const $76740a77b002a338$export$6d64057b0e102f00 = (sourceNodes)=>{
    if (sourceNodes.length !== 1) return false;
    const source = sourceNodes[0];
    const { heading: heading, paragraph: paragraph } = source.type.schema.nodes;
    return (source.type === paragraph || source.type === heading) && (source.content.size === 0 || source.textContent.trim() === '');
};

});

parcelRegister("dpwI7", function(module, exports) {
$parcel$export(module.exports, "createTransformAnalytics", () => $1b3b9784bdcf2dc1$export$aa709aa8b21709dc);

var $g6Qq4 = parcelRequire("g6Qq4");

var $j2Y9J = parcelRequire("j2Y9J");
const $1b3b9784bdcf2dc1$var$sourceTypeName = (sourceNodes)=>sourceNodes.length === 1 ? sourceNodes[0].type.name : 'multiple';
const $1b3b9784bdcf2dc1$var$sourceNodesCountByType = (sourceNodes)=>{
    const counts = {};
    for (const node of sourceNodes)counts[node.type.name] = (counts[node.type.name] || 0) + 1;
    return counts;
};
const $1b3b9784bdcf2dc1$export$aa709aa8b21709dc = (api, tr, selection)=>({
        transformed: (duration, startTime, { isEmptyLine: isEmptyLine = false, isNested: isNested, isSuggested: isSuggested = false, outputNodesCount: outputNodesCount, sourceNodes: sourceNodes, targetNodeType: targetNodeType })=>{
            var _api$analytics;
            api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || (_api$analytics = _api$analytics.actions) === null || _api$analytics === void 0 || _api$analytics.attachAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).TRANSFORMED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).ELEMENT,
                attributes: {
                    duration: duration,
                    isEmptyLine: isEmptyLine,
                    isNested: isNested,
                    isSuggested: isSuggested,
                    outputNodesCount: outputNodesCount,
                    sourceNodeType: $1b3b9784bdcf2dc1$var$sourceTypeName(sourceNodes),
                    sourceNodesCount: sourceNodes.length,
                    sourceNodesCountByType: $1b3b9784bdcf2dc1$var$sourceNodesCountByType(sourceNodes),
                    startTime: startTime,
                    targetNodeType: targetNodeType,
                    inputMethod: (0, $g6Qq4.INPUT_METHOD).BLOCK_MENU
                },
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
            })(tr);
        },
        errored: (error, sourceNodes, to)=>{
            var _api$analytics2;
            (0, $j2Y9J.logException)(error, {
                location: 'editor-plugin-block-menu'
            });
            api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 || (_api$analytics2 = _api$analytics2.actions) === null || _api$analytics2 === void 0 || _api$analytics2.attachAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).ERRORED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).ELEMENT,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).TRANSFORM,
                eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    docSize: tr.doc.nodeSize,
                    error: error.message,
                    errorStack: error.stack,
                    from: $1b3b9784bdcf2dc1$var$sourceTypeName(sourceNodes),
                    inputMethod: (0, $g6Qq4.INPUT_METHOD).BLOCK_MENU,
                    selection: selection.toJSON(),
                    to: to
                }
            })(tr);
        }
    });

});


parcelRegister("5hluS", function(module, exports) {
$parcel$export(module.exports, "transformNode", () => $2bc70c5bd4deb6de$export$eb9a5497877a817a);

var $eutMJ = parcelRequire("eutMJ");

var $951G5 = parcelRequire("951G5");

var $6Cbfp = parcelRequire("6Cbfp");

var $kW8qW = parcelRequire("kW8qW");

var $cw0wu = parcelRequire("cw0wu");

var $3DNV7 = parcelRequire("3DNV7");

var $2E7OD = parcelRequire("2E7OD");

var $3y2s4 = parcelRequire("3y2s4");

var $l57rz = parcelRequire("l57rz");

var $iLPdz = parcelRequire("iLPdz");

var $9R8u3 = parcelRequire("9R8u3");

var $dpwI7 = parcelRequire("dpwI7");

var $dOaWM = parcelRequire("dOaWM");

var $i78ce = parcelRequire("i78ce");
const $2bc70c5bd4deb6de$export$eb9a5497877a817a = (api, transformRegistry)=>(targetType, metadata)=>({ tr: tr })=>{
            var _api$blockControls;
            const preservedSelection = api === null || api === void 0 || (_api$blockControls = api.blockControls) === null || _api$blockControls === void 0 || (_api$blockControls = _api$blockControls.sharedState.currentState()) === null || _api$blockControls === void 0 ? void 0 : _api$blockControls.preservedSelection;
            if (!preservedSelection) return tr;
            const isSmallTextTransform = (metadata === null || metadata === void 0 ? void 0 : metadata.targetTypeName) === 'smallText';
            const isTextFormattingTransform = ((metadata === null || metadata === void 0 ? void 0 : metadata.marksToAdd) !== undefined || (metadata === null || metadata === void 0 ? void 0 : metadata.marksToRemove) !== undefined) && (0, $3y2s4.isExperimentEnabled)('platform_editor_block_menu_small_text');
            if (isSmallTextTransform && !isTextFormattingTransform) return null;
            const analytics = (0, $dpwI7.createTransformAnalytics)(api, tr, preservedSelection);
            const { $from: $from, $to: $to, range: range } = (0, $6Cbfp.expandSelectionToBlockRange)(preservedSelection);
            const sourceNode = (0, $l57rz.getSingleTransformSourceNode)(preservedSelection, range);
            if ((0, $l57rz.isExtensionTransformSource)(sourceNode)) {
                const context = {
                    source: sourceNode.toJSON(),
                    targetTypeName: (metadata === null || metadata === void 0 ? void 0 : metadata.targetTypeName) ?? targetType.name
                };
                const resolution = transformRegistry === null || transformRegistry === void 0 ? void 0 : transformRegistry.resolve(context);
                if (!resolution || resolution.status === 'unsupported') return tr;
                const measureId = `transformNode_${targetType.name}_${Date.now()}`;
                (0, $951G5.startMeasure)(measureId);
                try {
                    var _api$blockControls2, _api$blockControls3;
                    const transformResult = resolution.transform.transform(context);
                    if (!transformResult) {
                        (0, $951G5.stopMeasure)(measureId);
                        return tr;
                    }
                    if (!Array.isArray(transformResult.output) || transformResult.output.length === 0) throw new Error('Block menu transform returned no output');
                    const resultNodes = transformResult.output.map((nodeAdf)=>{
                        const node = (0, $kW8qW.Node).fromJSON(tr.doc.type.schema, nodeAdf);
                        node.check();
                        return node;
                    });
                    if (!range || !range.parent.canReplace(range.startIndex, range.endIndex, (0, $kW8qW.Fragment).from(resultNodes))) throw new Error('Block menu transform output is invalid at the selected position');
                    const sliceStart = $from.pos;
                    tr.replaceWith(sliceStart, $to.pos, resultNodes);
                    const insertedNode = tr.doc.nodeAt(sliceStart);
                    const nextSelection = insertedNode && (0, $cw0wu.NodeSelection).isSelectable(insertedNode) ? (0, $cw0wu.NodeSelection).create(tr.doc, sliceStart) : (0, $cw0wu.Selection).near(tr.doc.resolve(sliceStart));
                    tr.setSelection(nextSelection);
                    api === null || api === void 0 || (_api$blockControls2 = api.blockControls) === null || _api$blockControls2 === void 0 || _api$blockControls2.commands.stopPreservingSelection()({
                        tr: tr
                    });
                    api === null || api === void 0 || (_api$blockControls3 = api.blockControls) === null || _api$blockControls3 === void 0 || _api$blockControls3.commands.toggleBlockMenu({
                        closeMenu: true
                    })({
                        tr: tr
                    });
                    const { expand: expand, nestedExpand: nestedExpand } = tr.doc.type.schema.nodes;
                    resultNodes.forEach((node)=>{
                        if (node.type === expand || node.type === nestedExpand) (0, $eutMJ.expandedState).set(node, true);
                    });
                    (0, $951G5.stopMeasure)(measureId, (duration, startTime)=>{
                        analytics.transformed(duration, startTime, {
                            isNested: (0, $iLPdz.isNestedNode)(preservedSelection, ''),
                            isSuggested: Boolean(metadata === null || metadata === void 0 ? void 0 : metadata.isSuggested),
                            outputNodesCount: resultNodes.length,
                            sourceNodes: [
                                sourceNode
                            ],
                            targetNodeType: targetType.name
                        });
                    });
                } catch (error) {
                    (0, $951G5.stopMeasure)(measureId);
                    analytics.errored(error, [
                        sourceNode
                    ], targetType.name);
                }
                return tr;
            }
            const measureId = `transformNode_${targetType.name}_${Date.now()}`;
            (0, $951G5.startMeasure)(measureId);
            const docBeforeTransform = tr.doc;
            const { nodes: nodes } = tr.doc.type.schema;
            const selectedParent = $from.parent;
            const isParentLayout = selectedParent.type === nodes.layoutColumn;
            const isNested = (0, $iLPdz.isNestedNode)(preservedSelection, '') && !isParentLayout;
            const isList = (0, $i78ce.isListNode)(selectedParent);
            const sourceNodes = (0, $6Cbfp.getSourceNodesFromSelectionRange)(tr, preservedSelection);
            const isSuggested = Boolean(metadata === null || metadata === void 0 ? void 0 : metadata.isSuggested);
            try {
                var _api$blockControls6;
                const resultNodes = (0, $dOaWM.convertNodesToTargetType)({
                    sourceNodes: sourceNodes,
                    targetNodeType: targetType,
                    schema: tr.doc.type.schema,
                    isNested: isNested,
                    targetAttrs: metadata === null || metadata === void 0 ? void 0 : metadata.targetAttrs,
                    marksToAdd: isTextFormattingTransform ? metadata === null || metadata === void 0 ? void 0 : metadata.marksToAdd : undefined,
                    marksToRemove: isTextFormattingTransform ? metadata === null || metadata === void 0 ? void 0 : metadata.marksToRemove : undefined,
                    parentNode: selectedParent
                });
                const content = resultNodes.length > 0 ? resultNodes : sourceNodes;
                const sliceStart = isList ? $from.pos - 1 : $from.pos;
                const { expand: expand, nestedExpand: nestedExpand } = nodes;
                content.forEach((node)=>{
                    if (node.type === expand || node.type === nestedExpand) (0, $eutMJ.expandedState).set(node, true);
                });
                if (preservedSelection instanceof (0, $cw0wu.NodeSelection) && preservedSelection.node.type === nodes.mediaSingle) {
                    var _api$blockControls4;
                    // when node is media single, use tr.replaceWith freeze editor, if modify position, tr.replaceWith creates duplicats
                    const deleteFrom = $from.pos;
                    const deleteTo = $to.pos;
                    tr.delete(deleteFrom, deleteTo);
                    // After deletion, recalculate the insertion position to ensure it's valid
                    // especially when mediaSingle with caption is at the bottom of the document
                    const insertPos = Math.min(deleteFrom, tr.doc.content.size);
                    tr.insert(insertPos, content);
                    // when we replace and insert content, we need to manually map the preserved selection
                    // through the transaction, otherwise it will treat the selection as having been deleted
                    // and stop preserving it
                    const oldSize = sourceNodes.reduce((sum, node)=>sum + node.nodeSize, 0);
                    const newSize = content.reduce((sum, node)=>sum + node.nodeSize, 0);
                    api === null || api === void 0 || (_api$blockControls4 = api.blockControls) === null || _api$blockControls4 === void 0 || _api$blockControls4.commands.mapPreservedSelection(new (0, $3DNV7.Mapping)([
                        new (0, $3DNV7.StepMap)([
                            0,
                            oldSize,
                            newSize
                        ])
                    ]))({
                        tr: tr
                    });
                } else tr.replaceWith(sliceStart, $to.pos, content);
                if (isTextFormattingTransform && tr.doc.eq(docBeforeTransform)) {
                    (0, $951G5.stopMeasure)(measureId);
                    return null;
                }
                if (preservedSelection instanceof (0, $2E7OD.CellSelection)) {
                    const insertedNode = tr.doc.nodeAt($from.pos);
                    const isSelectable = insertedNode && (0, $cw0wu.NodeSelection).isSelectable(insertedNode);
                    if (isSelectable) {
                        var _api$blockControls5;
                        const nodeSelection = (0, $cw0wu.NodeSelection).create(tr.doc, $from.pos);
                        tr.setSelection(nodeSelection);
                        api === null || api === void 0 || (_api$blockControls5 = api.blockControls) === null || _api$blockControls5 === void 0 || _api$blockControls5.commands.startPreservingSelection()({
                            tr: tr
                        });
                    }
                }
                api === null || api === void 0 || (_api$blockControls6 = api.blockControls) === null || _api$blockControls6 === void 0 || _api$blockControls6.commands.toggleBlockMenu({
                    closeMenu: true
                })({
                    tr: tr
                });
                (0, $951G5.stopMeasure)(measureId, (duration, startTime)=>{
                    analytics.transformed(duration, startTime, {
                        isEmptyLine: (0, $9R8u3.isEmptyLine)(sourceNodes),
                        isNested: isNested,
                        isSuggested: isSuggested,
                        outputNodesCount: content.length,
                        sourceNodes: sourceNodes,
                        targetNodeType: isSmallTextTransform ? 'smallText' : targetType.name
                    });
                });
            } catch (error) {
                (0, $951G5.stopMeasure)(measureId);
                analytics.errored(error, sourceNodes, targetType.name);
            }
            return tr;
        };

});

parcelRegister("cFqsZ", function(module, exports) {
$parcel$export(module.exports, "getBlockMenuExperiencesPlugin", () => $23691b96965b1b82$export$4372671be2bee317);

var $bAB3U = parcelRequire("bAB3U");

var $g6Qq4 = parcelRequire("g6Qq4");

var $30Yan = parcelRequire("30Yan");

var $2KDOT = parcelRequire("2KDOT");
var $faLOc = parcelRequire("faLOc");

var $bApp6 = parcelRequire("bApp6");

var $b8RGE = parcelRequire("b8RGE");

var $73iZo = parcelRequire("73iZo");

var $1EaP8 = parcelRequire("1EaP8");

var $9skTL = parcelRequire("9skTL");

var $f7Kk4 = parcelRequire("f7Kk4");

var $cw0wu = parcelRequire("cw0wu");

var $aOR21 = parcelRequire("aOR21");
const $23691b96965b1b82$var$TIMEOUT_DURATION = 1000;
const $23691b96965b1b82$var$PORTAL_TEST_ID = {
    LINK_COPIED_TO_CLIPBOARD: 'link-copied-to-clipboard',
    SYNC_BLOCK_DELETE_CONFIRMATION: 'sync-block-delete-confirmation'
};
const $23691b96965b1b82$var$pluginKey = new (0, $cw0wu.PluginKey)('blockMenuExperiences');
const $23691b96965b1b82$var$START_METHOD = {
    DRAG_HANDLE_CLICK: 'dragHandleClick',
    KEYBOARD: 'keyboard'
};
const $23691b96965b1b82$var$ABORT_REASON = {
    USER_CANCELED: 'userCanceled',
    EDITOR_DESTROYED: 'editorDestroyed'
};
const $23691b96965b1b82$export$4372671be2bee317 = ({ refs: refs, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    let popupTargetEl;
    let editorView;
    const getPopupsTarget = ()=>{
        if (!popupTargetEl) {
            var _editorView;
            popupTargetEl = refs.popupsMountPoint || (0, $2KDOT.getPopupContainerFromEditorView)((_editorView = editorView) === null || _editorView === void 0 ? void 0 : _editorView.dom);
        }
        return popupTargetEl;
    };
    const getEditorDom = ()=>{
        var _editorView2;
        if (((_editorView2 = editorView) === null || _editorView2 === void 0 ? void 0 : _editorView2.dom) instanceof HTMLElement) return editorView.dom;
        return null;
    };
    const blockMenuOpenExperience = new (0, $b8RGE.Experience)((0, $bApp6.EXPERIENCE_ID).MENU_OPEN, {
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).BLOCK_MENU,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $9skTL.ExperienceCheckTimeout)({
                durationMs: $23691b96965b1b82$var$TIMEOUT_DURATION
            }),
            new (0, $1EaP8.ExperienceCheckPopupMutation)({
                nestedElementQuery: `[data-testid="${(0, $30Yan.BLOCK_MENU_TEST_ID)}"]`,
                getTarget: getPopupsTarget,
                type: 'editorContent'
            })
        ]
    });
    const observeConfigs = ()=>{
        const narrowTarget = (0, $faLOc.getSelectionAncestorDOM)(editorView);
        const editorDom = getEditorDom();
        return [
            ...narrowTarget ? [
                {
                    target: narrowTarget,
                    options: {
                        childList: true,
                        subtree: true
                    }
                }
            ] : [],
            ...editorDom ? [
                {
                    target: editorDom,
                    options: {
                        childList: true
                    }
                }
            ] : []
        ];
    };
    const blockMoveUpExperience = new (0, $b8RGE.Experience)((0, $bApp6.EXPERIENCE_ID).MENU_ACTION, {
        action: (0, $g6Qq4.ACTION).MOVED,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).MOVE_UP_BLOCK,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $9skTL.ExperienceCheckTimeout)({
                durationMs: $23691b96965b1b82$var$TIMEOUT_DURATION
            }),
            new (0, $73iZo.ExperienceCheckDomMutation)({
                onDomMutation: (0, $aOR21.handleMoveDomMutation),
                observeConfig: observeConfigs
            })
        ]
    });
    const blockMoveDownExperience = new (0, $b8RGE.Experience)((0, $bApp6.EXPERIENCE_ID).MENU_ACTION, {
        action: (0, $g6Qq4.ACTION).MOVED,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).MOVE_DOWN_BLOCK,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $9skTL.ExperienceCheckTimeout)({
                durationMs: $23691b96965b1b82$var$TIMEOUT_DURATION
            }),
            new (0, $73iZo.ExperienceCheckDomMutation)({
                onDomMutation: (0, $aOR21.handleMoveDomMutation),
                observeConfig: observeConfigs
            })
        ]
    });
    const blockDeleteExperience = new (0, $b8RGE.Experience)((0, $bApp6.EXPERIENCE_ID).MENU_ACTION, {
        action: (0, $g6Qq4.ACTION).DELETED,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).DELETE_BLOCK,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $9skTL.ExperienceCheckTimeout)({
                durationMs: $23691b96965b1b82$var$TIMEOUT_DURATION
            }),
            new (0, $73iZo.ExperienceCheckDomMutation)({
                onDomMutation: (0, $aOR21.handleDeleteDomMutation),
                observeConfig: observeConfigs
            }),
            new (0, $1EaP8.ExperienceCheckPopupMutation)({
                nestedElementQuery: `[data-testid="${$23691b96965b1b82$var$PORTAL_TEST_ID.SYNC_BLOCK_DELETE_CONFIRMATION}"]`,
                type: 'portalRoot'
            })
        ]
    });
    const blockTransformExperience = new (0, $b8RGE.Experience)((0, $bApp6.EXPERIENCE_ID).MENU_ACTION, {
        action: (0, $g6Qq4.ACTION).TRANSFORMED,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).TRANSFORM_BLOCK,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $9skTL.ExperienceCheckTimeout)({
                durationMs: $23691b96965b1b82$var$TIMEOUT_DURATION
            }),
            new (0, $73iZo.ExperienceCheckDomMutation)({
                onDomMutation: (0, $aOR21.handleTransformDomMutation),
                observeConfig: observeConfigs
            })
        ]
    });
    const blockCopyLinkExperience = new (0, $b8RGE.Experience)((0, $bApp6.EXPERIENCE_ID).MENU_ACTION, {
        action: (0, $g6Qq4.ACTION).COPIED,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).COPY_LINK_TO_BLOCK,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $9skTL.ExperienceCheckTimeout)({
                durationMs: $23691b96965b1b82$var$TIMEOUT_DURATION
            }),
            new (0, $1EaP8.ExperienceCheckPopupMutation)({
                nestedElementQuery: `[data-testid="${$23691b96965b1b82$var$PORTAL_TEST_ID.LINK_COPIED_TO_CLIPBOARD}"]`,
                type: 'portalRoot'
            })
        ]
    });
    const handleMenuOpened = (method)=>{
        // Don't start if block menu is already visible
        if ((0, $aOR21.isBlockMenuVisible)(getPopupsTarget())) return;
        blockMenuOpenExperience.start({
            method: method
        });
    };
    const handleTransformActioned = (target)=>{
        if (!target.closest('[data-testid="editor-turn-into-menu--content"]') || // Skip experience tracking when the clicked item is an extension menu item
        // (e.g. Jira macro, etc.) - they don't perform block transforms
        target.closest(`[data-testid="${(0, $30Yan.EXTENSION_MENU_ITEM_TEST_ID)}"]`)) return false;
        const turnIntoButton = target.closest('button');
        if (turnIntoButton && turnIntoButton instanceof HTMLElement && !turnIntoButton.hasAttribute('disabled') && turnIntoButton.getAttribute('aria-disabled') !== 'true') blockTransformExperience.start();
        return true;
    };
    const handleItemActioned = (target)=>{
        if (handleTransformActioned(target)) return;
        const button = target.closest('button[data-testid]');
        if (!button || !(button instanceof HTMLButtonElement) || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
        const testId = button.dataset.testid;
        if (!testId) return;
        switch(testId){
            case (0, $30Yan.BLOCK_MENU_ACTION_TEST_ID).MOVE_UP:
                blockMoveUpExperience.start();
                break;
            case (0, $30Yan.BLOCK_MENU_ACTION_TEST_ID).MOVE_DOWN:
                blockMoveDownExperience.start();
                break;
            case (0, $30Yan.BLOCK_MENU_ACTION_TEST_ID).DELETE:
                blockDeleteExperience.start();
                break;
            case (0, $30Yan.BLOCK_MENU_ACTION_TEST_ID).COPY_LINK:
                blockCopyLinkExperience.start();
                break;
        }
    };
    const unbindClickListener = (0, $bAB3U.bind)(document, {
        type: 'click',
        listener: (event)=>{
            const target = event.target;
            if (!(target instanceof HTMLElement)) return;
            if ((0, $aOR21.isDragHandleElement)(target)) handleMenuOpened($23691b96965b1b82$var$START_METHOD.DRAG_HANDLE_CLICK);
            else handleItemActioned(target);
        },
        options: {
            capture: true
        }
    });
    const unbindKeydownListener = (0, $bAB3U.bind)(document, {
        type: 'keydown',
        listener: (event)=>{
            const target = event.target;
            if (!(target instanceof HTMLElement)) return;
            // Check if Enter or Space is pressed on a drag handle
            if ((event.key === 'Enter' || event.key === ' ') && (0, $aOR21.isDragHandleElement)(target)) handleMenuOpened($23691b96965b1b82$var$START_METHOD.KEYBOARD);
            // Abort on Escape key if block menu is not yet visible
            if (event.key === 'Escape' && !(0, $aOR21.isBlockMenuVisible)(getPopupsTarget())) blockMenuOpenExperience.abort({
                reason: $23691b96965b1b82$var$ABORT_REASON.USER_CANCELED
            });
        },
        options: {
            capture: true
        }
    });
    return new (0, $f7Kk4.SafePlugin)({
        key: $23691b96965b1b82$var$pluginKey,
        view: (view)=>{
            editorView = view;
            return {
                destroy: ()=>{
                    blockMenuOpenExperience.abort({
                        reason: $23691b96965b1b82$var$ABORT_REASON.EDITOR_DESTROYED
                    });
                    blockMoveUpExperience.abort({
                        reason: $23691b96965b1b82$var$ABORT_REASON.EDITOR_DESTROYED
                    });
                    blockMoveDownExperience.abort({
                        reason: $23691b96965b1b82$var$ABORT_REASON.EDITOR_DESTROYED
                    });
                    blockDeleteExperience.abort({
                        reason: $23691b96965b1b82$var$ABORT_REASON.EDITOR_DESTROYED
                    });
                    blockTransformExperience.abort({
                        reason: $23691b96965b1b82$var$ABORT_REASON.EDITOR_DESTROYED
                    });
                    blockCopyLinkExperience.abort({
                        reason: $23691b96965b1b82$var$ABORT_REASON.EDITOR_DESTROYED
                    });
                    editorView = undefined;
                    unbindClickListener();
                    unbindKeydownListener();
                }
            };
        }
    });
};

});
parcelRegister("aOR21", function(module, exports) {
$parcel$export(module.exports, "isDragHandleElement", () => $3a6695e07c8a0824$export$6aa2a05df3516dfe);
$parcel$export(module.exports, "isBlockMenuVisible", () => $3a6695e07c8a0824$export$da6fa229035f8640);
$parcel$export(module.exports, "handleMoveDomMutation", () => $3a6695e07c8a0824$export$98aa59cf060bb46f);
$parcel$export(module.exports, "handleDeleteDomMutation", () => $3a6695e07c8a0824$export$d0c875b9d557ee38);
$parcel$export(module.exports, "handleTransformDomMutation", () => $3a6695e07c8a0824$export$7ed4b3067980a591);

var $30Yan = parcelRequire("30Yan");

var $6kZ0x = parcelRequire("6kZ0x");
const $3a6695e07c8a0824$export$6aa2a05df3516dfe = (element)=>{
    return !!(element !== null && element !== void 0 && element.closest('[data-editor-block-ctrl-drag-handle]'));
};
const $3a6695e07c8a0824$export$da6fa229035f8640 = (popupsTarget)=>{
    if (!popupsTarget) return false;
    return (0, $6kZ0x.popupWithNestedElement)(popupsTarget, `[data-testid="${(0, $30Yan.BLOCK_MENU_TEST_ID)}"]`) !== null;
};
const $3a6695e07c8a0824$var$isBlockMenuAddedInMutation = ({ type: type, addedNodes: addedNodes })=>{
    return type === 'childList' && [
        ...addedNodes
    ].some($3a6695e07c8a0824$var$isBlockMenuWithinNode);
};
const $3a6695e07c8a0824$var$isBlockMenuWithinNode = (node)=>{
    return (0, $6kZ0x.popupWithNestedElement)(node, `[data-testid="${(0, $30Yan.BLOCK_MENU_TEST_ID)}"]`) !== null;
};
const $3a6695e07c8a0824$export$848164ca7017e3ef = ({ mutations: mutations })=>{
    // Look for a mutation that added the block menu
    for (const mutation of mutations){
        if ($3a6695e07c8a0824$var$isBlockMenuAddedInMutation(mutation)) return {
            status: 'success'
        };
    }
    return undefined;
};
const $3a6695e07c8a0824$export$98aa59cf060bb46f = ({ mutations: mutations })=>{
    const removeMutation = mutations.find((m)=>m.type === 'childList' && m.removedNodes.length > 0);
    const addMutation = mutations.find((m)=>m.type === 'childList' && m.addedNodes.length > 0);
    if (removeMutation && addMutation && removeMutation.removedNodes.length === addMutation.addedNodes.length) return {
        status: 'success'
    };
    return undefined;
};
const $3a6695e07c8a0824$export$d0c875b9d557ee38 = ({ mutations: mutations })=>{
    // Delete action produces a single childList mutation with only removedNodes
    const childListMutations = mutations.filter((m)=>m.type === 'childList');
    // Check for at least one mutation with removedNodes but no addedNodes
    if (childListMutations.some((m)=>m.removedNodes.length > 0 && m.addedNodes.length === 0)) return {
        status: 'success'
    };
    return undefined;
};
const $3a6695e07c8a0824$export$7ed4b3067980a591 = ({ mutations: mutations })=>{
    const hasRemovedNodes = mutations.some((m)=>m.type === 'childList' && m.removedNodes.length > 0);
    const hasAddedNodes = mutations.some((m)=>m.type === 'childList' && m.addedNodes.length > 0);
    if (hasRemovedNodes && hasAddedNodes) return {
        status: 'success'
    };
    return undefined;
};

});


parcelRegister("86Ecr", function(module, exports) {
$parcel$export(module.exports, "keymapPlugin", () => $efe46d1ba684a619$export$e832373cff8dec22);

var $bdXbU = parcelRequire("bdXbU");

var $cv8id = parcelRequire("cv8id");

var $6Cbfp = parcelRequire("6Cbfp");

var $kyeIc = parcelRequire("kyeIc");

var $aCsiM = parcelRequire("aCsiM");

var $dlxOP = parcelRequire("dlxOP");

var $8eUTO = parcelRequire("8eUTO");
function $efe46d1ba684a619$export$e832373cff8dec22(api, config) {
    const list = {};
    const copyLinkToBlockCommand = (state, dispatch)=>{
        var _api$blockControls, _node$attrs;
        if (!(0, $8eUTO.isCopyLinkEnabled)(config)) return false;
        // Get the preserved selection (only works when block menu is open and selection is preserved)
        const selection = api === null || api === void 0 || (_api$blockControls = api.blockControls) === null || _api$blockControls === void 0 || (_api$blockControls = _api$blockControls.sharedState.currentState()) === null || _api$blockControls === void 0 ? void 0 : _api$blockControls.preservedSelection;
        if (!selection) return false;
        // Check if the selection has a valid block range with localId
        const blockRange = (0, $6Cbfp.expandSelectionToBlockRange)(selection);
        if (!blockRange) return false;
        const node = blockRange.$from.nodeAfter;
        if (!(node !== null && node !== void 0 && (_node$attrs = node.attrs) !== null && _node$attrs !== void 0 && _node$attrs.localId)) return false;
        // Execute the copy link action
        const { getLinkPath: getLinkPath, blockLinkHashPrefix: blockLinkHashPrefix } = config || {};
        (0, $dlxOP.copyLink)({
            getLinkPath: getLinkPath,
            blockLinkHashPrefix: blockLinkHashPrefix,
            selection: selection
        }).then((success)=>{
            if (success && dispatch) dispatch(state.tr.setMeta((0, $aCsiM.blockMenuPluginKey), {
                showFlag: (0, $kyeIc.FLAG_ID).LINK_COPIED_TO_CLIPBOARD
            }));
        });
        return true;
    };
    // Ignored via go/ees005
    (0, $cv8id.bindKeymapWithCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.copyLinkToBlock).common, copyLinkToBlockCommand, list);
    return (0, $bdXbU.keymap)(list);
}

});
parcelRegister("kyeIc", function(module, exports) {
$parcel$export(module.exports, "FLAG_ID", () => $7b334aa80edb61e0$export$5881677fb314e6d9);
var $7b334aa80edb61e0$export$5881677fb314e6d9 = /*#__PURE__*/ function(FLAG_ID) {
    FLAG_ID["LINK_COPIED_TO_CLIPBOARD"] = "link-copied-to-clipboard";
    return FLAG_ID;
}({});

});

parcelRegister("aCsiM", function(module, exports) {
$parcel$export(module.exports, "blockMenuPluginKey", () => $c64e1a24edc3b860$export$8750eaa816e9a19a);
$parcel$export(module.exports, "createPlugin", () => $c64e1a24edc3b860$export$ae829ec7b2625219);

var $f7Kk4 = parcelRequire("f7Kk4");

var $cw0wu = parcelRequire("cw0wu");

var $3dmbW = parcelRequire("3dmbW");
const $c64e1a24edc3b860$export$8750eaa816e9a19a = new (0, $cw0wu.PluginKey)('blockMenuPlugin');
const $c64e1a24edc3b860$export$ae829ec7b2625219 = (api)=>{
    return new (0, $f7Kk4.SafePlugin)({
        key: $c64e1a24edc3b860$export$8750eaa816e9a19a,
        state: {
            init () {
                return {
                    showFlag: false
                };
            },
            apply: (tr, currentPluginState)=>{
                const meta = tr.getMeta($c64e1a24edc3b860$export$8750eaa816e9a19a);
                return {
                    showFlag: (meta === null || meta === void 0 ? void 0 : meta.showFlag) ?? currentPluginState.showFlag
                };
            }
        },
        props: {
            handleKeyDown: (_editorView, event)=>{
                var _api$userIntent;
                const blockMenuOpen = (api === null || api === void 0 || (_api$userIntent = api.userIntent) === null || _api$userIntent === void 0 || (_api$userIntent = _api$userIntent.sharedState.currentState()) === null || _api$userIntent === void 0 ? void 0 : _api$userIntent.currentUserIntent) === 'blockMenuOpen';
                // Exit early and do nothing when block menu is closed
                if (!blockMenuOpen) return false;
                // Block further handling of key events when block menu is open
                // Except for backspace/delete/copy/cut/paste/undo/redo/copy-link-to-selection which should be handled by the selection preservation plugin
                return (0, $3dmbW.shouldSuppressKeyboardEvent)(event);
            }
        }
    });
};

});
parcelRegister("3dmbW", function(module, exports) {
$parcel$export(module.exports, "shouldSuppressKeyboardEvent", () => $20677dbf2f94b3c9$export$1cbe0677ce5bfb51);
/**
 * Determines whether keyboard events should be suppressed when the block menu is open.
 *
 * When the block menu is open, we want to block most keyboard events to prevent
 * unintended interactions. However, certain actions should still be allowed:
 * - Backspace/Delete: Allow deleting selected content
 * - Copy/Cut/Paste: Allow clipboard operations (Cmd/Ctrl+C, Cmd/Ctrl+X, Cmd/Ctrl+V)
 * - Undo/Redo: Allow undo/redo operations (Cmd/Ctrl+Z, Cmd/Ctrl+Y)
 * - Copy Link to Selection: Allow the keyboard shortcut (Cmd/Ctrl+Alt+A)
 *
 * @param event - The keyboard event to check
 * @returns true if the event should be suppressed, false if it should be allowed
 */ const $20677dbf2f94b3c9$export$1cbe0677ce5bfb51 = (event)=>{
    const key = event.key.toLowerCase();
    const code = event.code.toLowerCase();
    const isMetaCtrl = event.metaKey || event.ctrlKey;
    const isAlt = event.altKey;
    // Check for allowed keyboard shortcuts
    const isBackspaceDelete = [
        'backspace',
        'delete'
    ].includes(key);
    const isCopyCutPaste = isMetaCtrl && [
        'c',
        'x',
        'v'
    ].includes(key);
    const isUndoRedo = isMetaCtrl && [
        'z',
        'y'
    ].includes(key);
    // Use event.code to detect physical key 'A' because on macOS Option+A produces 'å'
    const isCopyLinkToBlock = isMetaCtrl && isAlt && code === 'keya';
    // Suppress all events except the allowed ones
    const suppressNativeHandling = !isCopyCutPaste && !isBackspaceDelete && !isUndoRedo && !isCopyLinkToBlock;
    return suppressNativeHandling;
};

});


parcelRegister("dlxOP", function(module, exports) {
$parcel$export(module.exports, "copyLink", () => $2b33168b028e81ce$export$9030f1f7cf11a203);

var $lySmk = parcelRequire("lySmk");

var $kAhws = parcelRequire("kAhws");

var $j2Y9J = parcelRequire("j2Y9J");

var $6Cbfp = parcelRequire("6Cbfp");
const $2b33168b028e81ce$export$9030f1f7cf11a203 = async ({ getLinkPath: getLinkPath, blockLinkHashPrefix: blockLinkHashPrefix = (0, $lySmk.DEFAULT_BLOCK_LINK_HASH_PREFIX), selection: selection })=>{
    const blockRange = (0, $6Cbfp.expandSelectionToBlockRange)(selection);
    if (!blockRange) return false;
    // get the link to the first node in the selection
    const node = blockRange.$from.nodeAfter;
    if (!node || !node.attrs || !node.attrs.localId) return false;
    const path = (getLinkPath === null || getLinkPath === void 0 ? void 0 : getLinkPath()) || location.pathname;
    try {
        const url = new URL(location.origin + path);
        url.hash = (0, $lySmk.createBlockLinkHashValue)(node.attrs.localId, blockLinkHashPrefix);
        const href = url.toString();
        await (0, $kAhws.copyToClipboard)(href);
    } catch (error) {
        (0, $j2Y9J.logException)(error, {
            location: 'editor-plugin-block-menu'
        });
        return false;
    }
    return true;
};

});

parcelRegister("8eUTO", function(module, exports) {
$parcel$export(module.exports, "isCopyLinkEnabled", () => $0aad7198b34fa084$export$c66aeef3d7df4772);

var $gdUUy = parcelRequire("gdUUy");
const $0aad7198b34fa084$export$c66aeef3d7df4772 = (config)=>{
    if (!(0, $gdUUy.fg)('platform_editor_adf_with_localid')) return false;
    if ((0, $gdUUy.fg)('platform_editor_block_menu_copy_link_opt_in')) return Boolean(config === null || config === void 0 ? void 0 : config.enableCopyLinkToSelection);
    return true;
};

});


parcelRegister("ahtLN", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c62cd006a878999$export$2e2bcd8739ae039);
/* block-menu.tsx generated by @compiled/babel-plugin v3.0.2 */ /* block-menu.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $fK3tS = parcelRequire("fK3tS");

var $jDsoo = parcelRequire("jDsoo");

var $g6Qq4 = parcelRequire("g6Qq4");

var $bosp6 = parcelRequire("bosp6");

var $30Yan = parcelRequire("30Yan");

var $iUiGU = parcelRequire("iUiGU");

var $5zk80 = parcelRequire("5zk80");

var $fdcHc = parcelRequire("fdcHc");

var $5chfg = parcelRequire("5chfg");

var $imBU3 = parcelRequire("imBU3");

var $3Aq92 = parcelRequire("3Aq92");

var $cf2n1 = parcelRequire("cf2n1");

var $5beht = parcelRequire("5beht");

var $5bbjm = parcelRequire("5bbjm");

var $h6aQr = parcelRequire("h6aQr");

var $3y2s4 = parcelRequire("3y2s4");

var $9PwDt = parcelRequire("9PwDt");

var $gNUrD = parcelRequire("gNUrD");

var $jVAei = parcelRequire("jVAei");

var $cm3rY = parcelRequire("cm3rY");

var $hgaAb = parcelRequire("hgaAb");

var $9QUTn = parcelRequire("9QUTn");
const $2c62cd006a878999$var$styles = {
    base: "_2rko12b0 _bfhk1bhr _16qs130s",
    maxWidthStyles: "_p12fnklw",
    emptyMenuSectionStyles: "_1cc0glyw _1k2yglyw"
};
const $2c62cd006a878999$var$DEFAULT_MENU_WIDTH = 230;
const $2c62cd006a878999$var$DRAG_HANDLE_OFFSET_PADDING = 5;
const $2c62cd006a878999$var$FALLBACK_MENU_HEIGHT = 300;
const $2c62cd006a878999$var$PopupWithListeners = (0, $cf2n1.default)((0, $5zk80.default));
const $2c62cd006a878999$var$useConditionalBlockMenuEffect = ({ api: api, isMenuOpen: isMenuOpen, menuTriggerBy: menuTriggerBy, selectedByShortcutOrDragHandle: selectedByShortcutOrDragHandle, hasFocus: hasFocus, openedViaKeyboard: openedViaKeyboard, prevIsMenuOpenRef: prevIsMenuOpenRef })=>{
    /**
   * NOTE: do not add `currentUserIntent` to dependency array as it causes unnecessary re-renders and messes with the user intent state
   */ (0, $bSJIT.useEffect)(()=>{
        var _api$userIntent;
        if (!isMenuOpen || !menuTriggerBy || !selectedByShortcutOrDragHandle || !hasFocus) return;
        // Fire analytics event when block menu opens (only on first transition from closed to open)
        if (!prevIsMenuOpenRef.current && isMenuOpen) {
            var _api$analytics;
            api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || _api$analytics.actions.fireAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).OPENED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).BLOCK_MENU,
                eventType: (0, $g6Qq4.EVENT_TYPE).UI,
                attributes: {
                    inputMethod: openedViaKeyboard ? (0, $g6Qq4.INPUT_METHOD).KEYBOARD : (0, $g6Qq4.INPUT_METHOD).MOUSE
                }
            });
        }
        // Update the previous state
        prevIsMenuOpenRef.current = isMenuOpen;
        api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$userIntent = api.userIntent) === null || _api$userIntent === void 0 ? void 0 : _api$userIntent.commands.setCurrentUserIntent('blockMenuOpen'));
    }, [
        api,
        isMenuOpen,
        menuTriggerBy,
        selectedByShortcutOrDragHandle,
        hasFocus,
        openedViaKeyboard,
        prevIsMenuOpenRef
    ]);
};
const $2c62cd006a878999$var$isSelectionWithinCodeBlock = (state)=>{
    const { $from: $from, $to: $to } = state.selection;
    return $from.sameParent($to) && $from.parent.type === state.schema.nodes.codeBlock;
};
const $2c62cd006a878999$var$useCloseBlockMenuOnResize = ({ isEnabled: isEnabled, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement, closeMenu: closeMenu })=>{
    (0, $bSJIT.useEffect)(()=>{
        if (!isEnabled || typeof ResizeObserver === 'undefined') return;
        const observedElements = Array.from(new Set([
            mountTo,
            boundariesElement,
            scrollableElement
        ].filter((element)=>Boolean(element))));
        if (observedElements.length === 0) return;
        const pendingInitialResizeElements = new Set(observedElements);
        const resizeObserver = new ResizeObserver((entries)=>{
            const hasResizeAfterInitialObservation = entries.some(({ target: target })=>{
                if (target instanceof HTMLElement && pendingInitialResizeElements.has(target)) {
                    pendingInitialResizeElements.delete(target);
                    return false;
                }
                return true;
            });
            if (hasResizeAfterInitialObservation) closeMenu();
        });
        observedElements.forEach((element)=>resizeObserver.observe(element));
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        boundariesElement,
        closeMenu,
        isEnabled,
        mountTo,
        scrollableElement
    ]);
};
const $2c62cd006a878999$var$BlockMenuContent = ({ api: api, setRef: setRef })=>{
    var _api$blockMenu;
    const blockMenuComponents = api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 ? void 0 : _api$blockMenu.actions.getBlockMenuComponents();
    const setOutsideClickTargetRef = (0, $bSJIT.useContext)((0, $3Aq92.OutsideClickTargetRefContext));
    const ref = (el)=>{
        setOutsideClickTargetRef(el);
        setRef === null || setRef === void 0 || setRef(el);
    };
    const shouldDisableArrowKeyNavigation = (event)=>{
        if (event.key !== 'ArrowUp' && event.key !== 'ArrowDown') return false;
        const target = event.target;
        if (!(target instanceof HTMLElement)) return false;
        return target.closest('[data-toolbar-nested-dropdown-menu]') !== null;
    };
    if ((0, $3y2s4.isExperimentEnabled)('platform_editor_menu_radius_update')) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $h6aQr.ToolbarMenuContainer), {
        testId: (0, $30Yan.BLOCK_MENU_TEST_ID),
        ref: ref,
        xcss: $2c62cd006a878999$var$styles.maxWidthStyles,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $5chfg.ArrowKeyNavigationProvider), {
            type: (0, $imBU3.ArrowKeyNavigationType).MENU,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            handleClose: (e)=>e.preventDefault(),
            disableArrowKeyNavigation: shouldDisableArrowKeyNavigation,
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $hgaAb.BlockMenuRenderer), {
                allRegisteredComponents: blockMenuComponents || []
            })
        })
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
        testId: (0, $30Yan.BLOCK_MENU_TEST_ID),
        role: "menu",
        ref: ref,
        xcss: (0, $jDsoo.cx)($2c62cd006a878999$var$styles.base, $2c62cd006a878999$var$styles.maxWidthStyles, $2c62cd006a878999$var$styles.emptyMenuSectionStyles),
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $5chfg.ArrowKeyNavigationProvider), {
            type: (0, $imBU3.ArrowKeyNavigationType).MENU,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            handleClose: (e)=>e.preventDefault(),
            disableArrowKeyNavigation: shouldDisableArrowKeyNavigation,
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $hgaAb.BlockMenuRenderer), {
                allRegisteredComponents: blockMenuComponents || []
            })
        })
    });
};
const $2c62cd006a878999$var$BlockMenu = ({ editorView: editorView, api: api, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement })=>{
    var _editorView$dom, _api$analytics2;
    const isPopupTargetVisibilityEnabled = Boolean(mountTo) && (0, $3y2s4.isExperimentEnabled)('platform_editor_popup_target_visibility');
    const { menuTriggerBy: menuTriggerBy, menuTriggerByNode: menuTriggerByNode, isSelectedViaDragHandle: isSelectedViaDragHandle, isMenuOpen: isMenuOpen, currentUserIntent: currentUserIntent, openedViaKeyboard: openedViaKeyboard } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'blockControls',
        'userIntent'
    ], (states)=>{
        var _states$blockControls, _states$blockControls2, _states$blockControls3, _states$blockControls4, _states$userIntentSta, _states$blockControls5;
        return {
            menuTriggerBy: (_states$blockControls = states.blockControlsState) === null || _states$blockControls === void 0 ? void 0 : _states$blockControls.menuTriggerBy,
            menuTriggerByNode: isPopupTargetVisibilityEnabled ? (_states$blockControls2 = states.blockControlsState) === null || _states$blockControls2 === void 0 ? void 0 : _states$blockControls2.menuTriggerByNode : undefined,
            isSelectedViaDragHandle: (_states$blockControls3 = states.blockControlsState) === null || _states$blockControls3 === void 0 ? void 0 : _states$blockControls3.isSelectedViaDragHandle,
            isMenuOpen: (_states$blockControls4 = states.blockControlsState) === null || _states$blockControls4 === void 0 ? void 0 : _states$blockControls4.isMenuOpen,
            currentUserIntent: (_states$userIntentSta = states.userIntentState) === null || _states$userIntentSta === void 0 ? void 0 : _states$userIntentSta.currentUserIntent,
            openedViaKeyboard: (_states$blockControls5 = states.blockControlsState) === null || _states$blockControls5 === void 0 || (_states$blockControls5 = _states$blockControls5.blockMenuOptions) === null || _states$blockControls5 === void 0 ? void 0 : _states$blockControls5.openedViaKeyboard
        };
    });
    const { onDropdownOpenChanged: onDropdownOpenChanged } = (0, $cm3rY.useBlockMenu)();
    const isMenuOpenRef = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(isMenuOpen);
    isMenuOpenRef.current = isMenuOpen;
    const [surfaceDragHandle, setSurfaceDragHandle] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useLayoutEffect(()=>{
        if (!(0, $3y2s4.isExperimentEnabled)('platform_editor_block_control_migration')) return;
        const readElement = ()=>setSurfaceDragHandle((0, $bosp6.surfaceDragHandleElementStore).get(editorView));
        readElement();
        return (0, $bosp6.surfaceDragHandleElementStore).subscribe(editorView, ()=>{
            if (!isMenuOpenRef.current) readElement();
        });
    }, [
        editorView
    ]);
    const openMenuHandleRef = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(null);
    const anchoredToRef = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(undefined);
    if (!isMenuOpen) {
        openMenuHandleRef.current = null;
        anchoredToRef.current = undefined;
    } else if (!openMenuHandleRef.current || anchoredToRef.current !== menuTriggerBy) {
        openMenuHandleRef.current = (0, $bosp6.surfaceDragHandleElementStore).get(editorView) ?? openMenuHandleRef.current ?? surfaceDragHandle;
        anchoredToRef.current = menuTriggerBy;
    }
    const targetHandleRef = (0, $3y2s4.isExperimentEnabled)('platform_editor_block_control_migration') ? openMenuHandleRef.current ?? surfaceDragHandle : editorView === null || editorView === void 0 || (_editorView$dom = editorView.dom) === null || _editorView$dom === void 0 ? void 0 : _editorView$dom.querySelector((0, $fdcHc.DRAG_HANDLE_SELECTOR));
    const menuTargetNode = menuTriggerByNode && (editorView === null || editorView === void 0 ? void 0 : editorView.nodeDOM(menuTriggerByNode.pos));
    const visibilityTarget = menuTargetNode instanceof HTMLElement ? menuTargetNode : undefined;
    const closeMenu = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback(()=>{
        api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
            var _api$blockControls, _api$userIntent2;
            api === null || api === void 0 || (_api$blockControls = api.blockControls) === null || _api$blockControls === void 0 || _api$blockControls.commands.toggleBlockMenu({
                closeMenu: true
            })({
                tr: tr
            });
            onDropdownOpenChanged(false);
            api === null || api === void 0 || (_api$userIntent2 = api.userIntent) === null || _api$userIntent2 === void 0 || _api$userIntent2.commands.setCurrentUserIntent(currentUserIntent === 'blockMenuOpen' ? 'default' : currentUserIntent || 'default')({
                tr: tr
            });
            return tr;
        });
    }, [
        api,
        currentUserIntent,
        onDropdownOpenChanged
    ]);
    $2c62cd006a878999$var$useCloseBlockMenuOnResize({
        isEnabled: Boolean(isMenuOpen),
        mountTo: mountTo,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        closeMenu: closeMenu
    });
    const prevIsMenuOpenRef = (0, $bSJIT.useRef)(false);
    const popupRef = (0, $bSJIT.useRef)(undefined);
    const [menuHeight, setMenuHeight] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(0);
    const [targetVisibility, setTargetVisibility] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState({
        isVisible: undefined,
        restoreFocusTo: null
    });
    const { isVisible: targetVisible, restoreFocusTo: restoreFocusTo } = targetVisibility;
    // CSS visibility can move focus to the document body. Preserve the active menu item so the
    // existing focus-loss guard does not close the menus during a temporary scroll transition.
    const handleTargetVisibilityChanged = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback((isVisible)=>{
        var _popupRef$current;
        if (isVisible) {
            setTargetVisibility((current)=>({
                    isVisible: true,
                    restoreFocusTo: current.isVisible === false ? current.restoreFocusTo : null
                }));
            return;
        }
        // Capture focus before scheduling the state update so the updater stays pure.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        const activeElement = document.activeElement;
        const isFocusInMenu = activeElement instanceof HTMLElement && (((_popupRef$current = popupRef.current) === null || _popupRef$current === void 0 ? void 0 : _popupRef$current.contains(activeElement)) || activeElement.closest((0, $fdcHc.NESTED_DROPDOWN_MENU)) !== null);
        setTargetVisibility({
            isVisible: false,
            restoreFocusTo: isFocusInMenu ? activeElement : null
        });
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useLayoutEffect(()=>{
        if (!isPopupTargetVisibilityEnabled || !targetVisible || !restoreFocusTo) return;
        const { activeElement: activeElement, body: body, documentElement: documentElement } = restoreFocusTo.ownerDocument;
        const focusWasLost = activeElement === null || activeElement === body || activeElement === documentElement;
        if (restoreFocusTo.isConnected && focusWasLost) restoreFocusTo.focus({
            preventScroll: true
        });
        setTargetVisibility((current)=>({
                ...current,
                restoreFocusTo: null
            }));
    }, [
        isPopupTargetVisibilityEnabled,
        restoreFocusTo,
        targetVisible
    ]);
    const targetHandleHeightOffset = -((targetHandleRef === null || targetHandleRef === void 0 ? void 0 : targetHandleRef.clientHeight) || 0);
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useLayoutEffect(()=>{
        var _popupRef$current2;
        if (!isMenuOpen) return;
        onDropdownOpenChanged(true);
        setMenuHeight(((_popupRef$current2 = popupRef.current) === null || _popupRef$current2 === void 0 ? void 0 : _popupRef$current2.clientHeight) || $2c62cd006a878999$var$FALLBACK_MENU_HEIGHT);
    }, [
        isMenuOpen,
        onDropdownOpenChanged
    ]);
    // Nested dropdowns are portaled outside the block-menu popup. Sparse surface reconciliation
    // dispatches after the menu opens, so a re-render can occur while focus is inside that portal.
    const hasFocus = ((editorView === null || editorView === void 0 ? void 0 : editorView.hasFocus()) || isPopupTargetVisibilityEnabled && (targetVisible === false || restoreFocusTo !== null) || // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    document.activeElement === targetHandleRef || popupRef.current && // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    (popupRef.current.contains(document.activeElement) || // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    popupRef.current === document.activeElement) || (0, $3y2s4.isExperimentEnabled)('platform_editor_block_control_migration') && // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    document.activeElement instanceof HTMLElement && // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    document.activeElement.closest((0, $fdcHc.NESTED_DROPDOWN_MENU)) !== null) ?? false;
    const selectedByShortcutOrDragHandle = !!isSelectedViaDragHandle || !!openedViaKeyboard;
    // Use conditional hook based on feature flag
    $2c62cd006a878999$var$useConditionalBlockMenuEffect({
        api: api,
        isMenuOpen: isMenuOpen,
        menuTriggerBy: menuTriggerBy,
        selectedByShortcutOrDragHandle: selectedByShortcutOrDragHandle,
        hasFocus: hasFocus,
        openedViaKeyboard: openedViaKeyboard,
        prevIsMenuOpenRef: prevIsMenuOpenRef
    });
    if (!isMenuOpen) return null;
    const handleKeyDown = (event)=>{
        var _api$core, _api$blockControls2;
        // When the editor view has focus, the keydown will be handled by the
        // selection preservation plugin – exit early to avoid double handling
        // Also exit if selection is within a code block to avoid double handling when code block got focus when the node after it is deleted
        if (!editorView || editorView !== null && editorView !== void 0 && editorView.hasFocus() || $2c62cd006a878999$var$isSelectionWithinCodeBlock(editorView.state)) return;
        const key = event.key.toLowerCase();
        const isMetaCtrl = event.metaKey || event.ctrlKey;
        const isDelete = [
            'backspace',
            'delete'
        ].includes(key);
        const isUndo = isMetaCtrl && key === 'z' && !event.shiftKey;
        const isRedo = isMetaCtrl && (key === 'y' || key === 'z' && event.shiftKey);
        // Necessary to prevent the editor from handling the delete natively
        if (isDelete || isUndo || isRedo) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (isUndo) (0, $jVAei.undo)(editorView.state, editorView.dispatch);
        else if (isRedo) (0, $gNUrD.redo)(editorView.state, editorView.dispatch);
        api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(api === null || api === void 0 || (_api$blockControls2 = api.blockControls) === null || _api$blockControls2 === void 0 || (_api$blockControls2 = _api$blockControls2.commands) === null || _api$blockControls2 === void 0 ? void 0 : _api$blockControls2.handleKeyDownWithPreservedSelection(event));
    };
    const handleClickOutside = (e)=>{
        // check if the clicked element was another drag handle or nested dropdown menu, if so don't close the menu
        if (e.target instanceof HTMLElement && (e.target.closest((0, $fdcHc.DRAG_HANDLE_SELECTOR)) || e.target.closest((0, $fdcHc.NESTED_DROPDOWN_MENU)))) return;
        closeMenu();
    };
    if (!menuTriggerBy || !selectedByShortcutOrDragHandle || !hasFocus || [
        'resizing',
        'dragging'
    ].includes(currentUserIntent || '')) {
        closeMenu();
        return null;
    }
    const setRef = (el)=>{
        if (el) popupRef.current = el;
    };
    if (!(targetHandleRef instanceof HTMLElement)) return null;
    const blockMenuContent = /*#__PURE__*/ (0, $dc70d.jsx)($2c62cd006a878999$var$BlockMenuContent, {
        api: api,
        setRef: setRef
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $iUiGU.ErrorBoundary), {
        component: (0, $g6Qq4.ACTION_SUBJECT).BLOCK_MENU,
        dispatchAnalyticsEvent: api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions.fireAnalyticsEvent,
        fallbackComponent: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($2c62cd006a878999$var$PopupWithListeners, {
            alignX: 'right',
            alignY: 'start',
            handleClickOutside: handleClickOutside,
            handleEscapeKeydown: closeMenu,
            handleKeyDown: handleKeyDown,
            mountTo: mountTo,
            boundariesElement: boundariesElement,
            scrollableElement: scrollableElement,
            target: targetHandleRef,
            visibilityTarget: visibilityTarget,
            zIndex: (0, $5bbjm.akEditorFloatingOverlapPanelZIndex),
            fitWidth: $2c62cd006a878999$var$DEFAULT_MENU_WIDTH,
            fitHeight: menuHeight,
            preventOverflow: true,
            stick: true,
            hideWhenTargetOutOfView: isPopupTargetVisibilityEnabled,
            onTargetVisibilityChanged: isPopupTargetVisibilityEnabled ? handleTargetVisibilityChanged : undefined,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            offset: [
                (0, $fdcHc.DRAG_HANDLE_WIDTH) + $2c62cd006a878999$var$DRAG_HANDLE_OFFSET_PADDING,
                targetHandleHeightOffset
            ],
            focusTrap: openedViaKeyboard ? // Only enable focus trap when opened via keyboard to make sure the focus is on the first focusable menu item
            {
                initialFocus: undefined
            } : undefined,
            children: isPopupTargetVisibilityEnabled ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $9QUTn.BlockMenuTargetVisibilityProvider), {
                value: targetVisible,
                children: blockMenuContent
            }) : blockMenuContent
        })
    });
};
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $2c62cd006a878999$var$_default_1 = (0, $fK3tS.default)($2c62cd006a878999$var$BlockMenu);
var $2c62cd006a878999$export$2e2bcd8739ae039 = $2c62cd006a878999$var$_default_1;

});
parcelRegister("cm3rY", function(module, exports) {
$parcel$export(module.exports, "useBlockMenu", () => $0ea1c388206a8733$export$348c130ef35bd15f);
$parcel$export(module.exports, "BlockMenuProvider", () => $0ea1c388206a8733$export$b01e53fc0770b652);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $8Sma6 = parcelRequire("8Sma6");
const $0ea1c388206a8733$var$BlockMenuContext = /*#__PURE__*/ (0, $bSJIT.createContext)({
    onDropdownOpenChanged: ()=>{},
    moveDownRef: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createRef(),
    moveUpRef: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createRef(),
    getFirstSelectedDomNode: ()=>undefined,
    getMovedBlockDomNode: ()=>undefined,
    getSelectedBlockDomNode: ()=>undefined,
    anchorMetricsRef: {
        current: undefined
    }
});
const $0ea1c388206a8733$export$348c130ef35bd15f = ()=>{
    const context = (0, $bSJIT.useContext)($0ea1c388206a8733$var$BlockMenuContext);
    if (!context) throw new Error('useBlockMenu must be used within BlockMenuProvider');
    return context;
};
const $0ea1c388206a8733$export$b01e53fc0770b652 = ({ children: children, api: api, editorView: editorView })=>{
    const moveUpRef = (0, $bSJIT.useRef)(null);
    const moveDownRef = (0, $bSJIT.useRef)(null);
    const anchorMetricsRef = (0, $bSJIT.useRef)(undefined);
    const getFirstSelectedDomNode = (0, $bSJIT.useCallback)(()=>{
        var _api$selection;
        const from = api === null || api === void 0 || (_api$selection = api.selection) === null || _api$selection === void 0 || (_api$selection = _api$selection.sharedState.currentState()) === null || _api$selection === void 0 || (_api$selection = _api$selection.selection) === null || _api$selection === void 0 ? void 0 : _api$selection.from;
        if (from !== undefined) {
            const nodeDOM = editorView === null || editorView === void 0 ? void 0 : editorView.nodeDOM(from);
            if (nodeDOM instanceof Element) return nodeDOM;
        }
    }, [
        api,
        editorView
    ]);
    const getTopLevelBlockDomNodeAt = (0, $bSJIT.useCallback)((from)=>{
        if (!editorView) return;
        const nodeDOM = editorView.nodeDOM(from);
        const domAtPos = nodeDOM instanceof Element ? nodeDOM : editorView.domAtPos(from).node;
        const element = domAtPos instanceof Element ? domAtPos : domAtPos.parentElement;
        if (!element || !editorView.dom.contains(element)) return;
        let block = element;
        while(block.parentElement && block.parentElement !== editorView.dom)block = block.parentElement;
        return block;
    }, [
        editorView
    ]);
    const getSelectedBlockDomNode = (0, $bSJIT.useCallback)(()=>{
        var _api$blockControls, _blockControlsState$a, _blockControlsState$m, _blockControlsState$p;
        const blockControlsState = api === null || api === void 0 || (_api$blockControls = api.blockControls) === null || _api$blockControls === void 0 ? void 0 : _api$blockControls.sharedState.currentState();
        // The editor selection is not necessarily in the block the menu was opened for.
        const from = (blockControlsState === null || blockControlsState === void 0 || (_blockControlsState$a = blockControlsState.activeNode) === null || _blockControlsState$a === void 0 ? void 0 : _blockControlsState$a.pos) ?? (blockControlsState === null || blockControlsState === void 0 || (_blockControlsState$m = blockControlsState.menuTriggerByNode) === null || _blockControlsState$m === void 0 ? void 0 : _blockControlsState$m.pos) ?? (blockControlsState === null || blockControlsState === void 0 || (_blockControlsState$p = blockControlsState.preservedSelection) === null || _blockControlsState$p === void 0 ? void 0 : _blockControlsState$p.from);
        return from === undefined ? undefined : getTopLevelBlockDomNodeAt(from);
    }, [
        api,
        getTopLevelBlockDomNodeAt
    ]);
    const getMovedBlockDomNode = (0, $bSJIT.useCallback)(()=>{
        // A move transaction maps its preserved selection onto the node it just moved, so this is
        // where that node ended up - unlike the block menu state, which keeps stale positions.
        const from = editorView === null || editorView === void 0 ? void 0 : editorView.state.selection.from;
        return from === undefined ? undefined : getTopLevelBlockDomNodeAt(from);
    }, [
        editorView,
        getTopLevelBlockDomNodeAt
    ]);
    const onDropdownOpenChanged = (0, $bSJIT.useCallback)((isOpen)=>{
        anchorMetricsRef.current = undefined;
        if (isOpen) {
            // The popup lays itself out next to the drag handle over the next frame or two.
            let remainingFrames = 3;
            const captureAnchorMetrics = ()=>{
                requestAnimationFrame(()=>{
                    anchorMetricsRef.current = (0, $8Sma6.getBlockMenuAnchorMetrics)(getSelectedBlockDomNode());
                    remainingFrames -= 1;
                    if (!anchorMetricsRef.current && remainingFrames > 0) captureAnchorMetrics();
                });
            };
            captureAnchorMetrics();
            return;
        }
        // On Dropdown closed, return focus to editor
        setTimeout(()=>requestAnimationFrame(()=>{
                api === null || api === void 0 || api.core.actions.focus({
                    scrollIntoView: false
                });
            }), 1);
    }, [
        api,
        getSelectedBlockDomNode
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)($0ea1c388206a8733$var$BlockMenuContext.Provider, {
        // eslint-disable-next-line @atlassian/perf-linting/no-inline-context-value, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        value: {
            onDropdownOpenChanged: onDropdownOpenChanged,
            moveDownRef: moveDownRef,
            moveUpRef: moveUpRef,
            getFirstSelectedDomNode: getFirstSelectedDomNode,
            getMovedBlockDomNode: getMovedBlockDomNode,
            getSelectedBlockDomNode: getSelectedBlockDomNode,
            anchorMetricsRef: anchorMetricsRef
        },
        children: children
    });
};

});
parcelRegister("8Sma6", function(module, exports) {
$parcel$export(module.exports, "getBlockMenuAnchorMetrics", () => $d521090cfd49dfb8$export$14a8a4d43280b99b);
$parcel$export(module.exports, "getBlockMenuPositionSnapshot", () => $d521090cfd49dfb8$export$556dc3717e87f4e4);
$parcel$export(module.exports, "scheduleBlockMenuPositionFix", () => $d521090cfd49dfb8$export$d9e3ec62bbe92ae7);

var $c9wRy = parcelRequire("c9wRy");

var $30Yan = parcelRequire("30Yan");

var $fdcHc = parcelRequire("fdcHc");
const $d521090cfd49dfb8$var$POPUP_WRAPPER_TEST_ID = 'popup-wrapper';
const $d521090cfd49dfb8$var$EDITOR_CONTENT_CONTAINER_SELECTOR = '[data-testid="editor-content-container"]';
/**
 * Breathing room left between the revealed block and the fold it just crossed, so the block does
 * not end up flush against the edge of the viewport.
 */ const $d521090cfd49dfb8$var$REVEAL_MARGIN = 8;
const $d521090cfd49dfb8$export$ed088d8d87374aaf = (dragHandleTop, dragHandleHeight, viewport)=>{
    if (dragHandleTop < viewport.top) return dragHandleTop - viewport.top;
    const dragHandleBottom = dragHandleTop + dragHandleHeight;
    if (dragHandleBottom > viewport.bottom) return dragHandleBottom - viewport.bottom;
    return 0;
};
/**
 * The editor content container is not always the element that actually scrolls - depending on the
 * product it can be an ancestor, or the document itself. Pick the closest one that really scrolls.
 */ const $d521090cfd49dfb8$var$getScrollContainer = (doc, selectedBlock)=>{
    const editorContentContainer = doc.querySelector($d521090cfd49dfb8$var$EDITOR_CONTENT_CONTAINER_SELECTOR);
    if (editorContentContainer && editorContentContainer.scrollHeight > editorContentContainer.clientHeight) return editorContentContainer;
    let ancestor = selectedBlock.parentElement;
    while(ancestor){
        var _doc$defaultView;
        const overflowY = (_doc$defaultView = doc.defaultView) === null || _doc$defaultView === void 0 ? void 0 : _doc$defaultView.getComputedStyle(ancestor).overflowY;
        if ((overflowY === 'auto' || overflowY === 'scroll') && ancestor.scrollHeight > ancestor.clientHeight) return ancestor;
        ancestor = ancestor.parentElement;
    }
    return doc.scrollingElement;
};
const $d521090cfd49dfb8$var$getScrollViewport = (doc, scrollContainer)=>{
    if (scrollContainer === doc.scrollingElement) {
        var _doc$defaultView2;
        return {
            bottom: ((_doc$defaultView2 = doc.defaultView) === null || _doc$defaultView2 === void 0 ? void 0 : _doc$defaultView2.innerHeight) ?? 0,
            top: 0
        };
    }
    const { top: top, bottom: bottom } = scrollContainer.getBoundingClientRect();
    return {
        bottom: bottom,
        top: top
    };
};
/**
 * Float based node views - a media group is one - collapse their top level wrapper to zero height,
 * so the visual bottom of the block has to come from its children.
 */ const $d521090cfd49dfb8$var$getBlockBottom = (block)=>{
    const rect = block.getBoundingClientRect();
    if (rect.height > 0) return rect.bottom;
    return Array.from(block.children).reduce((bottom, child)=>Math.max(bottom, child.getBoundingClientRect().bottom), rect.bottom);
};
const $d521090cfd49dfb8$var$setPopupTop = (blockMenuEl, targetTop)=>{
    const popupWrapper = blockMenuEl.closest(`[data-testid="${$d521090cfd49dfb8$var$POPUP_WRAPPER_TEST_ID}"]`) ?? blockMenuEl.parentElement;
    if (!(popupWrapper instanceof HTMLElement)) return;
    const distance = blockMenuEl.getBoundingClientRect().top - targetTop;
    const hasTopProperty = popupWrapper.style.top !== '';
    const hasBottomProperty = popupWrapper.style.bottom !== '';
    if (hasBottomProperty && !hasTopProperty) popupWrapper.style.bottom = `${parseFloat(popupWrapper.style.bottom || '0') + distance}px`;
    else popupWrapper.style.top = `${parseFloat(popupWrapper.style.top || '0') - distance}px`;
};
const $d521090cfd49dfb8$export$14a8a4d43280b99b = (selectedBlock)=>{
    var _doc$querySelector;
    const doc = (0, $c9wRy.getDocument)();
    const blockMenuEl = doc === null || doc === void 0 ? void 0 : doc.querySelector(`[data-testid="${(0, $30Yan.BLOCK_MENU_TEST_ID)}"]`);
    if (!doc || !selectedBlock || !blockMenuEl) return;
    const blockMenuRect = blockMenuEl.getBoundingClientRect();
    const dragHandleRect = (_doc$querySelector = doc.querySelector((0, $fdcHc.DRAG_HANDLE_SELECTOR))) === null || _doc$querySelector === void 0 ? void 0 : _doc$querySelector.getBoundingClientRect();
    if (blockMenuRect.height === 0 || !(dragHandleRect !== null && dragHandleRect !== void 0 && dragHandleRect.height)) return;
    const blockTop = selectedBlock.getBoundingClientRect().top;
    return {
        blockHeight: $d521090cfd49dfb8$var$getBlockBottom(selectedBlock) - blockTop,
        dragHandleHeight: dragHandleRect.height,
        dragHandleOffsetFromBlock: dragHandleRect.top - blockTop,
        popupOffsetFromBlock: blockMenuRect.top - blockTop,
        popupHeight: blockMenuRect.height
    };
};
const $d521090cfd49dfb8$export$556dc3717e87f4e4 = (selectedBlock, anchorMetrics)=>{
    const doc = (0, $c9wRy.getDocument)();
    if (!doc || !selectedBlock) return;
    const scrollContainer = $d521090cfd49dfb8$var$getScrollContainer(doc, selectedBlock);
    const metrics = anchorMetrics ?? $d521090cfd49dfb8$export$14a8a4d43280b99b(selectedBlock);
    if (!scrollContainer || !metrics) return;
    return {
        ...metrics,
        scrollContainer: scrollContainer,
        scrollTop: scrollContainer.scrollTop
    };
};
const $d521090cfd49dfb8$export$c178f82ad1bfa2e5 = (selectedNode, positionSnapshot)=>{
    const doc = (0, $c9wRy.getDocument)();
    if (!doc) return;
    const blockMenuEl = doc.querySelector(`[data-testid="${(0, $30Yan.BLOCK_MENU_TEST_ID)}"]`);
    if (!(blockMenuEl !== null && blockMenuEl !== void 0 && blockMenuEl.parentElement)) return;
    if (positionSnapshot) {
        if (!selectedNode) return;
        // Reuse the container resolved when the snapshot was taken - re-resolving it independently
        // here could pick a different element (e.g. for a node near an overflow boundary), applying
        // positionSnapshot.scrollTop to the wrong container.
        const scrollContainer = positionSnapshot.scrollContainer;
        // The move transaction scrolls the new selection into view - undo that, only a drag handle
        // leaving the viewport is allowed to move the editor.
        scrollContainer.scrollTo({
            behavior: 'instant',
            top: positionSnapshot.scrollTop
        });
        const viewport = $d521090cfd49dfb8$var$getScrollViewport(doc, scrollContainer);
        const anchorTop = selectedNode.getBoundingClientRect().top + positionSnapshot.dragHandleOffsetFromBlock;
        // Whether to scroll at all is decided by the drag handle alone - a block taller than the
        // viewport is expected to be cut off while its handle stays usable.
        if ($d521090cfd49dfb8$export$ed088d8d87374aaf(anchorTop, positionSnapshot.dragHandleHeight, viewport) === 0) return;
        // Once we do scroll, reveal the block and the popup, not just the handle sized sliver of it.
        // popupOffsetFromBlock is relative to the block - re-express it relative to the handle (the
        // anchor everything else here is measured from) to build one span covering all three. The
        // handle itself (0 to dragHandleHeight) always stays inside that span, so its visibility is
        // never sacrificed to make room for the block or the popup.
        const popupTopFromHandle = positionSnapshot.popupOffsetFromBlock - positionSnapshot.dragHandleOffsetFromBlock;
        const revealTop = Math.min(0, popupTopFromHandle);
        const revealBottom = Math.max(positionSnapshot.dragHandleHeight, positionSnapshot.blockHeight - positionSnapshot.dragHandleOffsetFromBlock, popupTopFromHandle + positionSnapshot.popupHeight);
        const revealHeight = Math.min(revealBottom - revealTop, Math.max(viewport.bottom - viewport.top - 2 * $d521090cfd49dfb8$var$REVEAL_MARGIN, 0));
        const scrollDistance = $d521090cfd49dfb8$export$ed088d8d87374aaf(anchorTop + revealTop - $d521090cfd49dfb8$var$REVEAL_MARGIN, revealHeight + 2 * $d521090cfd49dfb8$var$REVEAL_MARGIN, viewport);
        scrollContainer.scrollBy({
            behavior: 'instant',
            top: scrollDistance
        });
        $d521090cfd49dfb8$var$setPopupTop(blockMenuEl, selectedNode.getBoundingClientRect().top + positionSnapshot.popupOffsetFromBlock);
        return;
    }
    const scrollableContainer = doc.querySelector($d521090cfd49dfb8$var$EDITOR_CONTENT_CONTAINER_SELECTOR);
    if (!selectedNode || !scrollableContainer) return;
    const parentElement = blockMenuEl.parentElement;
    const currentTop = parentElement.getBoundingClientRect().top;
    const distance = selectedNode.getBoundingClientRect().top - blockMenuEl.getBoundingClientRect().top;
    scrollableContainer.scrollBy({
        behavior: 'instant',
        top: distance
    });
    const newTop = parentElement.getBoundingClientRect().top;
    const topDifference = currentTop - newTop;
    const hasTopProperty = parentElement.style.top !== '';
    const hasBottomProperty = parentElement.style.bottom !== '';
    if (hasBottomProperty && !hasTopProperty) {
        const currentBottomValue = parseFloat(parentElement.style.bottom || '0');
        parentElement.style.bottom = `${currentBottomValue - topDifference}px`;
    } else {
        const currentTopValue = parseFloat(parentElement.style.top || '0');
        parentElement.style.top = `${currentTopValue + topDifference}px`;
    }
};
const $d521090cfd49dfb8$export$d9e3ec62bbe92ae7 = (positionSnapshot, getMovedBlockDomNode, getFirstSelectedDomNode)=>{
    requestAnimationFrame(()=>{
        if (positionSnapshot) {
            $d521090cfd49dfb8$export$c178f82ad1bfa2e5(getMovedBlockDomNode(), positionSnapshot);
            return;
        }
        $d521090cfd49dfb8$export$c178f82ad1bfa2e5(getFirstSelectedDomNode());
    });
};

});


parcelRegister("hgaAb", function(module, exports) {
$parcel$export(module.exports, "BlockMenuRenderer", () => $b17659d92d14ee86$export$31e93a060be203b5);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $imZjB = parcelRequire("imZjB");

var $E3kbA = parcelRequire("E3kbA");

var $kwsSE = parcelRequire("kwsSE");
const $b17659d92d14ee86$export$31e93a060be203b5 = ({ allRegisteredComponents: allRegisteredComponents, fallbacks: fallbacks = (0, $E3kbA.BLOCK_MENU_FALLBACKS) })=>{
    const { childrenMap: childrenMap, topLevelSections: topLevelSections } = (0, $bSJIT.useMemo)(()=>({
            childrenMap: (0, $kwsSE.buildChildrenMap)(allRegisteredComponents),
            topLevelSections: (0, $kwsSE.getSortedTopLevelSections)(allRegisteredComponents)
        }), [
        allRegisteredComponents
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $imZjB.BlockMenuComponents), {
        registeredComponents: topLevelSections,
        childrenMap: childrenMap,
        fallbacks: fallbacks
    });
};

});
parcelRegister("imZjB", function(module, exports) {
$parcel$export(module.exports, "BlockMenuComponents", () => $d44d6ae2b4838031$export$de5057065abc3ddb);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $5DzcI = parcelRequire("5DzcI");
const $d44d6ae2b4838031$export$de5057065abc3ddb = ({ registeredComponents: registeredComponents, childrenMap: childrenMap, fallbacks: fallbacks })=>{
    if (!(registeredComponents !== null && registeredComponents !== void 0 && registeredComponents.length)) return null;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dc70d.Fragment), {
        children: registeredComponents.map((registeredComponent)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $5DzcI.BlockMenuComponent), {
                registeredComponent: registeredComponent,
                childrenMap: childrenMap,
                fallbacks: fallbacks
            }, registeredComponent.key))
    });
};

});
parcelRegister("5DzcI", function(module, exports) {
$parcel$export(module.exports, "BlockMenuComponent", () => $b13642348df8f73a$export$f37396fcdf7aa078);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $imZjB = parcelRequire("imZjB");

var $kwsSE = parcelRequire("kwsSE");
const $b13642348df8f73a$export$f37396fcdf7aa078 = ({ registeredComponent: registeredComponent, childrenMap: childrenMap, fallbacks: fallbacks })=>{
    if (!(0, $kwsSE.willComponentRender)(registeredComponent, childrenMap)) return null;
    if (registeredComponent.type === 'block-menu-item') {
        const ItemComponent = registeredComponent.component || fallbacks['block-menu-item'];
        return /*#__PURE__*/ (0, $dc70d.jsx)(ItemComponent, {}, registeredComponent.key);
    }
    const ParentComponent = registeredComponent.component || fallbacks[registeredComponent.type];
    const childrenMapKey = (0, $kwsSE.getChildrenMapKey)(registeredComponent.key, registeredComponent.type);
    const registeredComponents = childrenMap.get(childrenMapKey);
    return /*#__PURE__*/ (0, $dc70d.jsx)(ParentComponent, {
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $imZjB.BlockMenuComponents), {
            registeredComponents: registeredComponents,
            childrenMap: childrenMap,
            fallbacks: fallbacks
        })
    }, registeredComponent.key);
};

});
parcelRegister("kwsSE", function(module, exports) {
$parcel$export(module.exports, "getSortedTopLevelSections", () => $174ca32a2e1ee646$export$c21fbbc4028db8fb);
$parcel$export(module.exports, "getChildrenMapKey", () => $174ca32a2e1ee646$export$78a1be09e8c33cbb);
$parcel$export(module.exports, "buildChildrenMap", () => $174ca32a2e1ee646$export$93e686d60d327014);
$parcel$export(module.exports, "willComponentRender", () => $174ca32a2e1ee646$export$51a8f8a5d7877637);
/**
 * Type guard to check if a component has a parent
 *
 * @param component The block menu component to check
 * @returns True if the component has a parent, false otherwise
 */ const $174ca32a2e1ee646$var$hasParent = (component)=>{
    return 'parent' in component && !!component.parent;
};
/**
 * Type guard to identify top-level sections (sections without a parent)
 *
 * @param component The block menu component to check
 * @returns True if the component is a top-level section, false otherwise
 */ const $174ca32a2e1ee646$var$isTopLevelSection = (component)=>{
    return component.type === 'block-menu-section' && !$174ca32a2e1ee646$var$hasParent(component);
};
const $174ca32a2e1ee646$export$c21fbbc4028db8fb = (components)=>{
    return components.filter($174ca32a2e1ee646$var$isTopLevelSection).sort((a, b)=>(a.rank || 0) - (b.rank || 0));
};
const $174ca32a2e1ee646$export$78a1be09e8c33cbb = (key, type)=>{
    return `${type}:${key}`;
};
const $174ca32a2e1ee646$export$93e686d60d327014 = (components)=>{
    const childrenMap = new Map();
    for (const component of components)// Only components with parents can be children
    if ('parent' in component && !!component.parent) {
        const childrenMapKey = $174ca32a2e1ee646$export$78a1be09e8c33cbb(component.parent.key, component.parent.type);
        const existing = childrenMap.get(childrenMapKey) || [];
        existing.push(component);
        childrenMap.set(childrenMapKey, existing);
    }
    // Sort children by their rank within their parent
    for (const [, children] of childrenMap.entries())children.sort((a, b)=>{
        const rankA = $174ca32a2e1ee646$var$hasParent(a) ? a.parent.rank || 0 : 0;
        const rankB = $174ca32a2e1ee646$var$hasParent(b) ? b.parent.rank || 0 : 0;
        return rankA - rankB;
    });
    return childrenMap;
};
const $174ca32a2e1ee646$export$51a8f8a5d7877637 = (registeredComponent, childrenMap)=>{
    if (registeredComponent.type === 'block-menu-item') {
        var _registeredComponent$;
        return !(registeredComponent !== null && registeredComponent !== void 0 && (_registeredComponent$ = registeredComponent.isHidden) !== null && _registeredComponent$ !== void 0 && _registeredComponent$.call(registeredComponent));
    }
    const childrenMapKey = $174ca32a2e1ee646$export$78a1be09e8c33cbb(registeredComponent.key, registeredComponent.type);
    const registeredComponents = childrenMap.get(childrenMapKey) || [];
    return registeredComponents.some((childComponent)=>$174ca32a2e1ee646$export$51a8f8a5d7877637(childComponent, childrenMap));
};

});



parcelRegister("E3kbA", function(module, exports) {
$parcel$export(module.exports, "BLOCK_MENU_FALLBACKS", () => $513a08f9c61f9a3c$export$5b562d75078c479b);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $hETL4 = parcelRequire("hETL4");

var $dbuPt = parcelRequire("dbuPt");

var $dlk6h = parcelRequire("dlk6h");

var $1gwdz = parcelRequire("1gwdz");

var $l9Ysx = parcelRequire("l9Ysx");

var $9QUTn = parcelRequire("9QUTn");
const $513a08f9c61f9a3c$var$FallbackNestedMenu = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const targetVisible = (0, $9QUTn.useBlockMenuTargetVisibility)();
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $1gwdz.ToolbarNestedDropdownMenu), {
        isPopupVisible: targetVisible,
        elemBefore: undefined,
        elemAfter: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l9Ysx))), {
            label: "",
            size: "small"
        }),
        text: formatMessage((0, $hETL4.messages).fallbackNestedMenu),
        enableMaxHeight: true,
        shouldFitContainer: true,
        children: children
    });
};
const $513a08f9c61f9a3c$var$FallbackMenuItem = ()=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dbuPt.ToolbarDropdownItem), {
        children: formatMessage((0, $hETL4.messages).fallbackMenuItem)
    });
};
const $513a08f9c61f9a3c$export$5b562d75078c479b = {
    'block-menu-nested': $513a08f9c61f9a3c$var$FallbackNestedMenu,
    'block-menu-section': ({ children: children })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $dlk6h.ToolbarDropdownItemSection), {
            children: children
        }),
    'block-menu-item': $513a08f9c61f9a3c$var$FallbackMenuItem
};

});
parcelRegister("9QUTn", function(module, exports) {
$parcel$export(module.exports, "BlockMenuTargetVisibilityProvider", () => $91876869dfd9b1d8$export$a546decb48cd384e);
$parcel$export(module.exports, "useBlockMenuTargetVisibility", () => $91876869dfd9b1d8$export$28020221d7981464);

var $bSJIT = parcelRequire("bSJIT");
const $91876869dfd9b1d8$var$BlockMenuTargetVisibilityContext = (0, $bSJIT.createContext)(undefined);
const $91876869dfd9b1d8$export$a546decb48cd384e = $91876869dfd9b1d8$var$BlockMenuTargetVisibilityContext.Provider;
const $91876869dfd9b1d8$export$28020221d7981464 = ()=>(0, $bSJIT.useContext)($91876869dfd9b1d8$var$BlockMenuTargetVisibilityContext);

});




parcelRegister("l4hdc", function(module, exports) {
$parcel$export(module.exports, "getBlockMenuComponents", () => $87344f23246f0c99$export$b1be7b75e24fc24b);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $30Yan = parcelRequire("30Yan");

var $fY4jW = parcelRequire("fY4jW");

var $hETL4 = parcelRequire("hETL4");

var $dlk6h = parcelRequire("dlk6h");

var $3y2s4 = parcelRequire("3y2s4");

var $kwsSE = parcelRequire("kwsSE");

var $G1gkA = parcelRequire("G1gkA");

var $hPESD = parcelRequire("hPESD");

var $hUP59 = parcelRequire("hUP59");

var $hTCu5 = parcelRequire("hTCu5");

var $f2Y6L = parcelRequire("f2Y6L");

var $1CXNU = parcelRequire("1CXNU");

var $7taKW = parcelRequire("7taKW");

var $cYzbe = parcelRequire("cYzbe");

var $8boLk = parcelRequire("8boLk");

var $UhNhV = parcelRequire("UhNhV");

var $kNWxR = parcelRequire("kNWxR");

var $h1PPq = parcelRequire("h1PPq");

var $4a1ca = parcelRequire("4a1ca");

var $5Ksm0 = parcelRequire("5Ksm0");

var $aVr8t = parcelRequire("aVr8t");
const $87344f23246f0c99$var$MIN_NUMBER_OF_AVAILABLE_NATIVE_TRANSFORMS = 7;
const $87344f23246f0c99$var$getTotalNumberOfAvailableNativeTransforms = (blockMenuComponents)=>{
    if (!blockMenuComponents) return 0;
    const childrenMap = (0, $kwsSE.buildChildrenMap)(blockMenuComponents);
    const headingsKey = (0, $kwsSE.getChildrenMapKey)((0, $30Yan.TRANSFORM_TEXTFORMATTING_MENU_SECTION).key, 'block-menu-section');
    const structureKey = (0, $kwsSE.getChildrenMapKey)((0, $30Yan.TRANSFORM_STRUCTURE_MENU_SECTION).key, 'block-menu-section');
    const headingsChildren = childrenMap.get(headingsKey) || [];
    const structureChildren = childrenMap.get(structureKey) || [];
    return [
        ...headingsChildren,
        ...structureChildren
    ].filter((c)=>(0, $kwsSE.willComponentRender)(c, childrenMap)).length;
};
const $87344f23246f0c99$var$getMoveUpMoveDownMenuComponents = (api)=>{
    return [
        {
            type: 'block-menu-item',
            key: (0, $30Yan.POSITION_MOVE_UP_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $30Yan.POSITION_MENU_SECTION).key,
                rank: (0, $fY4jW.POSITION_MENU_SECTION_RANK)[(0, $30Yan.POSITION_MOVE_UP_MENU_ITEM).key]
            },
            component: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $8boLk.MoveUpDropdownItem), {
                    api: api
                })
        },
        {
            type: 'block-menu-item',
            key: (0, $30Yan.POSITION_MOVE_DOWN_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $30Yan.POSITION_MENU_SECTION).key,
                rank: (0, $fY4jW.POSITION_MENU_SECTION_RANK)[(0, $30Yan.POSITION_MOVE_DOWN_MENU_ITEM).key]
            },
            component: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $cYzbe.MoveDownDropdownItem), {
                    api: api
                })
        }
    ];
};
const $87344f23246f0c99$var$getTurnIntoMenuComponents = (api)=>{
    return [
        {
            type: 'block-menu-nested',
            key: (0, $30Yan.TRANSFORM_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $30Yan.TRANSFORM_MENU_SECTION).key,
                rank: (0, $fY4jW.TRANSFORM_MENU_SECTION_RANK)[(0, $30Yan.TRANSFORM_MENU_ITEM).key]
            },
            component: ({ children: children } = {
                children: null
            })=>{
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $f2Y6L.FormatMenuComponent), {
                    api: api,
                    children: children
                });
            },
            isHidden: ()=>(0, $4a1ca.checkIsFormatMenuHidden)(api)
        },
        {
            type: 'block-menu-section',
            key: (0, $30Yan.TRANSFORM_SUGGESTED_MENU_SECTION).key,
            parent: {
                type: 'block-menu-nested',
                key: (0, $30Yan.TRANSFORM_MENU_ITEM).key,
                rank: (0, $fY4jW.TRANSFORM_MENU_ITEM_RANK)[(0, $30Yan.TRANSFORM_SUGGESTED_MENU_SECTION).key]
            },
            component: ({ children: children } = {
                children: null
            })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $UhNhV.SuggestedItemsMenuSection), {
                    api: api,
                    children: children
                })
        },
        {
            type: 'block-menu-item',
            key: (0, $30Yan.TRANSFORM_SUGGESTED_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $30Yan.TRANSFORM_SUGGESTED_MENU_SECTION).key,
                rank: (0, $fY4jW.TRANSFORM_SUGGESTED_MENU_SECTION_RANK)[(0, $30Yan.TRANSFORM_SUGGESTED_MENU_ITEM).key]
            },
            component: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $kNWxR.SuggestedMenuItems), {
                    api: api
                }),
            isHidden: ()=>{
                var _api$blockMenu, _api$selection, _api$blockControls;
                const blockMenuComponents = api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 ? void 0 : _api$blockMenu.actions.getBlockMenuComponents();
                if ($87344f23246f0c99$var$getTotalNumberOfAvailableNativeTransforms(blockMenuComponents) < $87344f23246f0c99$var$MIN_NUMBER_OF_AVAILABLE_NATIVE_TRANSFORMS) return true;
                const menuItemsMap = (0, $5Ksm0.createMenuItemsMap)(blockMenuComponents);
                const selection = api === null || api === void 0 || (_api$selection = api.selection) === null || _api$selection === void 0 || (_api$selection = _api$selection.sharedState.currentState()) === null || _api$selection === void 0 ? void 0 : _api$selection.selection;
                const preservedSelection = api === null || api === void 0 || (_api$blockControls = api.blockControls) === null || _api$blockControls === void 0 || (_api$blockControls = _api$blockControls.sharedState.currentState()) === null || _api$blockControls === void 0 ? void 0 : _api$blockControls.preservedSelection;
                const currentSelection = preservedSelection || selection;
                const suggestedItems = (0, $aVr8t.getSuggestedItemsFromSelection)(menuItemsMap, currentSelection);
                return suggestedItems.length === 0;
            }
        },
        {
            type: 'block-menu-section',
            key: (0, $30Yan.TRANSFORM_CREATE_MENU_SECTION).key,
            parent: {
                type: 'block-menu-nested',
                key: (0, $30Yan.TRANSFORM_MENU_ITEM).key,
                rank: (0, $fY4jW.TRANSFORM_MENU_ITEM_RANK)[(0, $30Yan.TRANSFORM_CREATE_MENU_SECTION).key]
            },
            component: ({ children: children } = {
                children: null
            })=>{
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $7taKW.MenuSection), {
                    title: (0, $hETL4.messages).create,
                    hasSeparator: (0, $h1PPq.hasContentBeforeCreate)(api),
                    children: children
                });
            }
        },
        {
            type: 'block-menu-section',
            key: (0, $30Yan.TRANSFORM_STRUCTURE_MENU_SECTION).key,
            parent: {
                type: 'block-menu-nested',
                key: (0, $30Yan.TRANSFORM_MENU_ITEM).key,
                rank: (0, $fY4jW.TRANSFORM_MENU_ITEM_RANK)[(0, $30Yan.TRANSFORM_STRUCTURE_MENU_SECTION).key]
            },
            component: ({ children: children } = {
                children: null
            })=>{
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $7taKW.MenuSection), {
                    title: (0, $hETL4.messages).structure,
                    hasSeparator: (0, $h1PPq.hasContentBeforeStructure)(api),
                    children: children
                });
            }
        },
        {
            type: 'block-menu-section',
            key: (0, $30Yan.TRANSFORM_TEXTFORMATTING_MENU_SECTION).key,
            parent: {
                type: 'block-menu-nested',
                key: (0, $30Yan.TRANSFORM_MENU_ITEM).key,
                rank: (0, $fY4jW.TRANSFORM_MENU_ITEM_RANK)[(0, $30Yan.TRANSFORM_TEXTFORMATTING_MENU_SECTION).key]
            },
            component: ({ children: children } = {
                children: null
            })=>{
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $7taKW.MenuSection), {
                    title: (0, $3y2s4.isExperimentEnabled)('platform_editor_block_menu_small_text') ? (0, $hETL4.messages).textFormatting : (0, $hETL4.messages).headings,
                    hasSeparator: (0, $h1PPq.hasContentBeforeTextFormatting)(api),
                    children: children
                });
            }
        },
        {
            type: 'block-menu-section',
            key: (0, $30Yan.TRANSFORM_MENU_SECTION).key,
            rank: (0, $fY4jW.MAIN_BLOCK_MENU_SECTION_RANK)[(0, $30Yan.TRANSFORM_MENU_SECTION).key],
            component: ({ children: children })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $1CXNU.FormatMenuSection), {
                    api: api,
                    children: children
                })
        }
    ];
};
const $87344f23246f0c99$export$b1be7b75e24fc24b = ({ api: api, config: config })=>{
    return [
        ...$87344f23246f0c99$var$getTurnIntoMenuComponents(api),
        {
            type: 'block-menu-section',
            key: (0, $30Yan.BLOCK_ACTIONS_MENU_SECTION).key,
            rank: (0, $fY4jW.MAIN_BLOCK_MENU_SECTION_RANK)[(0, $30Yan.BLOCK_ACTIONS_MENU_SECTION).key],
            component: ({ children: children })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $hPESD.CopySection), {
                    children: children
                })
        },
        {
            type: 'block-menu-section',
            key: (0, $30Yan.BLOCK_ACTIONS_COPY_MENU_SECTION).key,
            rank: (0, $fY4jW.MAIN_BLOCK_MENU_SECTION_RANK)[(0, $30Yan.BLOCK_ACTIONS_COPY_MENU_SECTION).key],
            component: ({ children: children })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $dlk6h.ToolbarDropdownItemSection), {
                    hasSeparator: true,
                    children: children
                })
        },
        {
            type: 'block-menu-item',
            key: (0, $30Yan.BLOCK_ACTIONS_COPY_LINK_TO_BLOCK_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $30Yan.BLOCK_ACTIONS_COPY_MENU_SECTION).key,
                rank: (0, $fY4jW.BLOCK_ACTIONS_COPY_MENU_SECTION_RANK)[(0, $30Yan.BLOCK_ACTIONS_COPY_LINK_TO_BLOCK_MENU_ITEM).key]
            },
            component: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $G1gkA.CopyLinkDropdownItem), {
                    api: api,
                    config: config
                })
        },
        {
            type: 'block-menu-section',
            key: (0, $30Yan.POSITION_MENU_SECTION).key,
            rank: (0, $fY4jW.MAIN_BLOCK_MENU_SECTION_RANK)[(0, $30Yan.POSITION_MENU_SECTION).key],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dlk6h.ToolbarDropdownItemSection), {
                    hasSeparator: true,
                    children: children
                });
            }
        },
        ...$87344f23246f0c99$var$getMoveUpMoveDownMenuComponents(api),
        {
            type: 'block-menu-section',
            key: (0, $30Yan.DELETE_MENU_SECTION).key,
            rank: (0, $fY4jW.MAIN_BLOCK_MENU_SECTION_RANK)[(0, $30Yan.DELETE_MENU_SECTION).key],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $hTCu5.DeleteSection), {
                    children: children
                });
            }
        },
        {
            type: 'block-menu-item',
            key: (0, $30Yan.DELETE_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $30Yan.DELETE_MENU_SECTION).key,
                rank: (0, $fY4jW.DELETE_MENU_SECTION_RANK)[(0, $30Yan.DELETE_MENU_ITEM).key]
            },
            component: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $hUP59.DeleteDropdownItem), {
                    api: api
                })
        }
    ];
};

});
parcelRegister("G1gkA", function(module, exports) {
$parcel$export(module.exports, "CopyLinkDropdownItem", () => $e55e140c61f1f6c2$export$86b0dd217bb75f55);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $fK3tS = parcelRequire("fK3tS");
var $4vLTk = parcelRequire("4vLTk");

var $g6Qq4 = parcelRequire("g6Qq4");

var $30Yan = parcelRequire("30Yan");

var $cv8id = parcelRequire("cv8id");

var $hETL4 = parcelRequire("hETL4");

var $5beht = parcelRequire("5beht");

var $dbuPt = parcelRequire("dbuPt");

var $jBWM2 = parcelRequire("jBWM2");

var $gRfjb = parcelRequire("gRfjb");

var $kyeIc = parcelRequire("kyeIc");

var $aCsiM = parcelRequire("aCsiM");

var $8eUTO = parcelRequire("8eUTO");

var $cm3rY = parcelRequire("cm3rY");

var $91f6Q = parcelRequire("91f6Q");

var $dlxOP = parcelRequire("dlxOP");
const $e55e140c61f1f6c2$var$CopyLinkDropdownItemContent = ({ api: api, config: config })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { onDropdownOpenChanged: onDropdownOpenChanged } = (0, $cm3rY.useBlockMenu)();
    const { getLinkPath: getLinkPath, blockLinkHashPrefix: blockLinkHashPrefix } = config || {};
    const shortcut = (0, $cv8id.formatShortcut)((0, $cv8id.copyLinkToBlock));
    const { preservedSelection: preservedSelection, defaultSelection: defaultSelection } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'blockControls',
        'selection'
    ], ({ blockControlsState: blockControlsState, selectionState: selectionState })=>{
        return {
            preservedSelection: blockControlsState === null || blockControlsState === void 0 ? void 0 : blockControlsState.preservedSelection,
            defaultSelection: selectionState === null || selectionState === void 0 ? void 0 : selectionState.selection
        };
    });
    const selection = preservedSelection || defaultSelection;
    const handleClick = (0, $bSJIT.useCallback)(()=>{
        if (!selection) return;
        api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
            var _api$analytics, _api$blockControls;
            const payload = {
                action: (0, $g6Qq4.ACTION).CLICKED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).BLOCK_MENU_ITEM,
                attributes: {
                    menuItemName: (0, $91f6Q.BLOCK_MENU_ITEM_NAME).COPY_LINK_TO_BLOCK
                },
                eventType: (0, $g6Qq4.EVENT_TYPE).UI
            };
            api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || (_api$analytics = _api$analytics.actions) === null || _api$analytics === void 0 || _api$analytics.attachAnalyticsEvent(payload)(tr);
            api === null || api === void 0 || (_api$blockControls = api.blockControls) === null || _api$blockControls === void 0 || (_api$blockControls = _api$blockControls.commands) === null || _api$blockControls === void 0 || _api$blockControls.toggleBlockMenu({
                closeMenu: true
            })({
                tr: tr
            });
            return tr;
        });
        onDropdownOpenChanged(false);
        (0, $dlxOP.copyLink)({
            getLinkPath: getLinkPath,
            blockLinkHashPrefix: blockLinkHashPrefix,
            selection: selection
        }).then((success)=>{
            if (success) api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
                tr.setMeta((0, $aCsiM.blockMenuPluginKey), {
                    showFlag: (0, $kyeIc.FLAG_ID).LINK_COPIED_TO_CLIPBOARD
                });
                return tr;
            });
        });
    }, [
        api,
        blockLinkHashPrefix,
        getLinkPath,
        onDropdownOpenChanged,
        selection
    ]);
    if (!(0, $8eUTO.isCopyLinkEnabled)(config)) return null;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dbuPt.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gRfjb))), {
            label: "",
            size: "small"
        }),
        elemAfter: shortcut ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $jBWM2.ToolbarKeyboardShortcutHint), {
            shortcut: shortcut
        }) : undefined,
        ariaKeyshortcuts: shortcut,
        testId: (0, $30Yan.BLOCK_MENU_ACTION_TEST_ID).COPY_LINK,
        children: formatMessage((0, $hETL4.messages).copyLinkToSelection)
    });
};
const $e55e140c61f1f6c2$export$86b0dd217bb75f55 = (0, $fK3tS.default)($e55e140c61f1f6c2$var$CopyLinkDropdownItemContent);

});
parcelRegister("91f6Q", function(module, exports) {
$parcel$export(module.exports, "BLOCK_MENU_ITEM_NAME", () => $850ab3183139edc3$export$659b32b68ac9a52b);
const $850ab3183139edc3$export$3049469618923b43 = 'Editor Block Menu';
const $850ab3183139edc3$export$659b32b68ac9a52b = {
    COPY_LINK_TO_BLOCK: 'copyLinkToBlock',
    MOVE_UP: 'moveUp',
    MOVE_DOWN: 'moveDown',
    DELETE: 'delete',
    FORMAT_MENU: 'formatMenu'
};

});


parcelRegister("hPESD", function(module, exports) {
$parcel$export(module.exports, "CopySection", () => $977f447e0d2e1547$export$ec4637f07afe304);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $dlk6h = parcelRequire("dlk6h");
const $977f447e0d2e1547$export$ec4637f07afe304 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dlk6h.ToolbarDropdownItemSection), {
        hasSeparator: true,
        children: children
    });
};

});

parcelRegister("hUP59", function(module, exports) {
$parcel$export(module.exports, "DeleteDropdownItem", () => $8dce4835a5b1599e$export$920a93f5040e5764);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $fK3tS = parcelRequire("fK3tS");
var $4vLTk = parcelRequire("4vLTk");

var $g6Qq4 = parcelRequire("g6Qq4");

var $30Yan = parcelRequire("30Yan");

var $hETL4 = parcelRequire("hETL4");

var $6Cbfp = parcelRequire("6Cbfp");

var $dbuPt = parcelRequire("dbuPt");

var $gV64P = parcelRequire("gV64P");

var $gUpf2 = parcelRequire("gUpf2");

var $aRsbV = parcelRequire("aRsbV");

var $91f6Q = parcelRequire("91f6Q");
const $8dce4835a5b1599e$var$DeleteDropdownItemContent = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const onClick = ()=>{
        api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
            var _api$analytics, _api$blockControls, _api$blockControls2;
            const payload = {
                action: (0, $g6Qq4.ACTION).CLICKED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).BLOCK_MENU_ITEM,
                attributes: {
                    menuItemName: (0, $91f6Q.BLOCK_MENU_ITEM_NAME).DELETE
                },
                eventType: (0, $g6Qq4.EVENT_TYPE).UI
            };
            api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || (_api$analytics = _api$analytics.actions) === null || _api$analytics === void 0 || _api$analytics.attachAnalyticsEvent(payload)(tr);
            // Extract node information before deletion
            const preservedSelection = api === null || api === void 0 || (_api$blockControls = api.blockControls) === null || _api$blockControls === void 0 || (_api$blockControls = _api$blockControls.sharedState.currentState()) === null || _api$blockControls === void 0 ? void 0 : _api$blockControls.preservedSelection;
            const selection = preservedSelection || tr.selection;
            const sourceNodes = (0, $6Cbfp.getSourceNodesFromSelectionRange)(tr, selection);
            const nodeCount = sourceNodes.length;
            // Fire node deletion analytics event if nodes are being deleted
            if (nodeCount > 0) {
                var _api$analytics2;
                const nodeType = sourceNodes.length === 1 ? sourceNodes[0].type.name : 'multiple';
                const nodeDeletedPayload = {
                    action: (0, $g6Qq4.ACTION).DELETED,
                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).ELEMENT,
                    attributes: {
                        inputMethod: (0, $g6Qq4.INPUT_METHOD).BLOCK_MENU,
                        nodeType: nodeType,
                        nodeCount: nodeCount
                    },
                    eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
                };
                api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 || (_api$analytics2 = _api$analytics2.actions) === null || _api$analytics2 === void 0 || _api$analytics2.attachAnalyticsEvent(nodeDeletedPayload)(tr);
            }
            (0, $6Cbfp.deleteSelectedRange)(tr, preservedSelection);
            api === null || api === void 0 || (_api$blockControls2 = api.blockControls) === null || _api$blockControls2 === void 0 || (_api$blockControls2 = _api$blockControls2.commands) === null || _api$blockControls2 === void 0 || _api$blockControls2.toggleBlockMenu({
                closeMenu: true
            })({
                tr: tr
            });
            if (preservedSelection) {
                var _api$blockControls3;
                api === null || api === void 0 || (_api$blockControls3 = api.blockControls) === null || _api$blockControls3 === void 0 || (_api$blockControls3 = _api$blockControls3.commands) === null || _api$blockControls3 === void 0 || _api$blockControls3.stopPreservingSelection()({
                    tr: tr
                });
            }
            return tr;
        });
        api === null || api === void 0 || api.core.actions.focus();
    };
    const onShowHoverDecoration = (0, $bSJIT.useCallback)(()=>{
        api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
            var _api$blockControls4, _api$decorations, _api$decorations$hove;
            const preservedSelection = api === null || api === void 0 || (_api$blockControls4 = api.blockControls) === null || _api$blockControls4 === void 0 || (_api$blockControls4 = _api$blockControls4.sharedState.currentState()) === null || _api$blockControls4 === void 0 ? void 0 : _api$blockControls4.preservedSelection;
            api === null || api === void 0 || (_api$decorations = api.decorations) === null || _api$decorations === void 0 || (_api$decorations = _api$decorations.commands) === null || _api$decorations === void 0 || (_api$decorations$hove = _api$decorations.hoverDecoration) === null || _api$decorations$hove === void 0 || _api$decorations$hove.call(_api$decorations, {
                add: true,
                selection: preservedSelection
            })({
                tr: tr
            });
            return tr;
        });
    }, [
        api
    ]);
    const onRemoveHoverDecoration = (0, $bSJIT.useCallback)(()=>{
        api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
            var _api$decorations2, _api$decorations2$rem;
            api === null || api === void 0 || (_api$decorations2 = api.decorations) === null || _api$decorations2 === void 0 || (_api$decorations2 = _api$decorations2.commands) === null || _api$decorations2 === void 0 || (_api$decorations2$rem = _api$decorations2.removeDecoration) === null || _api$decorations2$rem === void 0 || _api$decorations2$rem.call(_api$decorations2)({
                tr: tr
            });
            return tr;
        });
    }, [
        api
    ]);
    (0, $bSJIT.useEffect)(()=>{
        return ()=>{
            // clean up hover decoration when unmounting
            onRemoveHoverDecoration();
        };
    }, [
        onRemoveHoverDecoration
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $gUpf2.Box), {
        onMouseEnter: onShowHoverDecoration,
        onMouseLeave: onRemoveHoverDecoration,
        onFocus: onShowHoverDecoration,
        onBlur: onRemoveHoverDecoration,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $dbuPt.ToolbarDropdownItem), {
            elemBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gV64P))), {
                color: "var(--ds-icon-danger, #C9372C)",
                label: "",
                size: "small"
            }),
            onClick: onClick,
            testId: (0, $30Yan.BLOCK_MENU_ACTION_TEST_ID).DELETE,
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $aRsbV.Text), {
                as: "span",
                color: "color.text.danger",
                children: formatMessage((0, $hETL4.messages).deleteBlock)
            })
        })
    });
};
const $8dce4835a5b1599e$export$920a93f5040e5764 = (0, $fK3tS.default)($8dce4835a5b1599e$var$DeleteDropdownItemContent);

});

parcelRegister("hTCu5", function(module, exports) {
$parcel$export(module.exports, "DeleteSection", () => $63089674fcd65c94$export$b65e02347f5cba52);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $dlk6h = parcelRequire("dlk6h");
const $63089674fcd65c94$export$b65e02347f5cba52 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dlk6h.ToolbarDropdownItemSection), {
        hasSeparator: true,
        children: children
    });
};

});

parcelRegister("f2Y6L", function(module, exports) {
$parcel$export(module.exports, "FormatMenuComponent", () => $dcec4ca35fdcbcbf$export$d1e6269624c4d543);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $g6Qq4 = parcelRequire("g6Qq4");

var $hETL4 = parcelRequire("hETL4");

var $1gwdz = parcelRequire("1gwdz");

var $6KOKW = parcelRequire("6KOKW");

var $l9Ysx = parcelRequire("l9Ysx");

var $gdUUy = parcelRequire("gdUUy");

var $9QUTn = parcelRequire("9QUTn");

var $91f6Q = parcelRequire("91f6Q");
const $dcec4ca35fdcbcbf$var$BLOCK_MENU_TRANSFORM_SPOTLIGHT_PORTAL_SELECTOR = '[data-test-id="block-menu-transform-spotlight-portal-container"]';
const $dcec4ca35fdcbcbf$var$shouldIgnoreBlockMenuTransformSpotlightCloseEvent = (event)=>event.target instanceof Element && event.target.closest($dcec4ca35fdcbcbf$var$BLOCK_MENU_TRANSFORM_SPOTLIGHT_PORTAL_SELECTOR) !== null;
const $dcec4ca35fdcbcbf$export$d1e6269624c4d543 = ({ api: api, children: children })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const targetVisible = (0, $9QUTn.useBlockMenuTargetVisibility)();
    const formatMenuLabel = (0, $hETL4.messages).changeFormat;
    const handleClick = (0, $bSJIT.useCallback)(()=>{
        api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
            var _api$analytics;
            const payload = {
                action: (0, $g6Qq4.ACTION).CLICKED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).BLOCK_MENU_ITEM,
                attributes: {
                    menuItemName: (0, $91f6Q.BLOCK_MENU_ITEM_NAME).FORMAT_MENU
                },
                eventType: (0, $g6Qq4.EVENT_TYPE).UI
            };
            api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || (_api$analytics = _api$analytics.actions) === null || _api$analytics === void 0 || _api$analytics.attachAnalyticsEvent(payload)(tr);
            return tr;
        });
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $1gwdz.ToolbarNestedDropdownMenu), {
        isPopupVisible: targetVisible,
        text: formatMessage(formatMenuLabel),
        elemBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6KOKW))), {
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l9Ysx))), {
            label: "",
            size: "small"
        }),
        enableMaxHeight: true,
        onClick: handleClick,
        dropdownTestId: "editor-turn-into-menu",
        testId: (0, $gdUUy.fg)('cc_blocks_changeboarding') ? 'turn-into-block-menu-btn' : undefined,
        shouldFitContainer: true,
        shouldIgnoreCloseEvent: (0, $gdUUy.fg)('cc_blocks_changeboarding') ? $dcec4ca35fdcbcbf$var$shouldIgnoreBlockMenuTransformSpotlightCloseEvent : undefined,
        children: children
    });
};

});

parcelRegister("1CXNU", function(module, exports) {
$parcel$export(module.exports, "FormatMenuSection", () => $e31f669a5096d1a3$export$c21c1480ef33ab5);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $dlk6h = parcelRequire("dlk6h");

var $3y2s4 = parcelRequire("3y2s4");

var $4zjoa = parcelRequire("4zjoa");

var $4a1ca = parcelRequire("4a1ca");
const $e31f669a5096d1a3$export$c21c1480ef33ab5 = ({ children: children, api: api })=>{
    const isFormatMenuHidden = (0, $bSJIT.useCallback)(()=>{
        return (0, $4a1ca.checkIsFormatMenuHidden)(api);
    }, [
        api
    ]);
    if (isFormatMenuHidden()) return null;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dlk6h.ToolbarDropdownItemSection), {
        hasSeparator: (0, $4zjoa.expValEqualsNoExposure)('platform_editor_ai_blockmenu_integration', 'isEnabled', true) || (0, $3y2s4.isExperimentEnabled)('platform_editor_ai_blockmenu_integration_jira'),
        children: children
    });
};

});
parcelRegister("4a1ca", function(module, exports) {
$parcel$export(module.exports, "checkIsFormatMenuHidden", () => $ec22fae3df16ec92$export$b9b8afbbcc99cd12);

var $gab48 = parcelRequire("gab48");
const $ec22fae3df16ec92$var$getIsFormatMenuHidden = (selection, schema)=>{
    const nodes = schema.nodes;
    if (!nodes) return false;
    const disabledNode = (0, $gab48.findSelectedNodeOfType)([
        nodes.rule
    ])(selection);
    return !!disabledNode;
};
const $ec22fae3df16ec92$export$b9b8afbbcc99cd12 = (api)=>{
    var _api$selection, _api$core$sharedState, _api$blockControls;
    const selection = api === null || api === void 0 || (_api$selection = api.selection) === null || _api$selection === void 0 || (_api$selection = _api$selection.sharedState) === null || _api$selection === void 0 || (_api$selection = _api$selection.currentState()) === null || _api$selection === void 0 ? void 0 : _api$selection.selection;
    const schema = api === null || api === void 0 || (_api$core$sharedState = api.core.sharedState.currentState()) === null || _api$core$sharedState === void 0 ? void 0 : _api$core$sharedState.schema;
    const menuTriggerBy = api === null || api === void 0 || (_api$blockControls = api.blockControls) === null || _api$blockControls === void 0 || (_api$blockControls = _api$blockControls.sharedState.currentState()) === null || _api$blockControls === void 0 ? void 0 : _api$blockControls.menuTriggerBy;
    if (!selection || !schema || !menuTriggerBy) return false;
    return $ec22fae3df16ec92$var$getIsFormatMenuHidden(selection, schema);
};

});


parcelRegister("7taKW", function(module, exports) {
$parcel$export(module.exports, "MenuSection", () => $6f6262c498174cbe$export$4b1545b4f2016d26);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $dlk6h = parcelRequire("dlk6h");
const $6f6262c498174cbe$export$4b1545b4f2016d26 = ({ children: children, title: title, hasSeparator: hasSeparator })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dlk6h.ToolbarDropdownItemSection), {
        title: formatMessage(title),
        hasSeparator: hasSeparator,
        children: children
    });
};

});

parcelRegister("cYzbe", function(module, exports) {
$parcel$export(module.exports, "MoveDownDropdownItem", () => $d27d8cae50a4cd0a$export$bae9e9a61a4ab27d);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $fK3tS = parcelRequire("fK3tS");
var $4vLTk = parcelRequire("4vLTk");

var $c9wRy = parcelRequire("c9wRy");

var $g6Qq4 = parcelRequire("g6Qq4");

var $30Yan = parcelRequire("30Yan");

var $hETL4 = parcelRequire("hETL4");

var $jYhRK = parcelRequire("jYhRK");

var $5beht = parcelRequire("5beht");

var $dbuPt = parcelRequire("dbuPt");

var $gEftm = parcelRequire("gEftm");

var $cm3rY = parcelRequire("cm3rY");

var $91f6Q = parcelRequire("91f6Q");

var $8Sma6 = parcelRequire("8Sma6");
const $d27d8cae50a4cd0a$var$MoveDownDropdownItemContent = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { moveUpRef: moveUpRef, moveDownRef: moveDownRef, getFirstSelectedDomNode: getFirstSelectedDomNode, getMovedBlockDomNode: getMovedBlockDomNode, getSelectedBlockDomNode: getSelectedBlockDomNode, anchorMetricsRef: anchorMetricsRef } = (0, $cm3rY.useBlockMenu)();
    const { canMoveDown: canMoveDown } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'blockControls'
    ], ({ blockControlsState: blockControlsState })=>{
        var _blockControlsState$b;
        return {
            canMoveDown: blockControlsState === null || blockControlsState === void 0 || (_blockControlsState$b = blockControlsState.blockMenuOptions) === null || _blockControlsState$b === void 0 ? void 0 : _blockControlsState$b.canMoveDown
        };
    });
    // Maybe don't need this
    (0, $bSJIT.useEffect)(()=>{
        const doc = (0, $c9wRy.getDocument)();
        if (!canMoveDown && moveDownRef.current && doc && moveDownRef.current === doc.activeElement && moveUpRef.current) moveUpRef.current.focus();
    }, [
        canMoveDown,
        moveUpRef,
        moveDownRef
    ]);
    const handleClick = ()=>{
        const positionSnapshot = (0, $8Sma6.getBlockMenuPositionSnapshot)(getSelectedBlockDomNode(), anchorMetricsRef.current);
        api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
            var _api$analytics, _api$blockControls;
            const payload = {
                action: (0, $g6Qq4.ACTION).CLICKED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).BLOCK_MENU_ITEM,
                attributes: {
                    menuItemName: (0, $91f6Q.BLOCK_MENU_ITEM_NAME).MOVE_DOWN
                },
                eventType: (0, $g6Qq4.EVENT_TYPE).UI
            };
            api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || (_api$analytics = _api$analytics.actions) === null || _api$analytics === void 0 || _api$analytics.attachAnalyticsEvent(payload)(tr);
            api === null || api === void 0 || (_api$blockControls = api.blockControls) === null || _api$blockControls === void 0 || (_api$blockControls = _api$blockControls.commands) === null || _api$blockControls === void 0 || _api$blockControls.moveNodeWithBlockMenu((0, $jYhRK.DIRECTION).DOWN)({
                tr: tr
            });
            return tr;
        });
        (0, $8Sma6.scheduleBlockMenuPositionFix)(positionSnapshot, getMovedBlockDomNode, getFirstSelectedDomNode);
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dbuPt.ToolbarDropdownItem), {
        triggerRef: moveDownRef,
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gEftm))), {
            label: "",
            size: "small"
        }),
        isDisabled: !canMoveDown,
        testId: (0, $30Yan.BLOCK_MENU_ACTION_TEST_ID).MOVE_DOWN,
        children: formatMessage((0, $hETL4.messages).moveDownBlock)
    });
};
const $d27d8cae50a4cd0a$export$bae9e9a61a4ab27d = (0, $fK3tS.default)($d27d8cae50a4cd0a$var$MoveDownDropdownItemContent);

});

parcelRegister("8boLk", function(module, exports) {
$parcel$export(module.exports, "MoveUpDropdownItem", () => $22477966a1e68169$export$bed5c407f49c1363);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $fK3tS = parcelRequire("fK3tS");
var $4vLTk = parcelRequire("4vLTk");

var $c9wRy = parcelRequire("c9wRy");

var $g6Qq4 = parcelRequire("g6Qq4");

var $30Yan = parcelRequire("30Yan");

var $hETL4 = parcelRequire("hETL4");

var $jYhRK = parcelRequire("jYhRK");

var $5beht = parcelRequire("5beht");

var $dbuPt = parcelRequire("dbuPt");

var $6uKO5 = parcelRequire("6uKO5");

var $cm3rY = parcelRequire("cm3rY");

var $91f6Q = parcelRequire("91f6Q");

var $8Sma6 = parcelRequire("8Sma6");
const $22477966a1e68169$var$MoveUpDropdownItemContent = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { moveUpRef: moveUpRef, moveDownRef: moveDownRef, getFirstSelectedDomNode: getFirstSelectedDomNode, getMovedBlockDomNode: getMovedBlockDomNode, getSelectedBlockDomNode: getSelectedBlockDomNode, anchorMetricsRef: anchorMetricsRef } = (0, $cm3rY.useBlockMenu)();
    const { canMoveUp: canMoveUp } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'blockControls'
    ], ({ blockControlsState: blockControlsState })=>{
        var _blockControlsState$b;
        return {
            canMoveUp: blockControlsState === null || blockControlsState === void 0 || (_blockControlsState$b = blockControlsState.blockMenuOptions) === null || _blockControlsState$b === void 0 ? void 0 : _blockControlsState$b.canMoveUp
        };
    });
    (0, $bSJIT.useEffect)(()=>{
        const doc = (0, $c9wRy.getDocument)();
        if (!canMoveUp && moveUpRef.current && doc && moveUpRef.current === doc.activeElement && moveDownRef.current) moveDownRef.current.focus();
    }, [
        canMoveUp,
        moveDownRef,
        moveUpRef
    ]);
    const handleClick = ()=>{
        const positionSnapshot = (0, $8Sma6.getBlockMenuPositionSnapshot)(getSelectedBlockDomNode(), anchorMetricsRef.current);
        api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
            var _api$analytics, _api$blockControls;
            const payload = {
                action: (0, $g6Qq4.ACTION).CLICKED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).BLOCK_MENU_ITEM,
                attributes: {
                    menuItemName: (0, $91f6Q.BLOCK_MENU_ITEM_NAME).MOVE_UP
                },
                eventType: (0, $g6Qq4.EVENT_TYPE).UI
            };
            api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || (_api$analytics = _api$analytics.actions) === null || _api$analytics === void 0 || _api$analytics.attachAnalyticsEvent(payload)(tr);
            api === null || api === void 0 || (_api$blockControls = api.blockControls) === null || _api$blockControls === void 0 || (_api$blockControls = _api$blockControls.commands) === null || _api$blockControls === void 0 || _api$blockControls.moveNodeWithBlockMenu((0, $jYhRK.DIRECTION).UP)({
                tr: tr
            });
            return tr;
        });
        (0, $8Sma6.scheduleBlockMenuPositionFix)(positionSnapshot, getMovedBlockDomNode, getFirstSelectedDomNode);
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dbuPt.ToolbarDropdownItem), {
        triggerRef: moveUpRef,
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6uKO5))), {
            label: "",
            size: "small"
        }),
        isDisabled: !canMoveUp,
        testId: (0, $30Yan.BLOCK_MENU_ACTION_TEST_ID).MOVE_UP,
        children: formatMessage((0, $hETL4.messages).moveUpBlock)
    });
};
const $22477966a1e68169$export$bed5c407f49c1363 = (0, $fK3tS.default)($22477966a1e68169$var$MoveUpDropdownItemContent);

});

parcelRegister("UhNhV", function(module, exports) {
$parcel$export(module.exports, "SuggestedItemsMenuSection", () => $dfd469d75801ff77$export$3ccae8d9afcf2256);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $hETL4 = parcelRequire("hETL4");

var $dlk6h = parcelRequire("dlk6h");

var $kmPiv = parcelRequire("kmPiv");

var $h1PPq = parcelRequire("h1PPq");
const $dfd469d75801ff77$export$3ccae8d9afcf2256 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo(({ api: api, children: children })=>{
    const suggestedItems = (0, $kmPiv.useSuggestedItems)(api);
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    if (suggestedItems.length === 0) return null;
    const hasSeparator = (0, $h1PPq.hasCreateSectionContent)(api) || (0, $h1PPq.hasStructureSectionContent)(api);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dlk6h.ToolbarDropdownItemSection), {
        title: formatMessage((0, $hETL4.messages).suggested),
        hasSeparator: hasSeparator,
        children: children
    });
});

});
parcelRegister("kmPiv", function(module, exports) {
$parcel$export(module.exports, "useSuggestedItems", () => $eb3bc151687f6fdd$export$e7773a638c2f1d4c);

var $bSJIT = parcelRequire("bSJIT");

var $5beht = parcelRequire("5beht");

var $5Ksm0 = parcelRequire("5Ksm0");

var $aVr8t = parcelRequire("aVr8t");
const $eb3bc151687f6fdd$export$e7773a638c2f1d4c = (api)=>{
    var _api$blockMenu;
    const { preservedSelection: preservedSelection, selection: selection } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'blockControls',
        'selection'
    ], (states)=>{
        var _states$blockControls, _states$selectionStat;
        return {
            preservedSelection: (_states$blockControls = states.blockControlsState) === null || _states$blockControls === void 0 ? void 0 : _states$blockControls.preservedSelection,
            selection: (_states$selectionStat = states.selectionState) === null || _states$selectionStat === void 0 ? void 0 : _states$selectionStat.selection
        };
    });
    const blockMenuComponents = api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 ? void 0 : _api$blockMenu.actions.getBlockMenuComponents();
    const menuItemsMap = (0, $bSJIT.useMemo)(()=>{
        return (0, $5Ksm0.createMenuItemsMap)(blockMenuComponents);
    }, [
        blockMenuComponents
    ]);
    const suggestedItems = (0, $bSJIT.useMemo)(()=>{
        const currentSelection = preservedSelection || selection;
        return (0, $aVr8t.getSuggestedItemsFromSelection)(menuItemsMap, currentSelection);
    }, [
        menuItemsMap,
        preservedSelection,
        selection
    ]);
    return suggestedItems;
};

});
parcelRegister("5Ksm0", function(module, exports) {
$parcel$export(module.exports, "createMenuItemsMap", () => $ab73acc7f8f5854c$export$9c09a74c46b5b186);
const $ab73acc7f8f5854c$export$9c09a74c46b5b186 = (blockMenuComponents)=>{
    if (!blockMenuComponents) return new Map();
    return new Map(blockMenuComponents.filter((c)=>c.type === 'block-menu-item').map((item)=>[
            item.key,
            item
        ]));
};

});

parcelRegister("aVr8t", function(module, exports) {
$parcel$export(module.exports, "getSuggestedItemsFromSelection", () => $3dc5e27b0c0556d5$export$199c6fc3d931fd5e);

var $6Cbfp = parcelRequire("6Cbfp");

var $i78ce = parcelRequire("i78ce");

var $fYcWU = parcelRequire("fYcWU");
const $3dc5e27b0c0556d5$export$199c6fc3d931fd5e = (menuItemsMap, currentSelection)=>{
    if (menuItemsMap.size === 0 || !currentSelection) return [];
    const { range: range } = (0, $6Cbfp.expandSelectionToBlockRange)(currentSelection);
    if (!range) return [];
    const blockNodes = (0, $i78ce.getBlockNodesInRange)(range);
    if (blockNodes.length === 0) return [];
    const firstNodeType = blockNodes[0].type.name;
    const allSameType = blockNodes.every((node)=>node.type.name === firstNodeType);
    if (!allSameType) return [];
    const nodeTypeName = firstNodeType;
    const sortedKeys = (0, $fYcWU.getSortedSuggestedItems)(nodeTypeName);
    return sortedKeys.map((key)=>menuItemsMap.get(key)).filter((item)=>{
        var _item$isHidden;
        return item !== undefined && !((_item$isHidden = item.isHidden) !== null && _item$isHidden !== void 0 && _item$isHidden.call(item));
    });
};

});
parcelRegister("fYcWU", function(module, exports) {
$parcel$export(module.exports, "getSortedSuggestedItems", () => $9f912cce0003e5b5$export$5a70f53de53a8267);
/**
 * Suggested transformations mapping for each block type.
 * Based on the Block Menu Compatibility Matrix:
 * https://hello.atlassian.net/wiki/spaces/egcuc/pages/5868774224/Block+Menu+Compatibility+Matrix#Suggested-for-each-block-type
 *
 * This mapping defines which transform items should appear in the TRANSFORM_SUGGESTED_MENU_SECTION
 * for each block type, ranked by priority (lower rank = higher priority).
 *
 * Structure:
 * {
 *   [sourceNodeType]: {
 *     [targetMenuItemKey]: rank
 *   }
 * }
 */ 
var $30Yan = parcelRequire("30Yan");
const $9f912cce0003e5b5$export$3dc4cfed1502c18 = {
    PARAGRAPH: 'paragraph',
    EXPAND: 'expand',
    BLOCKQUOTE: 'blockquote',
    LAYOUT_SECTION: 'layoutSection',
    PANEL: 'panel',
    CODE_BLOCK: 'codeBlock',
    DECISION: 'decisionList',
    BULLET_LIST: 'bulletList',
    ORDERED_LIST: 'orderedList',
    HEADING: 'heading',
    TASK_LIST: 'taskList',
    MEDIA_SINGLE: 'mediaSingle',
    EXTENSION: 'extension',
    BODIED_EXTENSION: 'bodiedExtension',
    BLOCK_CARD: 'blockCard',
    EMBED_CARD: 'embedCard',
    TABLE: 'table'
};
const $9f912cce0003e5b5$export$651a8624ef7a76eb = {
    [$9f912cce0003e5b5$export$3dc4cfed1502c18.PARAGRAPH]: {
        [(0, $30Yan.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]: 100,
        [(0, $30Yan.TRANSFORM_HEADINGS_H1_MENU_ITEM).key]: 200,
        [(0, $30Yan.TRANSFORM_HEADINGS_H2_MENU_ITEM).key]: 300,
        [(0, $30Yan.TRANSFORM_STRUCTURE_STATUS_MENU_ITEM).key]: 400
    },
    [$9f912cce0003e5b5$export$3dc4cfed1502c18.EXPAND]: {
        [(0, $30Yan.TRANSFORM_STRUCTURE_LAYOUT_MENU_ITEM).key]: 100,
        [(0, $30Yan.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]: 200,
        [(0, $30Yan.TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM).key]: 300
    },
    [$9f912cce0003e5b5$export$3dc4cfed1502c18.BLOCKQUOTE]: {
        [(0, $30Yan.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key]: 100,
        [(0, $30Yan.TRANSFORM_STRUCTURE_LAYOUT_MENU_ITEM).key]: 200,
        [(0, $30Yan.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]: 300
    },
    [$9f912cce0003e5b5$export$3dc4cfed1502c18.LAYOUT_SECTION]: {
        [(0, $30Yan.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]: 100,
        [(0, $30Yan.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key]: 200,
        [(0, $30Yan.TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM).key]: 300
    },
    [$9f912cce0003e5b5$export$3dc4cfed1502c18.PANEL]: {
        [(0, $30Yan.TRANSFORM_STRUCTURE_QUOTE_MENU_ITEM).key]: 100,
        [(0, $30Yan.TRANSFORM_STRUCTURE_CODE_BLOCK_MENU_ITEM).key]: 200,
        [(0, $30Yan.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key]: 300
    },
    [$9f912cce0003e5b5$export$3dc4cfed1502c18.CODE_BLOCK]: {
        [(0, $30Yan.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key]: 100,
        [(0, $30Yan.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]: 200,
        [(0, $30Yan.TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM).key]: 300
    },
    [$9f912cce0003e5b5$export$3dc4cfed1502c18.DECISION]: {
        [(0, $30Yan.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]: 100,
        [(0, $30Yan.TRANSFORM_STRUCTURE_QUOTE_MENU_ITEM).key]: 200,
        [(0, $30Yan.TRANSFORM_STRUCTURE_LAYOUT_MENU_ITEM).key]: 300
    },
    [$9f912cce0003e5b5$export$3dc4cfed1502c18.BULLET_LIST]: {
        [(0, $30Yan.TRANSFORM_STRUCTURE_NUMBERED_LIST_MENU_ITEM).key]: 100,
        [(0, $30Yan.TRANSFORM_STRUCTURE_QUOTE_MENU_ITEM).key]: 200,
        [(0, $30Yan.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]: 300
    },
    [$9f912cce0003e5b5$export$3dc4cfed1502c18.ORDERED_LIST]: {
        [(0, $30Yan.TRANSFORM_STRUCTURE_TASK_LIST_MENU_ITEM).key]: 100,
        [(0, $30Yan.TRANSFORM_STRUCTURE_BULLETED_LIST_MENU_ITEM).key]: 200,
        [(0, $30Yan.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]: 300
    },
    [$9f912cce0003e5b5$export$3dc4cfed1502c18.HEADING]: {
        [(0, $30Yan.TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM).key]: 100,
        [(0, $30Yan.TRANSFORM_STRUCTURE_BULLETED_LIST_MENU_ITEM).key]: 200,
        [(0, $30Yan.TRANSFORM_STRUCTURE_QUOTE_MENU_ITEM).key]: 300,
        [(0, $30Yan.TRANSFORM_STRUCTURE_STATUS_MENU_ITEM).key]: 400
    },
    [$9f912cce0003e5b5$export$3dc4cfed1502c18.TASK_LIST]: {
        [(0, $30Yan.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]: 100,
        [(0, $30Yan.TRANSFORM_STRUCTURE_NUMBERED_LIST_MENU_ITEM).key]: 200,
        [(0, $30Yan.TRANSFORM_STRUCTURE_BULLETED_LIST_MENU_ITEM).key]: 300
    },
    [$9f912cce0003e5b5$export$3dc4cfed1502c18.MEDIA_SINGLE]: {
        [(0, $30Yan.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]: 100,
        [(0, $30Yan.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key]: 200,
        [(0, $30Yan.TRANSFORM_STRUCTURE_QUOTE_MENU_ITEM).key]: 300
    },
    [$9f912cce0003e5b5$export$3dc4cfed1502c18.EXTENSION]: {
        [(0, $30Yan.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key]: 100,
        [(0, $30Yan.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]: 200,
        [(0, $30Yan.TRANSFORM_STRUCTURE_LAYOUT_MENU_ITEM).key]: 300
    }
};
const $9f912cce0003e5b5$export$af576b484f6dbef1 = (nodeType)=>{
    return $9f912cce0003e5b5$export$651a8624ef7a76eb[nodeType];
};
const $9f912cce0003e5b5$export$5a70f53de53a8267 = (nodeType)=>{
    const suggestions = $9f912cce0003e5b5$export$af576b484f6dbef1(nodeType);
    if (!suggestions) return [];
    return Object.entries(suggestions).sort(([, rankA], [, rankB])=>rankA - rankB).map(([key])=>key);
};

});



parcelRegister("h1PPq", function(module, exports) {
$parcel$export(module.exports, "hasCreateSectionContent", () => $c64c45e28f248069$export$3cacaf84fd07b7b3);
$parcel$export(module.exports, "hasStructureSectionContent", () => $c64c45e28f248069$export$633de4ec9855cbed);
$parcel$export(module.exports, "hasContentBeforeCreate", () => $c64c45e28f248069$export$8f788dc27a6f5b7d);
$parcel$export(module.exports, "hasContentBeforeStructure", () => $c64c45e28f248069$export$efe26e6796f95688);
$parcel$export(module.exports, "hasContentBeforeTextFormatting", () => $c64c45e28f248069$export$f6df3978f2a2b9db);

var $30Yan = parcelRequire("30Yan");

var $kwsSE = parcelRequire("kwsSE");
/**
 * Checks if a section has any visible content (items that will render)
 */ const $c64c45e28f248069$var$hasSectionContent = (sectionKey, api)=>{
    var _api$blockMenu;
    const blockMenuComponents = api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 ? void 0 : _api$blockMenu.actions.getBlockMenuComponents();
    if (!blockMenuComponents) return false;
    const childrenMap = (0, $kwsSE.buildChildrenMap)(blockMenuComponents);
    const sectionMapKey = (0, $kwsSE.getChildrenMapKey)(sectionKey, 'block-menu-section');
    const sectionChildren = childrenMap.get(sectionMapKey) || [];
    return sectionChildren.some((child)=>(0, $kwsSE.willComponentRender)(child, childrenMap));
};
const $c64c45e28f248069$export$761e0048084c1c43 = (api)=>{
    return $c64c45e28f248069$var$hasSectionContent((0, $30Yan.TRANSFORM_SUGGESTED_MENU_SECTION).key, api);
};
const $c64c45e28f248069$export$3cacaf84fd07b7b3 = (api)=>{
    return $c64c45e28f248069$var$hasSectionContent((0, $30Yan.TRANSFORM_CREATE_MENU_SECTION).key, api);
};
const $c64c45e28f248069$export$633de4ec9855cbed = (api)=>{
    return $c64c45e28f248069$var$hasSectionContent((0, $30Yan.TRANSFORM_STRUCTURE_MENU_SECTION).key, api);
};
const $c64c45e28f248069$export$8f788dc27a6f5b7d = (api)=>{
    return $c64c45e28f248069$export$761e0048084c1c43(api);
};
const $c64c45e28f248069$export$efe26e6796f95688 = (api)=>{
    return $c64c45e28f248069$export$3cacaf84fd07b7b3(api) || $c64c45e28f248069$export$761e0048084c1c43(api);
};
const $c64c45e28f248069$export$f6df3978f2a2b9db = (api)=>{
    return $c64c45e28f248069$export$633de4ec9855cbed(api) || $c64c45e28f248069$export$3cacaf84fd07b7b3(api) || $c64c45e28f248069$export$761e0048084c1c43(api);
};

});


parcelRegister("kNWxR", function(module, exports) {
$parcel$export(module.exports, "SuggestedMenuItems", () => $ffb7e537b78241ac$export$a038b8788149eebb);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $kmPiv = parcelRequire("kmPiv");
const $ffb7e537b78241ac$export$a038b8788149eebb = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo(({ api: api })=>{
    const suggestedItems = (0, $kmPiv.useSuggestedItems)(api);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dc70d.Fragment), {
        children: suggestedItems.map((item)=>{
            const ItemComponent = item.component;
            return ItemComponent ? /*#__PURE__*/ (0, $dc70d.jsx)(ItemComponent, {
                isSuggested: true
            }, item.key) : null;
        })
    });
});

});


parcelRegister("44b4M", function(module, exports) {
$parcel$export(module.exports, "Flag", () => $9c6a1b6ea9a8fd76$export$48ea269755562084);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $hETL4 = parcelRequire("hETL4");

var $5beht = parcelRequire("5beht");

var $eJ0Uu = parcelRequire("eJ0Uu");

var $2bmUD = parcelRequire("2bmUD");

var $lJzMO = parcelRequire("lJzMO");

var $e8iqP = parcelRequire("e8iqP");

var $kyeIc = parcelRequire("kyeIc");

var $aCsiM = parcelRequire("aCsiM");
const $9c6a1b6ea9a8fd76$var$flagMap = {
    [(0, $kyeIc.FLAG_ID).LINK_COPIED_TO_CLIPBOARD]: {
        title: (0, $hETL4.messages).linkCopiedToClipboard,
        autoDismiss: true
    }
};
const $9c6a1b6ea9a8fd76$export$48ea269755562084 = ({ api: api })=>{
    const { showFlag: showFlag } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'blockMenu'
    ], (states)=>{
        var _states$blockMenuStat;
        return {
            showFlag: (_states$blockMenuStat = states.blockMenuState) === null || _states$blockMenuStat === void 0 ? void 0 : _states$blockMenuStat.showFlag
        };
    });
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    if (!showFlag) return;
    const { title: title } = $9c6a1b6ea9a8fd76$var$flagMap[showFlag];
    const onDismissed = ()=>{
        api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $aCsiM.blockMenuPluginKey), {
                showFlag: false
            });
            return tr;
        });
        api === null || api === void 0 || api.core.actions.focus();
    };
    const FlagComponent = $9c6a1b6ea9a8fd76$var$flagMap[showFlag].autoDismiss ? (0, $eJ0Uu.default) : (0, $2bmUD.default);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $lJzMO.FlagGroup), {
        children: /*#__PURE__*/ (0, $dc70d.jsx)(FlagComponent, {
            onDismissed: onDismissed,
            title: formatMessage(title),
            id: showFlag,
            testId: showFlag,
            icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e8iqP))), {
                label: "",
                color: "var(--ds-icon-success, #6A9A23)",
                size: "small"
            })
        })
    });
};

});


parcelRegister("hiMOs", function(module, exports) {
$parcel$export(module.exports, "uiControlRegistryPlugin", () => $6cf7df548692963c$export$eb211d52411e6f09);

var $irVnK = parcelRequire("irVnK");
const $6cf7df548692963c$export$eb211d52411e6f09 = ()=>{
    const registry = (0, $irVnK.createRegistry)();
    return {
        name: 'uiControlRegistry',
        actions: {
            getComponent: registry.getComponent,
            register: registry.register,
            subscribe: registry.subscribe,
            unregister: registry.unregister,
            getComponents: registry.getComponents
        }
    };
};

});
parcelRegister("irVnK", function(module, exports) {
$parcel$export(module.exports, "createRegistry", () => $1aced338d2e2534f$export$b877d3ed23ba6b7a);

var $3y2s4 = parcelRequire("3y2s4");

var $1KaSt = parcelRequire("1KaSt");
const $1aced338d2e2534f$var$getComponentKey = ({ type: type, key: key })=>`${type}:${key}`;
/** Preserves the existing string lookup while the indexed hierarchy rolls out behind experiments. */ const $1aced338d2e2534f$var$getComponentsForSurface = (allComponents, surfaceKey)=>{
    const root = allComponents.find((component)=>component.key === surfaceKey && (!component.parents || component.parents.length === 0));
    if (!root) return [];
    const includedKeys = new Set([
        surfaceKey
    ]);
    let changed = true;
    while(changed){
        changed = false;
        for (const component of allComponents){
            var _component$parents;
            if (includedKeys.has(component.key)) continue;
            if ((_component$parents = component.parents) !== null && _component$parents !== void 0 && _component$parents.some((parent)=>includedKeys.has(parent.key))) {
                includedKeys.add(component.key);
                changed = true;
            }
        }
    }
    return allComponents.filter((component)=>includedKeys.has(component.key));
};
const $1aced338d2e2534f$export$b877d3ed23ba6b7a = ()=>{
    const components = [];
    const registeredComponents = new Map();
    const surfaceCache = new Map();
    const listeners = new Set();
    // Replacement and deduplication are part of the existing slash-command registration contract.
    const supportsMutableRegistration = (0, $3y2s4.isExperimentEnabled)('platform_editor_slash_command');
    // Either registry-backed experience can opt the shared model into indexed, cached surface lookup.
    const supportsOptimizedSurfaceLookup = (0, $3y2s4.isExperimentEnabled)('platform_editor_slash_command') || (0, $3y2s4.isExperimentEnabled)('platform_editor_block_control_migration');
    const updateIndexes = ()=>{
        registeredComponents.clear();
        components.forEach((component)=>{
            registeredComponents.set($1aced338d2e2534f$var$getComponentKey(component), component);
        });
    };
    const invalidateSurfaceCache = ()=>{
        surfaceCache.clear();
    };
    const notifyListeners = ()=>{
        listeners.forEach((listener)=>listener());
    };
    const register = (newComponents, { replaceExisting: replaceExisting = false } = {})=>{
        if (!supportsMutableRegistration) {
            components.push(...newComponents);
            invalidateSurfaceCache();
            if (newComponents.length > 0) notifyListeners();
            return;
        }
        let hasChanged = false;
        const componentKeys = new Set(registeredComponents.keys());
        const componentsToRegister = newComponents.filter((component)=>{
            const componentKey = $1aced338d2e2534f$var$getComponentKey(component);
            if (componentKeys.has(componentKey)) {
                if (replaceExisting) {
                    const index = components.findIndex((existing)=>$1aced338d2e2534f$var$getComponentKey(existing) === componentKey);
                    if (index !== -1) {
                        components[index] = component;
                        hasChanged = true;
                    }
                }
                return false;
            }
            hasChanged = true;
            componentKeys.add(componentKey);
            return true;
        });
        components.push(...componentsToRegister);
        if (hasChanged) {
            updateIndexes();
            invalidateSurfaceCache();
            notifyListeners();
        }
    };
    const resolveSurfaceIdentifier = (surface)=>{
        if (typeof surface !== 'string') return surface;
        const root = components.find((component)=>component.key === surface && (component.type === 'toolbar' || component.type === 'menu') && (!component.parents || component.parents.length === 0));
        return root ? {
            key: root.key,
            type: root.type
        } : undefined;
    };
    const getComponents = (surface)=>{
        if (typeof surface === 'string' && !supportsOptimizedSurfaceLookup) return $1aced338d2e2534f$var$getComponentsForSurface(components, surface);
        const identifier = resolveSurfaceIdentifier(surface);
        if (!identifier) return [];
        const surfaceIdentity = $1aced338d2e2534f$var$getComponentKey(identifier);
        const cached = surfaceCache.get(surfaceIdentity);
        if (cached) return cached;
        const surfaceComponents = (0, $1KaSt.resolveSurface)(components, identifier).components;
        surfaceCache.set(surfaceIdentity, surfaceComponents);
        return surfaceComponents;
    };
    return {
        getComponent: (component)=>registeredComponents.get($1aced338d2e2534f$var$getComponentKey(component)),
        getComponents: getComponents,
        register: register,
        subscribe: (listener)=>{
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
            };
        },
        unregister: (componentsToRemove)=>{
            let hasChanged = false;
            componentsToRemove.forEach((component)=>{
                const componentKey = $1aced338d2e2534f$var$getComponentKey(component);
                const index = components.findIndex((existing)=>$1aced338d2e2534f$var$getComponentKey(existing) === componentKey);
                if (index !== -1) {
                    components.splice(index, 1);
                    hasChanged = true;
                }
            });
            if (hasChanged) {
                if (supportsMutableRegistration) updateIndexes();
                invalidateSurfaceCache();
                notifyListeners();
            }
        },
        components: components
    };
};

});




//# sourceMappingURL=shared.8fe0ce57.js.map
